var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _circle, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFuture4Dark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1921,
    height: 370,
    viewBox: "0 0 1921 370",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_950_20574",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1921,
    height: 370
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1920.86 0.77002H0.859375V369.77H1920.86V0.77002Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_950_20574)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1935.83 -12.0722H-49.7676V369.534H1935.83V-12.0722Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M420.123 325.53L431.84 332.294V318.767L420.123 325.53Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M431.84 318.767V332.294L448.872 342.139V328.612L431.84 318.767Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M448.873 328.612V342.139L489.66 318.591V305.064L448.873 328.612Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M489.66 305.064V318.591L501.377 311.828L489.66 305.064Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M448.873 328.612L489.66 305.064L501.377 311.828L448.873 342.139L420.123 325.53L431.84 318.767L448.873 328.612Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M448.873 328.612V342.139",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M431.84 318.767V332.294",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M489.66 305.064V318.591",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1464.44 240.708L1561.17 129.277",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1518.47 283.926L1636.48 249.054",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1650.62 184.656V209.507L1636.47 217.667L1650.62 184.656Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1650.62 159.082V184.656L1636.47 217.667L1621.92 226.075L1650.62 159.082Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1650.62 157.862V159.082L1621.92 226.075L1606.5 234.969L1635.88 166.362L1650.62 157.862Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1650.62 157.861L1605.88 183.684L1561.17 157.861L1605.88 132.038L1650.62 157.861Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1635.89 166.362L1606.51 234.968L1605.88 235.33V210.831L1621.34 174.77L1635.89 166.362Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1621.34 174.77L1605.88 210.831V183.684L1621.34 174.77Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1605.88 210.831V235.331L1561.17 209.508V157.862L1605.88 183.685V210.831Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1561.17 157.861L1605.88 132.038L1650.62 157.861L1605.88 183.684L1561.17 157.861Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1605.88 183.684V235.33",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1561.17 157.862V209.508L1605.88 235.331L1650.62 209.508V157.862",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1605.88 210.831L1621.34 174.77",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1606.5 234.968L1635.88 166.362",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1621.92 226.075L1650.62 159.082",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1636.47 217.667L1650.62 184.656",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1561.17 188.007C1556.93 176.973 1554.51 165.638 1554.51 155.048C1554.51 122.555 1577.32 109.38 1605.46 125.626C1608.22 127.219 1610.92 129.029 1613.56 131.045",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1635.1 153.724C1648.01 171.853 1656.41 194.16 1656.41 213.892C1656.41 246.385 1633.6 259.561 1605.46 243.314C1595.97 237.833 1587.07 229.694 1579.46 220.076",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1547.36 189.114C1544.92 182.774 1542.95 176.362 1541.5 169.992",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1538.63 143.942C1539.53 102.73 1569.1 86.2973 1605.45 107.291C1618.43 114.778 1630.54 126.04 1640.79 139.35",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1656.75 164.604C1666.45 183.602 1672.3 204.233 1672.3 223.055C1672.3 251.246 1659.21 268.351 1639.67 270.533",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1616.45 266.955C1612.87 265.569 1609.2 263.811 1605.46 261.65C1593 254.452 1581.35 243.79 1571.36 231.173",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1090.91 358.489C1089.81 360.443 1089.12 362.626 1089.12 364.601C1089.12 366.576 1089.83 368.024 1090.96 368.675L1134.16 393.619C1133.02 392.968 1132.32 391.551 1132.32 389.545C1132.32 387.539 1133 385.377 1134.11 383.433C1135.26 381.427 1136.85 379.658 1138.62 378.645C1140.36 377.631 1141.93 377.538 1143.07 378.21L1099.87 353.266C1098.73 352.605 1097.15 352.698 1095.42 353.701C1093.65 354.714 1092.06 356.483 1090.92 358.489H1090.91Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.06 378.19L1099.87 353.256C1098.73 352.594 1097.15 352.687 1095.42 353.69C1093.65 354.704 1092.06 356.472 1090.92 358.478C1089.82 360.433 1089.13 362.615 1089.13 364.59C1089.13 366.566 1089.84 368.013 1090.97 368.665L1134.17 393.609",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1155.76 -31.9173L1165.37 -37.4708C1165.78 -37.7086 1166.32 -37.6776 1166.91 -37.3467L1288.26 32.7179C1289.56 33.4728 1290.62 35.4894 1290.62 37.2371V141.894C1290.62 142.846 1290.3 143.518 1289.8 143.808L1280.21 149.34C1280.66 149.02 1280.94 148.379 1280.94 147.489V42.832C1280.94 41.0842 1279.88 39.0573 1278.58 38.3127L1157.23 -31.7519C1156.67 -32.0725 1156.18 -32.1138 1155.76 -31.9173Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1280.23 149.34L1280.13 149.392C1279.72 149.63 1279.18 149.609 1278.59 149.268L1157.24 79.2136C1155.94 78.4587 1154.88 76.4421 1154.88 74.6943V-29.963C1154.88 -30.9144 1155.21 -31.5866 1155.69 -31.8762C1155.71 -31.8969 1155.74 -31.8969 1155.75 -31.9175C1155.75 -31.9175 1155.75 -31.9175 1155.77 -31.9175C1156.19 -32.1037 1156.68 -32.0727 1157.24 -31.7521L1278.59 38.3125C1279.89 39.0571 1280.95 41.084 1280.95 42.8318V147.489C1280.95 148.378 1280.67 149.02 1280.23 149.34ZM1262.24 78.014C1268.36 74.4771 1268.36 63.029 1262.24 52.4184C1259.12 47.0098 1255 42.8731 1250.91 40.5773C1246.99 38.3849 1243.07 37.8988 1240.08 39.6259C1237.34 41.2081 1235.83 44.3727 1235.54 48.3335V48.3852C1235.19 53.2768 1236.7 59.3784 1240.08 65.2214C1246.2 75.8319 1256.12 81.5508 1262.24 78.0243V78.014ZM1228.27 45.6033C1228.27 35.6133 1221.25 23.4619 1212.59 18.4565C1210.61 17.319 1208.71 16.6468 1206.97 16.4192C1203.45 15.9539 1200.53 17.2466 1198.78 20.0285C1197.59 21.89 1196.92 24.4133 1196.92 27.5055C1196.92 37.4955 1203.95 49.6572 1212.6 54.6419C1221.26 59.6472 1228.28 55.5933 1228.28 45.593L1228.27 45.6033Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1262.24 52.4187C1268.36 63.0292 1268.36 74.4774 1262.24 78.0142C1256.12 81.551 1246.19 75.8218 1240.08 65.2113C1236.7 59.3682 1235.19 53.2667 1235.54 48.3751L1251.17 58.8098L1250.91 40.5775C1255 42.8734 1259.12 47.01 1262.24 52.4187Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1240.07 39.626C1243.06 37.899 1246.98 38.385 1250.9 40.5774L1251.16 58.8097L1235.53 48.375V48.3233C1235.82 44.3625 1237.34 41.1979 1240.07 39.6157V39.626Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1206.97 16.4193L1212.59 36.5545L1196.91 27.5056C1196.91 24.4134 1197.59 21.8901 1198.77 20.0286C1200.53 17.2467 1203.44 15.9436 1206.96 16.4193H1206.97Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1212.59 54.6524C1203.94 49.6677 1196.91 37.5059 1196.91 27.5159L1212.59 36.5648L1206.97 16.4297C1208.71 16.6572 1210.61 17.3294 1212.59 18.467C1221.25 23.4723 1228.27 35.6238 1228.27 45.6138C1228.27 55.6038 1221.25 59.668 1212.59 54.6627V54.6524Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1155.69 -31.876C1155.2 -31.5864 1154.88 -30.9246 1154.88 -29.9628V74.6945C1154.88 76.4319 1155.94 78.4588 1157.24 79.2138L1278.59 149.268C1279.18 149.609 1279.72 149.63 1280.13 149.392",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1280.23 149.341C1280.67 149.02 1280.95 148.379 1280.95 147.489V42.8322C1280.95 41.0845 1279.9 39.0575 1278.59 38.3129L1157.24 -31.7516C1156.69 -32.0722 1156.19 -32.1136 1155.78 -31.9171",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1235.53 48.3337C1235.82 44.3728 1237.34 41.2083 1240.07 39.626C1243.06 37.899 1246.98 38.385 1250.9 40.5774C1254.99 42.8733 1259.11 47.0099 1262.23 52.4186C1268.35 63.0291 1268.35 74.4773 1262.23 78.0141C1256.11 81.551 1246.18 75.8217 1240.07 65.2112C1236.69 59.3682 1235.18 53.2666 1235.53 48.375V48.3233V48.3337Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.91 27.516C1196.91 24.4239 1197.59 21.9005 1198.77 20.039C1200.53 17.2572 1203.44 15.9644 1206.96 16.4298C1208.7 16.6573 1210.6 17.3295 1212.58 18.4671C1221.24 23.4725 1228.26 35.6239 1228.26 45.6139C1228.26 55.6039 1221.24 59.6682 1212.58 54.6628C1203.93 49.6782 1196.9 37.5164 1196.9 27.5264L1196.91 27.516Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1250.9 40.5876L1251.16 58.8199L1235.53 48.3749V48.3335",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1206.97 16.4196L1212.59 36.5548L1196.91 27.5162",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M1176.89 70.6305C1180.57 72.7505 1179.46 60.7646 1185.01 63.9705C1189.65 66.649 1191.29 76.6803 1194.86 78.7383C1202.87 83.3714 1202.29 61.4781 1210.45 66.1939C1214.26 68.3864 1215.94 73.9708 1217.66 79.5967C1219.38 85.2122 1221.14 90.8484 1225.12 93.1339C1228.3 94.9747 1229.23 87.87 1232.55 89.7728C1238.59 93.2683 1239.98 104.241 1245.31 107.312C1251.37 110.818 1252.18 99.9283 1258.22 103.424C1262.54 105.916 1265.63 114.138 1267.37 125.131",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M1155.69 -31.876C1155.69 -31.876 1155.74 -31.8966 1155.75 -31.9173C1155.75 -31.9173 1155.75 -31.9173 1155.77 -31.9173L1165.38 -37.4708C1165.8 -37.7086 1166.33 -37.6776 1166.92 -37.3467L1288.27 32.7179C1289.57 33.4728 1290.63 35.4894 1290.63 37.2371V141.894C1290.63 142.846 1290.31 143.518 1289.81 143.808L1280.13 149.402",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.39 5.59167L1183.69 14.4131",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.39 14.5164L1183.69 23.3378",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.39 23.4416L1183.69 32.2734",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M886.551 81.8085L892.249 78.5199V93.567",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M972.873 31.9725L978.571 28.6735V43.7206",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1001.51 15.4363L1007.22 12.1476V27.1947",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M911.392 74.9936C911.392 70.8362 908.475 69.1505 904.877 71.2292C901.278 73.3079 898.361 78.3546 898.361 82.5119C898.361 86.6693 901.278 88.355 904.877 86.2763C908.475 84.1976 911.392 79.1509 911.392 74.9936Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M929.333 64.6313C929.333 60.4739 926.417 58.7882 922.818 60.8669C919.219 62.9456 916.303 67.9923 916.303 72.1496C916.303 76.307 919.219 77.9927 922.818 75.914C926.417 73.8353 929.333 68.7886 929.333 64.6313Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M969.419 41.4868C969.419 37.3295 966.503 35.6438 962.904 37.7224C959.305 39.8011 956.389 44.8478 956.389 49.0052C956.389 53.1625 959.305 54.8482 962.904 52.7695C966.503 50.6908 969.419 45.6441 969.419 41.4868Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M998.105 24.9296C998.105 20.7723 995.188 19.0866 991.589 21.1653C987.99 23.2439 985.074 28.2906 985.074 32.448C985.074 36.6053 987.99 38.291 991.589 36.2123C995.188 34.1337 998.105 29.0869 998.105 24.9296Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.69 -2.54794C1045.69 -6.70527 1042.77 -8.39096 1039.17 -6.31229C1035.57 -4.23362 1032.66 0.813098 1032.66 4.97043C1032.66 9.12777 1035.57 10.8135 1039.17 8.73479C1042.77 6.65612 1045.69 1.6094 1045.69 -2.54794Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M886.551 139.225L892.249 135.927V150.974",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M944.775 105.605L950.474 102.316V117.363",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M972.873 89.3789L978.571 86.0903V101.137",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M1001.51 72.8424L1007.22 69.5538V84.6008",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.47 54.3931L1039.17 51.1045V66.1516",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M938.476 116.764C938.476 112.606 935.559 110.921 931.961 112.999C928.362 115.078 925.445 120.125 925.445 124.282C925.445 128.439 928.362 130.125 931.961 128.046C935.559 125.968 938.476 120.921 938.476 116.764Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M998.105 82.3362C998.105 78.1789 995.188 76.4932 991.589 78.5719C987.99 80.6505 985.074 85.6973 985.074 89.8546C985.074 94.0119 987.99 95.6976 991.589 93.6189C995.188 91.5403 998.105 86.4936 998.105 82.3362Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M932.996 82.9773L938.694 79.6783V94.7254",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M944.775 76.1727L950.474 72.884V87.9208",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M972.873 59.9467L978.571 56.6581V71.7051",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M984.611 53.1726L990.31 49.884V64.9207",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M929.333 92.6051C929.333 88.4478 926.417 86.7621 922.818 88.8408C919.219 90.9195 916.303 95.9662 916.303 100.124C916.303 104.281 919.219 105.967 922.818 103.888C926.417 101.809 929.333 96.7625 929.333 92.6051Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.69 25.4366C1045.69 21.2792 1042.77 19.5935 1039.17 21.6722C1035.57 23.7509 1032.66 28.7976 1032.66 32.9549C1032.66 37.1123 1035.57 38.7979 1039.17 36.7193C1042.77 34.6406 1045.69 29.5939 1045.69 25.4366Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M932.996 141.118L938.694 137.819V152.866",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M972.873 118.087L978.571 114.798V129.845",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1001.51 101.551L1007.22 98.2624V113.309",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M929.333 150.746C929.333 146.589 926.417 144.903 922.818 146.982C919.219 149.06 916.303 154.107 916.303 158.264C916.303 162.422 919.219 164.107 922.818 162.029C926.417 159.95 929.333 154.903 929.333 150.746Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M998.105 111.044C998.105 106.887 995.188 105.201 991.589 107.28C987.99 109.359 985.074 114.405 985.074 118.563C985.074 122.72 987.99 124.406 991.589 122.327C995.188 120.248 998.105 115.202 998.105 111.044Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1026.43 94.6942C1026.43 90.5369 1023.52 88.8512 1019.92 90.9298C1016.32 93.0085 1013.4 98.0552 1013.4 102.213C1013.4 106.37 1016.32 108.056 1019.92 105.977C1023.52 103.898 1026.43 98.8515 1026.43 94.6942Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M933.648 62.6975L950.94 52.7178",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.38 17.8252L1027.88 8.29022",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M898.229 140.559L919.873 128.067",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M957.113 106.567L974.508 96.5248",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.39 74.6522L1033.27 62.5939",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M1044.6 56.0476L1056.17 49.3669",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M882.662 120.114L910.853 103.836",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M955.293 78.1893L972.915 68.0131",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M999.875 52.4385L1028.38 35.9849",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M882.662 178.255L908.775 163.177",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M945.684 141.863L971.3 127.074",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M1032.13 91.9644L1056.17 78.0756",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M864.006 -31.4938V27.743C864.006 30.1733 862.393 32.5829 859.197 34.434C852.796 38.126 842.423 38.126 836.001 34.434C832.795 32.5829 831.213 30.1733 831.213 27.743V-31.618C831.213 -29.1877 832.806 -26.7781 836.001 -24.9269C842.423 -21.235 852.796 -21.235 859.197 -24.9269C862.352 -26.7367 863.954 -29.1153 864.006 -31.5042V-31.4938Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M864.006 -31.6072V27.7538C864.006 30.1841 862.393 32.5937 859.197 34.4448C852.796 38.1368 842.423 38.1368 836.001 34.4448C832.795 32.5937 831.213 30.1841 831.213 27.7538V-31.6072",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M194.335 246.748C194.335 249.975 195.462 252.239 197.292 253.305L263.137 291.32C261.307 290.266 260.169 288.001 260.18 284.774C260.18 281.599 261.276 278.083 263.055 274.95C264.895 271.723 267.46 268.889 270.294 267.245C273.086 265.632 275.62 265.477 277.44 266.542L211.595 228.526C209.764 227.471 207.231 227.616 204.438 229.229C201.605 230.863 199.03 233.697 197.199 236.923C195.42 240.057 194.324 243.573 194.324 246.748H194.335Z",
    fill: "black"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M260.18 284.764C260.18 287.99 261.307 290.255 263.137 291.31C264.968 292.365 267.502 292.21 270.294 290.596C273.086 288.983 275.62 286.222 277.45 283.047C279.281 279.872 280.418 276.304 280.418 273.078C280.418 269.851 279.281 267.586 277.45 266.531C275.62 265.466 273.096 265.621 270.304 267.235C267.471 268.869 264.906 271.702 263.065 274.939C261.286 278.073 260.19 281.589 260.19 284.764H260.18Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M277.45 266.542C275.619 265.487 273.096 265.632 270.304 267.245C267.47 268.879 264.905 271.713 263.064 274.95C261.286 278.083 260.189 281.599 260.189 284.774C260.189 288.001 261.317 290.266 263.147 291.321C264.978 292.375 267.511 292.22 270.304 290.607C273.096 288.994 275.629 286.233 277.46 283.058C279.29 279.883 280.428 276.315 280.428 273.088C280.428 269.862 279.29 267.597 277.46 266.542H277.45Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M277.45 266.542L211.604 228.526C209.774 227.471 207.24 227.616 204.448 229.229C201.614 230.863 199.039 233.697 197.209 236.923C195.43 240.057 194.334 243.573 194.334 246.748C194.334 249.975 195.461 252.239 197.292 253.305L263.137 291.32",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M239.01 288.735C237.18 287.669 234.656 287.824 231.864 289.438C229.031 291.072 226.466 293.905 224.625 297.142C222.846 300.276 221.75 303.792 221.75 306.967C221.75 310.193 222.877 312.458 224.708 313.513C226.538 314.568 229.072 314.413 231.864 312.8C234.656 311.186 237.19 308.425 239.021 305.25C240.851 302.075 241.989 298.507 241.989 295.281C241.989 292.054 240.851 289.789 239.021 288.735H239.01Z",
    fill: "black"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M239.01 288.734L173.165 250.719C171.335 249.664 168.801 249.808 166.009 251.422C163.175 253.056 160.6 255.889 158.77 259.116C156.991 262.249 155.895 265.766 155.895 268.941C155.895 272.167 157.022 274.432 158.852 275.497L224.697 313.513C222.867 312.458 221.729 310.193 221.74 306.967C221.74 303.792 222.836 300.276 224.615 297.142C226.455 293.916 229.02 291.082 231.854 289.438C234.646 287.824 237.18 287.669 239 288.734H239.01Z",
    fill: "black"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M239.01 288.735C237.18 287.68 234.656 287.825 231.864 289.438C229.031 291.072 226.466 293.905 224.625 297.142C222.846 300.276 221.75 303.792 221.75 306.967C221.75 310.194 222.877 312.458 224.708 313.513C226.538 314.568 229.072 314.413 231.864 312.8C234.656 311.186 237.19 308.425 239.021 305.25C240.851 302.075 241.989 298.508 241.989 295.281C241.989 292.054 240.851 289.789 239.021 288.735H239.01Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M239.01 288.734L173.165 250.719C171.335 249.664 168.801 249.808 166.009 251.422C163.175 253.056 160.6 255.889 158.77 259.116C156.991 262.249 155.895 265.766 155.895 268.94C155.895 272.167 157.022 274.432 158.852 275.497L224.697 313.513",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M115.914 144.272C117.289 139.029 120.94 133.217 125.821 130.756L138.118 137.86C139.565 138.76 141.489 138.708 143.599 137.498L166.847 124.075C167.85 123.496 168.812 122.7 169.701 121.748C177.312 123.63 183.445 127.808 187.096 132.762C187.964 133.941 188.688 135.161 189.267 136.392C194.831 148.368 193.125 180.24 193.125 180.24L129.089 207.511V166.341C131.468 163.952 132.802 160.653 132.802 157.013C132.802 149.702 126.866 143.766 119.554 143.766C118.293 143.766 117.072 143.941 115.924 144.272H115.914Z",
    fill: "black"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M115.913 144.272C117.071 143.941 118.291 143.766 119.543 143.766C126.864 143.766 132.79 149.702 132.79 157.013C132.79 160.653 131.456 163.952 129.078 166.341C126.678 168.761 123.214 170.261 119.543 170.261C116.109 170.261 113.131 168.958 110.773 166.817C108.115 164.397 106.295 160.902 106.295 157.013C106.295 150.963 110.359 145.855 115.902 144.283L115.913 144.272Z",
    fill: "#459AA4"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M172.12 85.5939C170.693 84.8286 168.863 84.9424 166.856 86.0903L143.608 99.5241C139.068 102.14 135.397 109.162 135.397 115.192V131.283C135.397 134.51 136.442 136.806 138.117 137.85L120.898 127.912C119.161 126.909 118.064 124.582 118.064 121.273V105.181C118.064 99.1414 121.736 92.1194 126.265 89.5133L149.524 76.0899C151.571 74.9006 153.453 74.8179 154.891 75.6556L172.12 85.6042V85.5939Z",
    fill: "black"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M190.911 123.454C190.911 127.074 189.463 130.352 187.106 132.741C183.455 127.787 177.333 123.609 169.711 121.727C172.379 118.863 174.385 114.602 174.923 110.486C175.802 110.3 176.723 110.207 177.653 110.207C184.975 110.207 190.901 116.143 190.901 123.454H190.911Z",
    fill: "#459AA4"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M172.121 85.5938L172.235 85.6558C173.972 86.659 175.068 88.9858 175.068 92.2952V108.387C175.068 109.08 175.017 109.793 174.924 110.496C174.386 114.612 172.38 118.883 169.711 121.738C168.822 122.689 167.871 123.486 166.857 124.065L143.609 137.488C141.499 138.708 139.576 138.76 138.128 137.85C136.463 136.806 135.408 134.51 135.408 131.283V115.192C135.408 109.152 139.079 102.13 143.619 99.524L166.867 86.0902C168.863 84.9423 170.704 84.8388 172.131 85.5938H172.121Z",
    fill: "black"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M129.088 210.169C129.119 215.226 125.179 219.363 120.122 219.373C120.101 219.373 120.091 219.373 120.07 219.373C115.034 219.373 110.804 215.298 110.783 210.262V166.807C113.131 168.947 116.119 170.25 119.553 170.25C123.235 170.25 126.689 168.751 129.088 166.331V210.169Z",
    fill: "black"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M138.114 137.85C136.449 136.806 135.395 134.51 135.395 131.283V115.192C135.395 109.152 139.066 102.13 143.606 99.524L166.854 86.0902C168.85 84.9423 170.691 84.8388 172.118 85.5938",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M172.232 85.6559C173.969 86.6591 175.065 88.9859 175.065 92.2953V108.387C175.065 109.08 175.014 109.793 174.921 110.497C174.393 114.613 172.376 118.884 169.708 121.738C168.819 122.689 167.868 123.486 166.854 124.065L143.606 137.488C141.496 138.709 139.573 138.76 138.125 137.85",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M138.238 137.923L138.125 137.85L120.906 127.912C119.168 126.909 118.072 124.582 118.072 121.273V105.181C118.072 99.1414 121.744 92.1194 126.273 89.5133L149.532 76.0899C151.579 74.9006 153.461 74.8179 154.899 75.6556L172.242 85.6663",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M161.043 104.571V109.349",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M151.322 110.187V114.954",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M129.087 166.331C131.455 163.942 132.799 160.643 132.799 157.003C132.799 149.692 126.863 143.755 119.552 143.755C118.29 143.755 117.07 143.931 115.922 144.262C110.379 145.844 106.314 150.943 106.314 156.993C106.314 160.881 108.124 164.377 110.792 166.797C113.14 168.937 116.129 170.24 119.562 170.24C123.244 170.24 126.698 168.741 129.097 166.321L129.087 166.331Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M125.819 130.746C120.949 133.207 117.298 139.019 115.912 144.262",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M129.088 207.501L193.123 180.23C193.123 180.23 194.84 148.357 189.266 136.382C188.687 135.141 187.963 133.92 187.094 132.752C183.444 127.798 177.321 123.62 169.699 121.738",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M187.104 132.741C189.451 130.352 190.909 127.074 190.909 123.454C190.909 116.143 184.973 110.207 177.662 110.207C176.721 110.207 175.811 110.31 174.932 110.486",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M129.088 166.331V210.169C129.119 215.226 125.179 219.363 120.122 219.373C120.101 219.373 120.091 219.373 120.07 219.373C115.034 219.373 110.804 215.298 110.783 210.262V166.807",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M345.095 32.0452V114.933L292.404 84.5083V1.62012L345.095 32.0452Z",
    fill: "black"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M345.095 114.933L292.404 84.508V1.61987L345.095 32.045V114.933Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M306.066 26.3984L331.434 41.0421",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M306.066 36.4921L315.146 41.7353",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M325.166 47.5265L331.433 51.1357",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M306.066 46.5959L331.434 61.2396",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M306.066 56.6891L312.871 60.6189",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M320.709 65.1381L331.433 71.3327",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M306.066 66.7928L331.434 81.4366",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M306.066 76.886L319.81 84.8284",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M327.844 89.4616L331.432 91.5299",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M788.646 326.637V326.668L716.916 367.486C714.279 365.655 712.211 361.891 712.211 358.758C712.211 355.624 714.269 354.249 716.916 355.469L783.672 316.905L783.899 317.298C783.878 317.495 783.868 317.701 783.868 317.919C783.868 321.052 785.967 324.816 788.646 326.647V326.637Z",
    fill: "black"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M787.664 314.588V314.619C787.664 314.619 787.653 314.619 787.633 314.609L787.664 314.588Z",
    fill: "black"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M787.665 314.589L716.907 355.469V355.438L670.68 328.746C669.274 327.929 668.002 327.836 667.061 328.333L737.746 287.524C738.687 286.976 740 287.059 741.448 287.897L787.675 314.589H787.665ZM765.606 313.72C765.74 313.647 765.761 313.523 765.637 313.451L738.831 297.97C738.707 297.897 738.5 297.907 738.366 297.99L726.484 304.857C726.339 304.929 726.328 305.054 726.453 305.126L753.258 320.607C753.372 320.68 753.589 320.669 753.723 320.587L765.606 313.72Z",
    fill: "black"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M765.638 313.451C765.751 313.523 765.741 313.637 765.607 313.72L753.724 320.586C753.579 320.669 753.372 320.679 753.259 320.607L726.453 305.126C726.329 305.053 726.339 304.94 726.484 304.857L738.367 297.99C738.501 297.918 738.708 297.907 738.832 297.969L765.638 313.451Z",
    fill: "black"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M716.905 367.486V367.517L688.507 351.125L693.513 348.23L682.044 341.611L677.038 344.496L670.668 340.825C667.783 339.16 665.445 335.106 665.445 331.766C665.445 330.101 666.024 328.932 666.976 328.374L667.048 328.332C667.989 327.836 669.272 327.929 670.668 328.746L716.895 355.438V355.469C714.258 354.249 712.189 355.634 712.189 358.758C712.189 361.881 714.247 365.655 716.895 367.486H716.905Z",
    fill: "black"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M693.524 348.23L675.416 358.675L672.458 353.711L663.957 352.056L682.055 341.611L693.524 348.23Z",
    fill: "black"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M688.519 351.125L716.917 367.517V367.486C714.28 365.655 712.212 361.891 712.212 358.758C712.212 355.624 714.27 354.249 716.917 355.469V355.438L670.69 328.746C669.283 327.929 668.011 327.836 667.07 328.332",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M677.038 344.497L670.668 340.825C667.783 339.16 665.445 335.106 665.445 331.766C665.445 330.101 666.024 328.932 666.976 328.374L737.723 287.524C738.664 286.976 739.977 287.059 741.425 287.897L787.652 314.589V314.62C787.652 314.62 787.642 314.62 787.621 314.609",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M716.906 355.469L787.664 314.588",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M716.906 367.486L788.636 326.668V326.637C785.957 324.806 783.858 321.042 783.858 317.908C783.858 317.691 783.868 317.484 783.889 317.288",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M753.259 320.597L726.453 305.116C726.329 305.043 726.339 304.929 726.484 304.847L738.367 297.98C738.501 297.907 738.708 297.897 738.832 297.959L765.638 313.441C765.751 313.513 765.741 313.627 765.607 313.709L753.724 320.576C753.579 320.659 753.372 320.669 753.259 320.597Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M688.518 351.126L675.416 358.675L672.458 353.711L663.957 352.056L682.055 341.611L693.524 348.23L688.518 351.126Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.3 142.194C1167.09 137.664 1171.97 135.854 1175.66 134.417C1176.99 133.9 1178.17 133.435 1178.94 132.907C1182.42 130.249 1184.02 129.205 1185.14 128.595C1183.54 126.04 1182.06 123.713 1180.69 121.583C1178.88 119.029 1191.43 109.98 1194.88 114.675C1198.16 120.745 1200.35 126.195 1200.33 129.691C1200.3 134.076 1196.8 136.775 1193.22 138.688C1189.92 140.446 1185.94 142.349 1182.36 143.931C1179.96 145.131 1178.8 147.096 1177.61 148.606C1176.67 149.826 1175.71 150.746 1174.11 150.746C1171.52 150.746 1166.19 144.335 1166.19 143.528C1166.19 143.063 1166.23 142.618 1166.3 142.204V142.194Z",
    fill: "black"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.69 112.658C1174.96 120.042 1175.42 129.66 1175.66 134.427C1171.97 135.865 1167.1 137.675 1166.3 142.204C1164.66 142.411 1163 142.504 1161.34 142.515C1150.94 142.515 1142 137.478 1133.98 130.291C1134.03 129.939 1134.34 127.209 1134.34 127.209C1134.6 124.975 1134.72 122.907 1134.72 120.963C1134.72 120.89 1134.72 120.807 1134.72 120.735C1134.69 108.46 1129.81 100.972 1127.15 88.5623C1125.33 89.2965 1123.6 90.6306 1121.99 92.0991C1117.24 95.3981 1110.54 86.6491 1112.35 81.1163C1128.21 62.3256 1134.75 64.2077 1143.94 67.5377C1140.9 72.2949 1149.33 76.4005 1158.25 74.5494C1158.87 74.4253 1159.51 74.4563 1160.11 74.6631C1160.26 74.7045 1160.41 74.7665 1160.56 74.8389C1162.29 75.6663 1164 76.535 1165.68 77.3933C1167.5 78.3344 1169.18 79.5444 1170.65 80.9612V80.9405C1176.51 86.6491 1188.04 101.996 1194.89 114.665C1191.44 109.969 1178.89 119.029 1180.7 121.573C1178.43 118.067 1176.45 115.109 1174.7 112.638L1174.69 112.658Z",
    fill: "#FBB93E"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M1186.91 262.095C1188.73 262.095 1190.75 262.736 1190.75 264.556C1190.75 267.007 1187.55 268.765 1185.46 269.779C1178.46 273.988 1169.47 279.19 1164.99 279.19C1163.93 279.159 1162.9 278.869 1161.98 278.342C1161.28 277.959 1160.69 277.401 1160.27 276.718C1170.78 279.117 1175.46 268.889 1175.63 262.881H1175.64C1176.67 263.377 1177.79 263.626 1178.93 263.626C1181.59 263.626 1184.14 262.116 1186.91 262.116V262.095Z",
    fill: "black"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M1160.27 276.707C1159.94 276.635 1159.6 276.542 1159.26 276.439C1157.98 276.066 1157.09 274.918 1157.05 273.584C1156.81 266.107 1156.28 258.858 1155.71 252.384C1155.51 249.985 1155.28 247.689 1155.07 245.527C1154.25 237.296 1153.51 230.977 1153.51 228.06C1153.51 217.14 1155.26 203.882 1154.3 187.666H1154.27C1151.46 196.612 1149.37 204.999 1147.84 212.29C1146.49 218.608 1145.85 225.061 1145.92 231.525C1146.01 239.219 1146.64 244.721 1146.64 244.721C1146.65 244.886 1146.66 245.062 1146.67 245.228C1147.09 254.318 1140.49 261.795 1130.98 259.644C1130.61 259.561 1130.25 259.468 1129.88 259.365C1128.89 259.075 1128.27 258.093 1128.43 257.079C1129.86 248.206 1130.13 240.657 1128.11 220.201C1127.58 203.375 1133.96 193.478 1133.96 177.666C1133.96 159.982 1135.21 156.496 1133.89 150.726C1132.8 145.865 1132.89 140.87 1133.37 135.71C1133.55 133.931 1133.76 132.121 1133.99 130.291C1142 137.478 1150.95 142.515 1161.34 142.515C1162.99 142.515 1164.66 142.411 1166.3 142.204C1166.23 142.618 1166.19 143.063 1166.19 143.528C1166.19 144.335 1171.53 150.746 1174.11 150.746C1175.71 150.746 1176.67 149.826 1177.61 148.606C1183.7 180.292 1167.92 233.717 1175.21 259.944C1175.51 260.678 1175.65 261.691 1175.62 262.87C1175.46 268.889 1170.77 279.138 1160.26 276.707H1160.27Z",
    fill: "#459AA4"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M1161.84 31.3215C1170.19 38.7881 1166.69 42.5628 1163.05 45.655C1160.8 47.5578 1158.51 49.2022 1158.91 51.3015C1154.77 48.4679 1152.81 54.3419 1157.38 56.4516C1155.21 62.5325 1149.94 68.3962 1145.05 65.2937C1144.97 65.242 1144.89 65.1903 1144.81 65.1386C1140.47 62.1085 1138.07 52.9872 1138.73 46.503C1139.56 39.0363 1150.87 36.999 1155.37 35.1169C1158.14 33.7414 1158.9 31.6731 1159.37 31.2388C1160.07 30.5769 1161.16 30.6183 1161.83 31.3215H1161.84Z",
    fill: "black"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.83 73.5363C1159.28 73.9189 1159.71 74.2809 1160.1 74.6325V74.6635C1159.49 74.4567 1158.85 74.4256 1158.24 74.5497C1149.33 76.3906 1140.89 72.2849 1143.94 67.5381C1144.26 66.9487 1144.65 66.173 1145.05 65.2837C1149.94 68.3655 1155.21 62.5224 1157.38 56.4416C1152.81 54.3319 1154.76 48.4578 1158.91 51.2914C1158.52 49.1921 1160.81 47.5478 1163.05 45.6449C1163.62 47.9304 1163.88 51.0329 1164.02 55.4074C1164.02 66.1317 1157.14 61.9537 1157.2 67.9001C1157.38 69.2548 1156.64 71.7161 1158.83 73.5466V73.5363Z",
    fill: "black"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M1155.06 245.528C1155.27 247.689 1155.49 249.975 1155.7 252.384C1154.01 252.87 1152.38 253.563 1150.84 254.432C1145.15 257.834 1140.49 262.995 1135.73 262.995C1135.03 262.995 1134.33 262.871 1133.66 262.654C1132.31 262.188 1131.28 261.051 1130.97 259.655C1140.51 261.733 1147.13 254.329 1146.67 245.238H1146.7C1147.86 245.652 1149.08 245.849 1150.31 245.797C1151.83 245.797 1153.5 245.631 1155.06 245.528Z",
    fill: "black"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.71 245.238H1146.67C1146.67 245.073 1146.66 244.897 1146.64 244.731C1146.64 244.731 1146.01 239.219 1145.92 231.535C1145.85 225.072 1146.49 218.619 1147.84 212.3C1149.37 204.999 1151.46 196.622 1154.27 187.677H1154.3C1155.26 203.892 1153.51 217.15 1153.51 228.071C1153.51 230.987 1154.26 237.306 1155.07 245.538C1153.51 245.641 1151.85 245.807 1150.33 245.807C1149.09 245.859 1147.86 245.662 1146.72 245.249L1146.71 245.238Z",
    fill: "black"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.72 120.963C1134.72 122.907 1134.59 124.975 1134.34 127.209C1134.34 127.209 1133.55 133.931 1133.37 135.71H1133.26C1131.85 135.079 1130.51 134.355 1129.23 133.538C1128.19 132.887 1127.61 131.708 1127.72 130.487C1127.82 129.267 1127.98 128.026 1128.14 126.94C1120.77 121.873 1115.12 114.003 1107.83 105.306C1102.36 99.2453 1104.15 92.1096 1106.21 88.8106C1108.41 85.9253 1110.44 83.3709 1112.35 81.1165C1110.55 86.6492 1117.24 95.3982 1121.99 92.0993C1120.76 93.2058 1119.61 94.3641 1118.53 95.3879C1118.29 95.6258 1118.12 95.9257 1118.05 96.2566C1118.22 99.6693 1125.68 112.71 1134.58 120.746H1134.72V120.973V120.963Z",
    fill: "black"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M1130.96 259.634C1130.96 259.634 1130.96 259.644 1130.96 259.654C1131.28 261.061 1132.3 262.188 1133.65 262.653C1134.33 262.881 1135.02 262.995 1135.72 262.995C1140.48 262.995 1145.14 257.834 1150.83 254.432C1152.36 253.563 1154 252.87 1155.69 252.384C1155.69 252.384 1155.7 252.384 1155.71 252.384",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.69 112.658C1174.96 120.042 1175.43 129.66 1175.66 134.428",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M1177.62 148.595C1183.71 180.282 1167.93 233.707 1175.22 259.933C1175.52 260.668 1175.66 261.681 1175.63 262.86C1175.46 268.879 1170.78 279.128 1160.27 276.697C1159.94 276.625 1159.6 276.532 1159.26 276.428C1157.98 276.056 1157.09 274.908 1157.05 273.574C1156.81 266.097 1156.27 258.858 1155.71 252.374C1155.51 249.974 1155.29 247.679 1155.07 245.517C1154.27 237.285 1153.51 230.967 1153.51 228.05C1153.51 217.129 1155.25 203.871 1154.3 187.656C1154 182.464 1153.41 176.973 1152.4 171.151C1150.45 159.713 1145.05 162.67 1144.66 144.635",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M1175.64 262.86C1176.67 263.357 1177.79 263.605 1178.93 263.605C1181.59 263.605 1184.14 262.095 1186.91 262.095C1188.73 262.095 1190.75 262.736 1190.75 264.556C1190.75 267.007 1187.56 268.765 1185.46 269.779C1178.47 273.988 1169.47 279.19 1164.99 279.19C1163.94 279.159 1162.9 278.869 1161.98 278.342C1161.28 277.959 1160.69 277.401 1160.27 276.718C1160.27 276.718 1160.27 276.708 1160.26 276.697",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M1146.71 245.238C1147.86 245.652 1149.08 245.849 1150.31 245.797C1151.83 245.797 1153.5 245.631 1155.06 245.528H1155.07",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M1133.99 130.281C1142 137.468 1150.95 142.504 1161.34 142.504C1162.99 142.504 1164.66 142.401 1166.3 142.194H1166.31",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.59 120.735C1125.68 112.71 1118.23 99.6695 1118.05 96.2465C1118.12 95.9155 1118.29 95.6156 1118.54 95.3778C1119.61 94.3539 1120.77 93.1957 1121.99 92.0995C1123.6 90.6413 1125.33 89.2969 1127.15 88.5626C1129.81 100.962 1134.69 108.45 1134.72 120.735C1134.72 120.808 1134.72 120.88 1134.72 120.963C1134.72 122.907 1134.6 124.975 1134.34 127.209C1134.34 127.209 1133.54 133.931 1133.38 135.71C1132.88 140.871 1132.79 145.866 1133.89 150.726C1135.21 156.507 1133.97 159.982 1133.97 177.666C1133.97 193.468 1127.59 203.375 1128.11 220.201C1130.13 240.657 1129.87 248.206 1128.43 257.079C1128.27 258.103 1128.88 259.086 1129.88 259.365C1130.25 259.468 1130.62 259.561 1130.98 259.644C1140.49 261.795 1147.09 254.318 1146.68 245.228C1146.68 245.062 1146.67 244.887 1146.65 244.721C1146.65 244.721 1146.01 239.209 1145.92 231.525C1145.85 225.062 1146.49 218.609 1147.85 212.29C1149.38 204.989 1151.46 196.612 1154.27 187.666",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M1167.92 104.106C1169.56 105.74 1171.77 108.491 1174.69 112.648C1176.43 115.12 1178.41 118.078 1180.69 121.583C1182.06 123.714 1183.54 126.041 1185.14 128.595C1184.02 129.205 1182.42 130.239 1178.94 132.907C1178.17 133.435 1176.99 133.911 1175.66 134.417C1171.97 135.855 1167.08 137.665 1166.3 142.194C1166.23 142.608 1166.19 143.053 1166.19 143.518C1166.19 144.325 1171.53 150.736 1174.11 150.736C1175.71 150.736 1176.66 149.806 1177.61 148.596C1178.79 147.086 1179.96 145.131 1182.36 143.921C1185.93 142.339 1189.91 140.446 1193.22 138.678C1196.81 136.765 1200.31 134.066 1200.33 129.681C1200.35 126.185 1198.16 120.735 1194.88 114.665C1188.04 101.996 1176.5 86.6493 1170.66 80.9407",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M1180.69 121.583C1178.88 119.029 1191.43 109.98 1194.88 114.675C1194.89 114.685 1194.9 114.706 1194.91 114.716",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.93 67.5379C1144.25 66.9484 1144.65 66.1728 1145.05 65.2834",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.05 45.655C1163.62 47.9405 1163.88 51.0429 1164.02 55.4175C1164.02 66.1417 1157.14 61.9637 1157.2 67.9101C1157.38 69.2649 1156.65 71.7262 1158.83 73.5567C1159.28 73.9393 1159.71 74.3013 1160.1 74.6529",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.05 45.655C1166.69 42.5628 1170.19 38.7881 1161.84 31.3215C1161.17 30.6183 1160.08 30.5769 1159.38 31.2388C1158.91 31.6731 1158.14 33.7414 1155.38 35.1169C1150.88 36.999 1139.56 39.0363 1138.74 46.503C1138.08 52.9872 1140.48 62.0982 1144.82 65.1386C1144.91 65.1903 1144.99 65.2524 1145.06 65.2937C1149.95 68.3859 1155.22 62.5325 1157.39 56.4516C1152.82 54.3419 1154.77 48.4679 1158.92 51.3015C1158.53 49.2022 1160.82 47.5578 1163.06 45.655H1163.05Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M1112.34 81.1165C1110.54 86.6492 1117.23 95.3982 1121.98 92.0889",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M1171.12 81.4682C1170.96 81.3028 1170.8 81.1373 1170.63 80.9718C1169.15 79.555 1167.48 78.3451 1165.66 77.404C1163.98 76.5456 1162.27 75.6769 1160.54 74.8496C1160.4 74.7772 1160.24 74.7152 1160.09 74.6738C1159.49 74.467 1158.85 74.4359 1158.23 74.56C1149.32 76.4009 1140.88 72.2952 1143.92 67.5484C1134.72 64.2288 1128.2 62.3466 1112.33 81.127C1110.43 83.3814 1108.39 85.9358 1106.19 88.8211C1104.13 92.1201 1102.34 99.2558 1107.81 105.316C1115.11 114.003 1120.75 121.873 1128.12 126.951C1127.96 128.037 1127.8 129.278 1127.7 130.498C1127.59 131.718 1128.17 132.897 1129.21 133.549C1130.5 134.376 1131.85 135.09 1133.24 135.71",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M1101.22 245.993V392.762L1063.76 414.386V400.311L986.421 444.956V459.02L936.471 487.853V341.105L1101.22 245.993Z",
    fill: "black"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M1101.22 245.993L936.47 341.105L771.738 245.993L936.47 150.892L1101.22 245.993Z",
    fill: "black"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M936.471 341.105V487.853L886.511 459.02V444.956L809.176 400.311V414.386L771.719 392.762V245.993H771.739L936.471 341.105Z",
    fill: "black"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M771.738 245.993L936.47 150.892L1101.22 245.993L936.47 341.105L771.738 245.993Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M936.471 341.105V487.853",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M771.719 245.993V392.762L809.176 414.386V400.311L886.511 444.956V459.02L936.471 487.853L986.421 459.02V444.956L1063.76 400.311V414.386L1101.22 392.762V245.993",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M258.815 377.787L237.997 389.814L217.18 377.776L237.997 365.759L258.815 377.787Z",
    fill: "black"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M237.997 389.814L217.18 377.797L237.997 365.759L258.815 377.787",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.85 251.37L1363.35 242.425",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M1363.35 251.37L1347.85 242.425",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M595.766 198.008L611.268 189.062",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M611.268 198.008L595.766 189.062",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M1450.05 198.421C1453.94 198.421 1457.09 195.268 1457.09 191.379C1457.09 187.489 1453.94 184.336 1450.05 184.336C1446.16 184.336 1443 187.489 1443 191.379C1443 195.268 1446.16 198.421 1450.05 198.421Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M1753.55 174.139C1757.44 174.139 1760.6 170.986 1760.6 167.096C1760.6 163.207 1757.44 160.054 1753.55 160.054C1749.66 160.054 1746.51 163.207 1746.51 167.096C1746.51 170.986 1749.66 174.139 1753.55 174.139Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M1918.88 36.8126C1922.77 36.8126 1925.93 33.6595 1925.93 29.77C1925.93 25.8804 1922.77 22.7273 1918.88 22.7273C1914.99 22.7273 1911.84 25.8804 1911.84 29.77C1911.84 33.6595 1914.99 36.8126 1918.88 36.8126Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M448.769 283.243C452.659 283.243 455.812 280.09 455.812 276.201C455.812 272.311 452.659 269.158 448.769 269.158C444.88 269.158 441.727 272.311 441.727 276.201C441.727 280.09 444.88 283.243 448.769 283.243Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M665.127 291.858C669.016 291.858 672.169 288.705 672.169 284.815C672.169 280.926 669.016 277.773 665.127 277.773C661.237 277.773 658.084 280.926 658.084 284.815C658.084 288.705 661.237 291.858 665.127 291.858Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M647.236 79.6167C651.126 79.6167 654.279 76.4636 654.279 72.5741C654.279 68.6845 651.126 65.5314 647.236 65.5314C643.346 65.5314 640.193 68.6845 640.193 72.5741C640.193 76.4636 643.346 79.6167 647.236 79.6167Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M533.386 77.4863C537.276 77.4863 540.429 74.3332 540.429 70.4436C540.429 66.5541 537.276 63.401 533.386 63.401C529.497 63.401 526.344 66.5541 526.344 70.4436C526.344 74.3332 529.497 77.4863 533.386 77.4863Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M1219.21 170.437C1223.1 170.437 1226.25 167.284 1226.25 163.394C1226.25 159.505 1223.1 156.351 1219.21 156.351C1215.32 156.351 1212.17 159.505 1212.17 163.394C1212.17 167.284 1215.32 170.437 1219.21 170.437Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M1410.89 20.1317C1414.78 20.1317 1417.94 16.9786 1417.94 13.089C1417.94 9.19949 1414.78 6.04639 1410.89 6.04639C1407 6.04639 1403.85 9.19949 1403.85 13.089C1403.85 16.9786 1407 20.1317 1410.89 20.1317Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M332.705 155.741C336.594 155.741 339.747 152.588 339.747 148.699C339.747 144.809 336.594 141.656 332.705 141.656C328.815 141.656 325.662 144.809 325.662 148.699C325.662 152.588 328.815 155.741 332.705 155.741Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5694 409.298V354.487L67.0078 348.51C68.0316 349.037 69.0348 349.585 70.0172 350.154C97.9293 366.266 97.8983 392.338 70.0172 408.502C69.5415 408.771 69.0658 409.039 68.5694 409.308V409.298Z",
    fill: "black"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5673 354.477V409.287C53.2514 417.571 33.1783 421.356 13.6016 420.425V370.382L68.5673 354.466V354.477Z",
    fill: "black"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0069 348.499L68.5684 354.477L13.6027 370.393L-29.584 345.118L-1.30996 313.596L59.354 319.377L67.0069 348.499ZM39.1879 347.61L35.7131 334.342L12.7753 332.16L2.09243 344.073L18.4115 353.629L39.1982 347.61H39.1879Z",
    fill: "#FBB93E"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7034 334.342L39.1885 347.61L18.4018 353.629L12.7656 350.33V332.16L35.7034 334.342Z",
    fill: "black"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7669 332.16V350.33L2.08398 344.073L12.7669 332.16Z",
    fill: "black"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M-25.7265 347.372L-29.584 345.118V409.298C-17.3395 415.916 -2.05456 419.691 13.6027 420.425V370.382L-25.7265 347.362V347.372Z",
    fill: "black"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6144 370.393L-29.5723 345.118L-1.29825 313.596L59.3554 319.377L68.5698 354.477L13.6144 370.393Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7669 332.16L35.7046 334.342L39.1897 347.61L18.4031 353.629L2.08398 344.073L12.7669 332.16Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6152 370.392V420.425",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5684 409.298V354.477",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M67.008 348.499C68.0318 349.027 69.035 349.575 70.0174 350.144C97.9295 366.256 97.8985 392.327 70.0174 408.491C69.5417 408.76 69.066 409.029 68.5696 409.298C53.2123 417.509 33.1806 421.366 13.6038 420.436C-2.04304 419.691 -17.3383 415.937 -29.5828 409.308C-30.0792 409.039 -30.5549 408.77 -31.0306 408.501C-58.9117 392.337 -58.9117 366.318 -31.0306 350.154C-30.5549 349.885 -30.0792 349.616 -29.5828 349.347",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7656 332.16V350.33",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M546.519 134.014L537.987 142.422L529.455 124.158L520.924 132.566L512.392 114.303L503.85 122.71",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.72 146.589L1094.18 154.997L1085.65 136.733L1077.12 145.141L1068.58 126.878L1060.05 135.286",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M1559.97 64.1766L1551.43 72.5843L1542.9 54.321L1534.37 62.7288L1525.84 44.4655L1517.3 52.8732",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M1826.92 215.133L1818.38 223.541L1809.84 205.278L1801.31 213.685L1792.78 195.432L1784.25 203.83",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M1340.53 172.816C1339.42 174.77 1338.74 176.952 1338.74 178.927C1338.74 180.903 1339.44 182.35 1340.58 183.002L1383.78 207.946C1382.64 207.294 1381.94 205.878 1381.94 203.871C1381.94 201.865 1382.62 199.704 1383.72 197.76C1384.87 195.753 1386.46 193.985 1388.23 192.971C1389.97 191.958 1391.54 191.865 1392.68 192.537L1349.48 167.593C1348.35 166.931 1346.76 167.024 1345.04 168.027C1343.27 169.041 1341.68 170.809 1340.54 172.816H1340.53Z",
    fill: "black"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M1383.72 197.759C1382.62 199.704 1381.94 201.896 1381.94 203.871C1381.94 205.847 1382.64 207.294 1383.78 207.946C1384.91 208.597 1386.5 208.504 1388.22 207.512C1389.96 206.498 1391.53 204.781 1392.67 202.816C1393.81 200.841 1394.51 198.618 1394.51 196.611C1394.51 194.605 1393.81 193.199 1392.67 192.547C1391.53 191.885 1389.95 191.978 1388.22 192.982C1386.45 193.995 1384.86 195.763 1383.71 197.77L1383.72 197.759Z",
    fill: "black"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M1392.68 192.527C1391.54 191.865 1389.96 191.958 1388.23 192.961C1386.47 193.974 1384.87 195.743 1383.72 197.749C1382.62 199.693 1381.94 201.886 1381.94 203.861C1381.94 205.836 1382.64 207.284 1383.78 207.936C1384.91 208.587 1386.5 208.494 1388.22 207.501C1389.96 206.488 1391.53 204.771 1392.67 202.806C1393.81 200.831 1394.51 198.607 1394.51 196.601C1394.51 194.595 1393.81 193.188 1392.67 192.537L1392.68 192.527Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M1392.68 192.527L1349.48 167.593C1348.35 166.931 1346.76 167.024 1345.04 168.027C1343.27 169.041 1341.67 170.809 1340.54 172.816C1339.43 174.77 1338.75 176.952 1338.75 178.927C1338.75 180.903 1339.45 182.35 1340.59 183.002L1383.79 207.946",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M136.577 19.3044C135.553 21.1039 134.922 23.1205 134.922 24.9406C134.922 26.7607 135.573 28.0948 136.628 28.705L176.495 51.7254C175.44 51.1256 174.789 49.8226 174.789 47.9611C174.789 46.0996 175.42 44.114 176.433 42.3249C177.488 40.4738 178.967 38.8398 180.591 37.909C182.193 36.9783 183.652 36.8955 184.696 37.5057L144.829 14.4852C143.774 13.8751 142.326 13.9578 140.724 14.8886C139.1 15.8296 137.621 17.4533 136.566 19.3044H136.577Z",
    fill: "black"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M176.435 42.3246C175.422 44.1241 174.791 46.1407 174.791 47.9608C174.791 49.781 175.443 51.115 176.497 51.7252C177.552 52.325 179 52.2423 180.603 51.3219C182.206 50.3911 183.664 48.7985 184.709 46.9887C185.763 45.1686 186.415 43.1106 186.415 41.2595C186.415 39.4083 185.763 38.1052 184.709 37.5054C183.654 36.8953 182.206 36.978 180.603 37.9088C178.979 38.8498 177.501 40.4735 176.446 42.3246H176.435Z",
    fill: "black"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M184.708 37.495C183.653 36.8848 182.205 36.9676 180.602 37.8983C178.979 38.8394 177.5 40.463 176.445 42.3142C175.432 44.1136 174.801 46.1303 174.801 47.9504C174.801 49.7705 175.452 51.1046 176.507 51.7147C177.562 52.3145 179.01 52.2318 180.613 51.3114C182.216 50.3807 183.674 48.7881 184.718 46.9783C185.773 45.1582 186.425 43.1002 186.425 41.249C186.425 39.3979 185.773 38.0948 184.718 37.495H184.708Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M184.706 37.4952L144.839 14.4747C143.785 13.8646 142.337 13.9473 140.734 14.8781C139.11 15.8191 137.631 17.4428 136.577 19.2939C135.553 21.0934 134.922 23.11 134.922 24.9301C134.922 26.7502 135.573 28.0843 136.628 28.6945L176.495 51.7149",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7816 255.672L77.1019 261.257L65.209 254.39L74.8887 248.805L86.7816 255.672Z",
    fill: "black"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5811 266.179L58.9013 271.774L38.9316 260.243L48.6114 254.659L68.5811 266.179Z",
    fill: "black"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M50.378 276.686L40.6983 282.271L12.6621 266.086L22.3419 260.491L50.378 276.686Z",
    fill: "black"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7816 255.672L74.8887 248.805L65.209 254.39L77.1019 261.257",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5811 266.179L48.6114 254.659L38.9316 260.243L58.9013 271.774",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3789 276.686L58.9004 271.774L86.7814 255.672",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M50.378 276.686L22.3419 260.491L12.6621 266.086L40.6983 282.271L50.378 276.686Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.07 245.755L1316.51 253.067L1300.65 251.433C1294.25 250.771 1286.94 243.015 1284.31 234.111C1281.69 225.217 1284.75 218.526 1291.14 219.188L1294.97 219.581C1294.81 221.701 1295.09 224.141 1295.86 226.789C1298.49 235.683 1305.8 243.439 1312.2 244.101L1328.06 245.745L1328.07 245.755Z",
    fill: "black"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M1316.51 253.067L1328.08 245.755C1327.38 251.505 1325.02 255.911 1321.28 258.269H1321.27L1309.76 265.57C1311.74 264.308 1313.32 262.478 1314.48 260.182C1315.5 258.155 1316.2 255.756 1316.53 253.067H1316.51Z",
    fill: "black"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M1318.56 213.52L1306.76 220.48C1304.64 217.398 1302.3 214.585 1299.8 212.145C1294.16 206.581 1287.8 202.899 1281.82 202.289C1281.18 202.227 1280.55 202.196 1279.94 202.207C1277.51 202.248 1275.35 202.817 1273.51 203.882C1285.44 196.291 1287.3 194.337 1293.38 194.967C1302.1 195.867 1311.65 203.272 1318.57 213.52H1318.56Z",
    fill: "black"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.76 220.491L1307.01 220.843L1306.29 220.77L1306.76 220.491Z",
    fill: "black"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.29 220.77L1291.16 219.198C1284.76 218.536 1281.7 225.227 1284.33 234.121C1286.96 243.025 1294.27 250.771 1300.67 251.443L1316.53 253.077C1316.2 255.766 1315.5 258.165 1314.48 260.192C1313.31 262.488 1311.73 264.318 1309.76 265.58L1309.73 265.601C1307.35 267.1 1304.44 267.772 1301.04 267.421C1292.97 266.583 1284.17 260.151 1277.4 251.06C1273.35 245.6 1270.03 239.188 1268.04 232.445C1267.17 229.488 1266.62 226.654 1266.35 223.986C1266.04 221.008 1266.09 218.226 1266.48 215.723C1267.33 210.242 1269.78 206.074 1273.51 203.892C1275.37 202.827 1277.52 202.258 1279.95 202.217C1280.56 202.217 1281.19 202.227 1281.83 202.3C1287.81 202.91 1294.17 206.591 1299.81 212.155C1302.31 214.606 1304.65 217.419 1306.77 220.49L1306.3 220.77H1306.29Z",
    fill: "black"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M1277.38 251.05L1277 251.319L1212.42 248.03C1212.63 246.789 1212.74 245.435 1212.74 243.997C1212.74 241.846 1212.5 239.612 1212.03 237.348C1210.19 228.247 1204.88 218.774 1198.06 212.31L1266.32 223.965C1266.59 226.634 1267.14 229.467 1268.01 232.425C1270 239.168 1273.32 245.58 1277.37 251.04L1277.38 251.05Z",
    fill: "black"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M1266.46 215.713C1266.07 218.215 1266.02 220.987 1266.33 223.976L1198.07 212.321L1209.12 205.919L1266.47 215.713H1266.46Z",
    fill: "black"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M1216.34 252.777L1243.65 306.988L1220.25 320.504C1215.44 312.19 1206.45 306.605 1196.16 306.605V263.026C1197.31 262.84 1198.38 262.467 1199.36 261.94L1216.34 252.787V252.777Z",
    fill: "black"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M1224.05 248.62L1199.42 261.899C1203.35 259.748 1205.8 254.97 1205.8 248.124C1205.8 245.972 1205.56 243.739 1205.1 241.474C1203.22 232.228 1197.77 222.59 1190.79 216.127C1188.87 214.348 1186.82 212.796 1184.7 211.587C1179 208.298 1173.82 207.926 1170.04 209.963L1196.52 195.681C1200.32 193.633 1205.49 194.006 1211.18 197.305C1215.54 199.828 1219.6 203.706 1222.98 208.277L1209.11 205.909L1198.06 212.31C1204.89 218.764 1210.2 228.247 1212.03 237.348C1212.5 239.602 1212.74 241.836 1212.74 243.997C1212.74 245.435 1212.62 246.779 1212.42 248.03L1224.05 248.62Z",
    fill: "black"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M1220.24 320.504C1222.61 324.589 1223.97 329.346 1223.97 334.403C1223.97 349.761 1211.52 362.212 1196.16 362.212C1180.8 362.212 1168.35 349.771 1168.35 334.403C1168.35 329.336 1169.7 324.589 1172.07 320.504C1176.88 312.19 1185.86 306.605 1196.16 306.605C1206.46 306.605 1215.43 312.2 1220.24 320.504Z",
    fill: "black"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M1205.08 241.484C1205.55 243.738 1205.79 245.972 1205.79 248.134C1205.79 254.969 1203.34 259.747 1199.41 261.909L1199.34 261.94C1198.37 262.467 1197.3 262.829 1196.15 263.026C1192.84 263.594 1188.91 262.757 1184.68 260.326C1181.54 258.506 1178.55 255.983 1175.88 253.015C1168.62 244.979 1163.59 233.604 1163.59 223.789C1163.59 216.912 1166.06 212.134 1170.02 209.994C1173.8 207.946 1178.98 208.318 1184.68 211.617C1186.8 212.838 1188.85 214.379 1190.77 216.157C1197.75 222.611 1203.21 232.249 1205.07 241.505L1205.08 241.484ZM1191.64 239.964C1191.64 239.25 1191.57 238.516 1191.41 237.771C1190.79 234.731 1189 231.546 1186.7 229.426C1186.06 228.836 1185.38 228.329 1184.69 227.926C1182.82 226.84 1181.1 226.716 1179.86 227.388C1178.56 228.092 1177.74 229.664 1177.74 231.928C1177.74 236.365 1180.84 241.753 1184.69 243.966C1186.56 245.052 1188.28 245.176 1189.52 244.504H1189.54C1190.83 243.79 1191.64 242.208 1191.64 239.964Z",
    fill: "black"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.16 263.026V306.606C1185.86 306.606 1176.88 312.2 1172.07 320.505L1148.67 306.988L1175.88 253.005C1178.55 255.973 1181.54 258.496 1184.68 260.316C1188.91 262.757 1192.84 263.595 1196.15 263.016L1196.16 263.026Z",
    fill: "black"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.41 237.771C1191.57 238.516 1191.64 239.25 1191.64 239.964C1191.64 242.218 1190.83 243.79 1189.54 244.504H1189.52C1188.28 245.186 1186.56 245.062 1184.69 243.976C1180.85 241.763 1177.74 236.375 1177.74 231.939C1177.74 229.674 1178.56 228.102 1179.86 227.399C1181.1 226.726 1182.82 226.85 1184.69 227.936C1185.38 228.34 1186.07 228.846 1186.7 229.436C1189 231.566 1190.79 234.741 1191.41 237.782V237.771Z",
    fill: "black"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M1216.34 252.777L1243.65 306.988L1220.24 320.504",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.16 263.026V306.595",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M1172.08 320.505L1148.68 306.988L1175.88 253.005",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M1199.42 261.899L1199.35 261.93C1198.38 262.457 1197.31 262.819 1196.16 263.016C1192.85 263.574 1188.92 262.747 1184.69 260.316C1181.55 258.496 1178.56 255.973 1175.89 253.005C1168.64 244.949 1163.6 233.594 1163.6 223.779C1163.6 216.902 1166.06 212.124 1170.03 209.984",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M1191.64 239.964C1191.64 242.218 1190.83 243.79 1189.54 244.504H1189.52C1188.28 245.186 1186.56 245.062 1184.69 243.976C1180.85 241.763 1177.74 236.375 1177.74 231.939C1177.74 229.674 1178.56 228.102 1179.86 227.399C1181.1 226.726 1182.82 226.85 1184.69 227.936C1185.38 228.34 1186.07 228.846 1186.7 229.436C1189 231.566 1190.79 234.741 1191.41 237.782C1191.57 238.526 1191.64 239.26 1191.64 239.974V239.964Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M1224.05 248.62L1199.42 261.899C1203.35 259.748 1205.8 254.97 1205.8 248.124C1205.8 245.972 1205.56 243.739 1205.1 241.474C1203.22 232.228 1197.77 222.59 1190.79 216.127C1188.87 214.348 1186.82 212.796 1184.7 211.587C1179 208.298 1173.82 207.926 1170.04 209.963L1196.52 195.681C1200.32 193.633 1205.49 194.006 1211.18 197.305C1215.54 199.828 1219.6 203.706 1222.98 208.277",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M1266.32 223.976L1198.06 212.321L1209.11 205.919L1266.46 215.713",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M1277 251.319L1212.42 248.03C1212.63 246.789 1212.74 245.435 1212.74 243.997C1212.74 241.846 1212.5 239.612 1212.03 237.348C1210.19 228.247 1204.88 218.774 1198.06 212.31",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M1172.08 320.504C1169.71 324.589 1168.36 329.346 1168.36 334.403C1168.36 349.761 1180.8 362.212 1196.17 362.212C1211.54 362.212 1223.98 349.771 1223.98 334.403C1223.98 329.336 1222.62 324.589 1220.25 320.504C1215.44 312.19 1206.46 306.605 1196.17 306.605C1185.88 306.605 1176.89 312.2 1172.08 320.504Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M1294.98 219.591C1294.82 221.711 1295.1 224.152 1295.87 226.799C1298.5 235.693 1305.81 243.449 1312.21 244.111L1328.07 245.755",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.76 220.491L1307 220.842L1291.15 219.198C1284.75 218.536 1281.69 225.227 1284.32 234.121C1286.95 243.025 1294.26 250.771 1300.66 251.443L1316.51 253.077",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M1309.72 265.591C1307.34 267.09 1304.42 267.762 1301.03 267.411C1292.96 266.573 1284.16 260.141 1277.39 251.05C1273.34 245.59 1270.02 239.178 1268.03 232.435C1267.16 229.478 1266.61 226.644 1266.34 223.976C1266.03 220.998 1266.09 218.216 1266.47 215.713C1267.33 210.232 1269.77 206.064 1273.5 203.882",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M1273.5 203.892C1285.44 196.302 1287.3 194.347 1293.38 194.978C1302.1 195.878 1311.64 203.282 1318.57 213.531L1306.77 220.491C1304.65 217.409 1302.31 214.596 1299.81 212.155C1294.17 206.592 1287.81 202.91 1281.83 202.3C1281.19 202.238 1280.56 202.207 1279.95 202.217C1277.52 202.258 1275.36 202.827 1273.51 203.892H1273.5Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.07 245.755C1327.37 251.505 1325.01 255.911 1321.27 258.269H1321.26L1309.75 265.57C1311.73 264.308 1313.31 262.478 1314.47 260.182C1315.49 258.155 1316.19 255.756 1316.52 253.067L1328.08 245.755H1328.07Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M1309.75 265.57L1309.72 265.591",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M1306.76 220.491L1306.29 220.77",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M445.086 394.892L433.11 420.684C430.059 420.218 426.678 420.673 424.289 422.049C421.89 423.424 421.104 425.389 421.921 427.147L377.245 434.056C376.934 433.021 376.087 432.039 374.711 431.243C371.143 429.174 365.352 429.174 361.784 431.243L330.097 412.938C333.665 410.87 333.665 407.54 330.097 405.482C328.918 404.809 327.501 404.344 326.002 404.117L337.843 378.604C340.884 379.069 344.286 378.614 346.665 377.239C349.064 375.863 349.85 373.898 349.033 372.14L393.223 365.304C393.626 366.173 394.412 366.99 395.591 367.673C399.159 369.741 404.95 369.741 408.518 367.673L440.205 385.977C436.637 388.035 436.637 391.376 440.205 393.434C441.58 394.23 443.307 394.726 445.096 394.902L445.086 394.892Z",
    fill: "black"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M408.51 360.206C412.078 362.264 412.078 365.604 408.51 367.662C404.942 369.73 399.151 369.73 395.583 367.662C394.404 366.99 393.618 366.163 393.214 365.294C392.397 363.536 393.183 361.581 395.583 360.206C399.151 358.137 404.942 358.137 408.51 360.206Z",
    fill: "black"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M349.023 372.14C349.84 373.898 349.054 375.863 346.655 377.238C344.266 378.614 340.874 379.069 337.834 378.593C336.334 378.365 334.917 377.91 333.738 377.238C330.171 375.17 330.171 371.84 333.738 369.772C337.306 367.714 343.098 367.714 346.655 369.772C347.834 370.444 348.62 371.271 349.023 372.14Z",
    fill: "black"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M408.51 367.662L440.196 385.967",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M349.023 372.14L393.213 365.294",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M408.51 367.662C412.078 365.604 412.078 362.264 408.51 360.206C404.942 358.137 399.151 358.137 395.583 360.206C393.183 361.581 392.397 363.536 393.214 365.294C393.618 366.163 394.404 366.98 395.583 367.662C399.151 369.73 404.932 369.72 408.51 367.662Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M349.023 372.14C348.62 371.271 347.834 370.454 346.655 369.772C343.087 367.714 337.296 367.714 333.738 369.772C330.171 371.84 330.171 375.17 333.738 377.238C334.917 377.91 336.334 378.365 337.834 378.593C340.874 379.058 344.277 378.614 346.655 377.238C349.054 375.863 349.84 373.898 349.023 372.14Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M403.928 355.748V397.88C403.928 400.713 402.035 403.568 398.281 405.739C390.763 410.083 378.58 410.083 371.052 405.739C367.298 403.568 365.426 400.713 365.426 397.88V355.614C365.426 358.468 367.298 361.301 371.052 363.473C378.591 367.817 390.773 367.817 398.281 363.473C401.983 361.343 403.866 358.551 403.928 355.758V355.748Z",
    fill: "black"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M403.928 355.748C403.897 358.541 401.973 361.333 398.281 363.463C390.763 367.807 378.58 367.807 371.052 363.463C367.298 361.291 365.426 358.458 365.426 355.603C365.426 352.749 367.298 349.916 371.052 347.744C378.591 343.4 390.773 343.4 398.281 347.744C402.035 349.916 403.928 352.77 403.928 355.603C403.928 355.666 403.928 355.707 403.928 355.748Z",
    fill: "black"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M403.928 355.748C403.866 358.541 401.973 361.333 398.281 363.463C390.763 367.807 378.58 367.807 371.052 363.463C367.298 361.291 365.426 358.458 365.426 355.603C365.426 352.749 367.298 349.916 371.052 347.744C378.591 343.4 390.773 343.4 398.281 347.744C402.035 349.916 403.928 352.77 403.928 355.603",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M403.928 355.604V397.87C403.928 400.703 402.035 403.558 398.281 405.729C390.763 410.073 378.58 410.073 371.052 405.729C367.298 403.558 365.426 400.703 365.426 397.87V355.604",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M829.691 54.9003L848.399 28.4774L842.898 68.8718L829.691 54.9003Z",
    fill: "black"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M842.898 68.8717L848.4 28.4773L867.108 61.2603L842.898 68.8717Z",
    fill: "black"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M842.898 68.8719L848.399 28.4775L867.107 61.2605L842.898 68.8719ZM842.898 68.8719L829.691 54.9004L848.399 28.4775",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M1545.78 390.455L1561.49 368.272L1556.87 402.203L1545.78 390.455Z",
    fill: "black"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M1556.87 402.203L1561.49 368.272L1577.2 395.802L1556.87 402.203Z",
    fill: "black"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M1556.87 402.203L1561.49 368.272L1577.2 395.802L1556.87 402.203ZM1556.87 402.203L1545.78 390.455L1561.49 368.272",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M1327.36 114.851L1346.68 87.5699L1340.99 129.278L1327.36 114.851Z",
    fill: "black"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M1340.99 129.278L1346.68 87.5699L1365.99 121.408L1340.99 129.278Z",
    fill: "black"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M1340.99 129.277L1346.68 87.5697L1365.99 121.408L1340.99 129.277ZM1340.99 129.277L1327.36 114.851L1346.68 87.5697",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.57 342.832L1874.89 315.561L1869.2 357.258L1855.57 342.832Z",
    fill: "black"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M1869.2 357.258L1874.89 315.561L1894.2 349.399L1869.2 357.258Z",
    fill: "black"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M1869.2 357.258L1874.89 315.561L1894.2 349.399L1869.2 357.258ZM1869.2 357.258L1855.57 342.832L1874.89 315.561",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M709.958 27.877L679.916 45.2199V10.5341L709.958 27.877Z",
    fill: "black"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M679.916 10.5341V45.2199L649.873 27.877L679.916 10.5341Z",
    fill: "black"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M679.916 45.2199L649.873 27.877L679.916 10.5341L709.958 27.877L679.916 45.2199Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M679.916 10.5341V45.2199",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M1737.6 131.594L1707.55 148.937V114.251L1737.6 131.594Z",
    fill: "black"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M1707.55 114.251V148.937L1677.51 131.594L1707.55 114.251Z",
    fill: "black"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M1707.55 148.937L1677.51 131.594L1707.55 114.251L1737.59 131.594L1707.55 148.937Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M1707.55 114.251V148.937",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M558.371 366.586C558.371 367.486 558.35 368.386 558.298 369.244C558.081 373.567 557.306 377.404 556.065 380.703C553.51 379.71 550.542 380.196 548.422 382.12C547.419 383.04 546.716 384.167 546.333 385.367C545.63 387.601 546.013 390.103 547.491 392.048L546.819 392.306C546.819 392.306 546.747 392.358 546.695 392.378L535.309 398.945C539.828 396.133 543.21 391.386 545.009 384.974C545.951 381.582 546.457 377.735 546.457 373.453C546.457 348.044 528.618 317.133 506.601 304.413C495.814 298.197 486.021 297.484 478.844 301.382L490.344 294.743C497.552 290.575 507.511 291.175 518.514 297.535C524.057 300.731 529.332 305.074 534.14 310.214C541.266 317.846 547.326 327.164 551.597 336.978C555.868 346.782 558.371 357.051 558.371 366.566V366.586Z",
    fill: "black"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M546.446 373.464C546.446 377.735 545.949 381.592 544.998 384.984C543.198 391.396 539.817 396.153 535.297 398.956L534.77 399.256C527.562 403.424 517.593 402.824 506.589 396.464C488.595 386.081 473.392 363.536 468.439 341.767C467.322 336.896 466.732 332.077 466.732 327.433C466.732 314.723 471.2 305.788 478.408 301.631L478.677 301.476L478.832 301.393C486.009 297.494 495.803 298.197 506.589 304.423C528.596 317.133 546.446 348.044 546.446 373.464ZM533.974 384.126C536.559 380.351 538.038 375.108 538.038 368.603C538.038 348.551 523.953 324.165 506.589 314.144C500.963 310.897 495.679 309.553 491.108 309.915C481.573 310.649 475.151 318.746 475.151 332.294C475.151 352.357 489.236 376.742 506.599 386.763C518.347 393.558 528.586 392.027 533.984 384.126H533.974Z",
    fill: "black"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M538.04 368.603C538.04 375.108 536.562 380.341 533.976 384.126C528.578 392.027 518.34 393.557 506.591 386.763C489.228 376.742 475.143 352.356 475.143 332.294C475.143 318.746 481.575 310.649 491.1 309.914C495.671 309.552 500.955 310.897 506.581 314.144C523.945 324.165 538.03 348.551 538.03 368.603H538.04Z",
    fill: "black"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M534.77 399.266C527.562 403.434 517.593 402.834 506.589 396.474C488.595 386.091 473.392 363.546 468.439 341.777C467.322 336.906 466.732 332.087 466.732 327.444C466.732 314.734 471.2 305.799 478.408 301.641",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M478.844 301.403C486.021 297.505 495.814 298.208 506.601 304.433C528.608 317.143 546.457 348.054 546.457 373.474C546.457 377.745 545.961 381.603 545.009 384.995C543.21 391.407 539.828 396.164 535.309 398.966",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M491.11 309.915C495.681 309.553 500.966 310.897 506.591 314.144C523.955 324.165 538.04 348.551 538.04 368.603C538.04 375.108 536.562 380.341 533.976 384.126C528.578 392.027 518.34 393.558 506.591 386.763C489.228 376.742 475.143 352.357 475.143 332.294C475.143 318.746 481.575 310.649 491.1 309.915H491.11Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M478.42 301.641L490.333 294.764C497.542 290.596 507.501 291.196 518.504 297.556C524.047 300.752 529.321 305.095 534.13 310.235C541.256 317.867 547.316 327.185 551.587 336.999C555.858 346.803 558.361 357.072 558.361 366.587C558.361 367.486 558.34 368.386 558.288 369.244C558.071 373.567 557.296 377.404 556.055 380.703",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M503.736 185.721V208.318L487.458 211.813L478.399 220.862V211.058L475.514 201.161L487.458 189.217L503.736 185.721Z",
    fill: "black"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M503.735 171.45V185.732L487.458 189.227L475.513 201.172L478.409 211.069L457.002 218.204L443.609 211.803H419.72L406.328 218.204L384.92 211.069L387.816 201.172L375.871 189.227L359.594 185.732V171.45L375.871 167.954L387.826 156.01L384.92 146.134L406.338 138.998L419.71 145.389H443.599L456.991 138.998L478.398 146.134L475.503 156.01L487.447 167.954L503.725 171.45H503.735ZM454.24 189.879C458.791 186.869 461.542 182.919 461.542 178.586C461.542 169.071 448.17 161.336 431.654 161.336C415.139 161.336 401.788 169.061 401.788 178.586C401.788 182.919 404.549 186.869 409.089 189.879C414.56 193.519 422.647 195.825 431.654 195.825C440.662 195.825 448.759 193.519 454.23 189.879H454.24Z",
    fill: "black"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M479.93 220.862V233.655L458.533 240.791V218.194L479.93 211.058V220.862Z",
    fill: "black"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M461.552 178.586C461.552 182.919 458.791 186.869 454.251 189.879C448.77 186.238 440.693 183.932 431.675 183.932C422.657 183.932 414.581 186.238 409.11 189.879C404.559 186.869 401.809 182.919 401.809 178.586C401.809 169.071 415.18 161.336 431.675 161.336C448.17 161.336 461.563 169.061 461.563 178.586H461.552Z",
    fill: "black"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M457.002 218.194V240.791L443.61 234.389H419.721L406.328 240.791V218.194L419.721 211.793H443.61L457.002 218.194Z",
    fill: "black"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M407.86 218.194V240.791L386.463 233.655V211.058L407.86 218.194Z",
    fill: "black"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M387.816 201.161L384.931 211.058V220.862L375.882 211.813L359.594 208.318V185.721L375.882 189.217L387.816 201.161Z",
    fill: "black"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M360.297 185.722V208.318",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M504.44 208.318L488.162 211.814L479.113 220.863",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M454.944 189.879C449.463 186.239 441.386 183.932 432.368 183.932C423.35 183.932 415.273 186.239 409.803 189.879",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M385.634 211.059L388.53 201.162L376.585 189.217L360.297 185.722V171.45L376.585 167.955L388.54 156.01L385.634 146.124L407.051 138.988L420.423 145.379H444.312L457.705 138.988L479.112 146.124L476.216 156.01L488.161 167.955L504.439 171.45V185.722L488.161 189.217L476.216 201.162L479.112 211.059L457.705 218.194L444.312 211.793H420.423L407.041 218.194L385.634 211.059Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M454.945 189.879C459.485 186.859 462.246 182.919 462.246 178.586C462.246 169.071 448.874 161.336 432.359 161.336C415.843 161.336 402.492 169.061 402.492 178.586C402.492 182.919 405.253 186.859 409.793 189.879C415.264 193.519 423.351 195.825 432.359 195.825C441.366 195.825 449.464 193.509 454.935 189.879H454.945Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M385.635 211.059V233.655L407.042 240.791L420.424 234.389H444.313L457.706 240.791L479.113 233.655V211.059",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M407.041 240.791V218.194",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M457.705 240.791V218.194",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M360.297 208.318L376.585 211.814L385.634 220.863",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M504.439 208.318V185.722",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M735.129 254.649C729.048 258.165 723.494 258.31 719.296 255.704C718.448 255.187 717.672 254.556 716.938 253.811C713.494 250.316 711.426 244.442 711.426 236.737V225.548C713.866 222.114 715.252 217.305 715.252 211.307C715.252 205.309 713.856 198.897 711.426 192.661V190.262C711.426 172.816 722.036 152.546 735.129 144.986L802.287 106.205C808.068 102.875 813.363 102.575 817.479 104.778C818.555 105.357 819.568 106.112 820.468 107.032C823.912 110.528 825.98 116.402 825.98 124.117V170.582C825.98 188.028 815.38 208.298 802.287 215.857L735.129 254.628V254.649ZM817.552 176.983V127.499C817.552 116.268 810.716 111.107 802.298 115.968L735.139 154.749C726.711 159.62 719.885 172.66 719.885 183.902V233.376C719.885 244.617 726.711 249.778 735.139 244.907L802.298 206.126C810.726 201.265 817.552 188.214 817.552 176.983Z",
    fill: "black"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M817.551 127.499V176.983C817.551 188.214 810.715 201.266 802.297 206.126L735.139 244.907C726.71 249.778 719.885 244.607 719.885 233.376V183.902C719.885 172.661 726.71 159.62 735.139 154.749L802.297 115.968C810.726 111.107 817.551 116.268 817.551 127.499ZM787.074 169.837C789.36 168.514 791.201 163.746 791.201 159.165C791.201 154.583 789.35 151.946 787.074 153.26C784.789 154.583 782.948 159.351 782.948 163.932C782.948 168.514 784.799 171.151 787.074 169.837ZM750.341 191.048C752.626 189.724 754.467 184.946 754.467 180.365C754.467 175.784 752.616 173.147 750.341 174.47C748.055 175.784 746.215 180.562 746.215 185.143C746.215 189.724 748.066 192.361 750.341 191.048Z",
    fill: "#FBB93E"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M796.6 92.7297L817.479 104.788C813.363 102.585 808.068 102.875 802.287 106.215L735.129 144.996C722.036 152.546 711.426 172.815 711.426 190.272V192.671C706.514 180.065 697.351 168.224 686.865 162.163C682.769 159.806 678.881 158.554 675.375 158.327V146.796C675.375 137.571 677.826 127.602 682.014 118.098C683.007 117.353 684.021 116.681 685.055 116.081L752.213 77.3C758.139 73.8769 763.558 73.6598 767.715 76.0487L796.589 92.7194L796.6 92.7297Z",
    fill: "black"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M796.601 76.7933V92.7298L782.464 84.5702V67.8788C782.464 60.4018 780.923 54.321 777.852 49.6259C780.799 49.9464 783.477 50.8462 785.835 52.3043L786.001 52.4078C787.314 53.2351 788.535 54.2382 789.61 55.3965C794.026 60.0502 796.601 67.3307 796.601 76.7933Z",
    fill: "black"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M791.212 159.164C791.212 163.746 789.361 168.513 787.085 169.837C784.8 171.15 782.959 168.513 782.959 163.932C782.959 159.351 784.81 154.583 787.085 153.259C789.371 151.946 791.212 154.583 791.212 159.164Z",
    fill: "black"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M771.874 43.4935L785.835 52.3046C783.477 50.8464 780.788 49.9467 777.851 49.6261C772.142 49.0056 765.482 50.6085 758.347 54.7245L713.619 80.5372C700.702 87.9935 689.244 101.986 682.356 117.333C682.243 117.591 682.129 117.85 682.015 118.098C677.91 127.633 675.376 137.561 675.376 146.796V191.379C673.163 188.917 670.691 186.818 668.085 185.329C665.655 183.922 663.338 183.168 661.229 183.002V137.882C661.229 113.475 678.354 83.8155 699.493 71.6227L744.21 45.81C755.089 39.5223 764.903 39.0983 771.863 43.4935H771.874Z",
    fill: "black"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M754.479 180.365C754.479 184.946 752.628 189.724 750.353 191.048C748.067 192.361 746.227 189.714 746.227 185.143C746.227 180.572 748.078 175.784 750.353 174.47C752.638 173.157 754.479 175.794 754.479 180.365Z",
    fill: "black"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M719.296 255.714L690.143 238.888C691.156 238.589 692.108 238.175 693.007 237.668L706.886 229.736C708.644 228.733 710.174 227.337 711.426 225.568V236.758C711.426 244.463 713.494 250.337 716.938 253.832C717.662 254.577 718.448 255.208 719.296 255.725V255.714Z",
    fill: "black"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M711.426 192.672C713.856 198.908 715.252 205.33 715.252 211.318C715.252 217.305 713.867 222.125 711.426 225.558C710.175 227.326 708.644 228.723 706.886 229.726L693.007 237.658C698.178 234.71 701.374 228.33 701.374 219.26C701.374 202.093 689.936 181.389 675.375 171.585V158.327C678.881 158.555 682.769 159.806 686.865 162.164C697.351 168.224 706.514 180.076 711.426 192.672Z",
    fill: "black"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M701.375 219.26C701.375 228.329 698.179 234.71 693.009 237.658C692.109 238.175 691.157 238.578 690.144 238.878C685.387 240.315 679.44 239.364 672.987 235.641C670.35 234.121 667.806 232.228 665.396 230.067C668.995 231.463 672.212 231.36 674.694 229.974L685.139 224.141C688.334 222.362 690.32 218.453 690.32 212.869C690.32 202.755 683.815 190.645 675.387 184.44V171.585C689.948 181.389 701.385 202.093 701.385 219.26H701.375Z",
    fill: "black"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M690.318 212.869C690.318 218.453 688.332 222.363 685.137 224.141L674.692 229.974C677.887 228.185 679.873 224.276 679.873 218.691C679.873 207.646 672.117 194.213 662.55 188.69C657.866 185.981 653.605 185.67 650.492 187.377C650.492 187.377 661.103 181.451 661.237 181.379V182.992C663.347 183.157 665.663 183.912 668.094 185.319C670.7 186.818 673.171 188.907 675.384 191.369V184.419C683.813 190.624 690.318 202.734 690.318 212.848V212.869Z",
    fill: "black"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M674.692 229.974C672.199 231.36 668.983 231.463 665.395 230.067C664.474 229.705 663.523 229.25 662.551 228.702C652.974 223.179 645.229 209.746 645.229 198.701C645.229 197.47 645.322 196.312 645.508 195.247C646.159 191.482 647.917 188.804 650.399 187.428L650.482 187.387C653.605 185.691 657.856 185.991 662.54 188.7C672.106 194.212 679.863 207.657 679.863 218.701C679.863 224.286 677.887 228.195 674.682 229.984L674.692 229.974ZM667.67 211.648C667.67 208.391 665.374 204.42 662.551 202.775C659.727 201.141 657.432 202.465 657.432 205.743C657.432 209.022 659.717 212.983 662.551 214.616C665.374 216.25 667.67 214.927 667.67 211.648Z",
    fill: "black"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M662.553 202.776C665.376 204.42 667.672 208.381 667.672 211.649C667.672 214.917 665.376 216.24 662.553 214.617C659.729 212.983 657.434 209.012 657.434 205.744C657.434 202.476 659.719 201.152 662.553 202.776Z",
    fill: "black"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M661.238 166.238V181.389C661.104 181.461 660.98 181.523 660.856 181.595L650.41 187.418C647.918 188.804 646.16 191.482 645.519 195.236C644.929 192.268 644.619 189.321 644.619 186.477C644.619 177.407 647.773 170.964 652.975 168.069C653.058 168.017 653.151 167.976 653.234 167.924C655.561 166.662 658.26 166.083 661.238 166.228V166.238Z",
    fill: "black"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M661.238 163.353V166.238C658.259 166.094 655.56 166.673 653.233 167.934L652.975 168.079L661.248 163.363L661.238 163.353Z",
    fill: "black"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M711.426 225.558V236.747C711.426 244.452 713.494 250.326 716.938 253.821C717.662 254.566 718.448 255.197 719.296 255.714",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M719.297 255.714C723.485 258.32 729.049 258.176 735.13 254.659L802.288 215.889C815.381 208.329 825.981 188.07 825.981 170.613V124.148C825.981 116.433 823.913 110.559 820.469 107.064C819.569 106.143 818.556 105.388 817.48 104.809",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M817.479 104.799C813.363 102.596 808.068 102.886 802.287 106.226L735.129 145.007C722.036 152.557 711.426 172.826 711.426 190.283V192.682",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M711.426 192.672V192.682",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M719.875 233.376V183.902C719.875 172.661 726.7 159.62 735.129 154.749L802.287 115.968C810.716 111.107 817.541 116.268 817.541 127.499V176.983C817.541 188.214 810.706 201.266 802.287 206.126L735.129 244.907C726.7 249.778 719.875 244.607 719.875 233.376Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M754.479 180.365C754.479 184.946 752.628 189.724 750.353 191.048C748.067 192.361 746.227 189.714 746.227 185.143C746.227 180.572 748.078 175.784 750.353 174.47C752.638 173.157 754.479 175.794 754.479 180.365Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M791.212 159.164C791.212 163.746 789.361 168.513 787.085 169.837C784.8 171.15 782.959 168.513 782.959 163.932C782.959 159.351 784.81 154.583 787.085 153.259C789.371 151.946 791.212 154.583 791.212 159.164Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M749.732 198.918C753.611 203.748 760.457 204.482 768.244 199.994C768.565 199.807 768.885 199.611 769.206 199.425C769.526 199.259 769.837 199.083 770.167 198.887C777.944 194.378 784.791 185.743 788.679 176.425",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M782.465 84.5703L817.802 104.974",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M682.016 118.098C683.008 117.353 684.022 116.681 685.056 116.081L752.215 77.3C758.14 73.8769 763.559 73.6598 767.717 76.0487L782.454 84.5598",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M645.509 195.247C644.92 192.279 644.609 189.331 644.609 186.487C644.609 177.418 647.764 170.975 652.965 168.079C653.048 168.027 653.141 167.986 653.224 167.934C655.551 166.673 658.25 166.094 661.228 166.238",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M675.376 171.585C689.937 181.389 701.375 202.093 701.375 219.26C701.375 228.329 698.179 234.71 693.009 237.658C692.109 238.175 691.157 238.578 690.144 238.878C685.377 240.295 679.44 239.364 672.987 235.641C670.35 234.121 667.806 232.228 665.396 230.067",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M650.492 187.376C653.616 185.68 657.866 185.98 662.551 188.69C672.117 194.202 679.873 207.646 679.873 218.691C679.873 224.275 677.898 228.184 674.692 229.974C672.199 231.359 668.994 231.463 665.395 230.067C664.474 229.705 663.523 229.25 662.551 228.702C652.974 223.179 645.229 209.745 645.229 198.7C645.229 197.47 645.322 196.312 645.508 195.246C646.17 191.492 647.917 188.804 650.399 187.428",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M657.434 205.743C657.434 202.465 659.719 201.152 662.553 202.775C665.376 204.42 667.672 208.38 667.672 211.648C667.672 214.916 665.376 216.24 662.553 214.617C659.729 212.983 657.434 209.011 657.434 205.743Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M693.007 237.658L706.886 229.726C708.644 228.723 710.175 227.326 711.426 225.558C713.867 222.125 715.252 217.316 715.252 211.318C715.252 205.319 713.856 198.908 711.426 192.672C706.514 180.065 697.351 168.224 686.865 162.164C682.769 159.806 678.881 158.555 675.375 158.327",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M661.238 163.353L652.965 168.069",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M650.41 187.418C650.41 187.418 661.103 181.451 661.238 181.379",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M675.376 184.44C683.805 190.645 690.31 202.755 690.31 212.869C690.31 218.453 688.324 222.362 685.129 224.141L674.684 229.974",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M690.143 238.878L719.627 255.9",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M782.464 84.5702V67.8788C782.464 60.4018 780.923 54.321 777.852 49.6259",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M786 52.4082C787.313 53.2355 788.534 54.2387 789.609 55.3969C794.025 60.0507 796.6 67.3312 796.6 76.7937V92.7302",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M785.834 52.3046L771.873 43.4935C764.913 39.0983 755.089 39.5223 744.22 45.81L699.502 71.6227C678.364 83.8155 661.238 113.475 661.238 137.882V183.002C663.348 183.168 665.665 183.922 668.095 185.329C670.701 186.828 673.173 188.917 675.386 191.379V146.796C675.386 137.571 677.919 127.633 682.025 118.098C682.139 117.839 682.242 117.581 682.366 117.333C689.264 101.996 700.712 87.9935 713.629 80.5372L758.357 54.7245C765.482 50.6085 772.152 49.0056 777.861 49.6261C780.808 49.9467 783.487 50.8464 785.845 52.3046H785.834Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M615.578 33.4724V39.605L611.804 93.8985C611.39 99.876 607.233 106.691 602.248 109.566C600.707 110.455 599.259 110.879 597.967 110.879C597.046 110.879 596.188 110.662 595.464 110.238C593.902 109.339 592.868 107.508 592.682 104.902L589.062 54.9313V48.7884C589.062 40.3496 595.009 30.07 602.31 25.8403C605.909 23.7719 609.167 23.5237 611.556 24.8268L611.7 24.9095C614.1 26.285 615.589 29.253 615.589 33.4827L615.578 33.4724Z",
    fill: "black"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M611.092 122.338C613.409 123.672 614.577 126.299 614.577 130.198C614.577 134.097 613.419 138.047 611.092 142.08C608.776 146.103 605.921 149.102 602.55 151.057C599.168 153.001 596.304 153.301 593.997 151.956C593.997 151.956 593.997 151.956 593.987 151.946L593.884 151.884C591.64 150.529 590.502 147.934 590.502 144.097C590.502 140.26 591.671 136.237 593.997 132.214C596.314 128.171 599.168 125.192 602.55 123.248C605.901 121.314 608.745 120.983 611.061 122.328H611.071C611.071 122.328 611.071 122.338 611.082 122.338H611.092Z",
    fill: "black"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M594.255 14.8267L611.546 24.8167C609.157 23.524 605.889 23.7619 602.301 25.8302C595 30.0599 589.053 40.3395 589.053 48.7783V54.9212L592.673 104.892C592.859 107.498 593.893 109.329 595.455 110.228L578.008 100.155C576.447 99.2558 575.423 97.4253 575.237 94.8192L571.617 44.8484V38.7055C571.617 30.2668 577.564 19.9872 584.865 15.7574C588.536 13.6374 591.856 13.4409 594.255 14.8267Z",
    fill: "black"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M593.636 112.266L611.062 122.328C608.745 120.994 605.901 121.325 602.55 123.248C599.169 125.193 596.304 128.171 593.998 132.215C591.671 136.237 590.502 140.209 590.502 144.097C590.502 147.986 591.64 150.53 593.884 151.884L576.541 141.874C574.225 140.529 573.066 137.913 573.066 134.024C573.066 130.136 574.225 126.165 576.562 122.142C578.868 118.098 581.733 115.12 585.104 113.176C588.465 111.242 591.309 110.911 593.626 112.255L593.636 112.266Z",
    fill: "black"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M611.69 24.8992C614.089 26.2746 615.578 29.2427 615.578 33.4724V39.605L611.804 93.8985C611.39 99.876 607.233 106.691 602.248 109.566C600.707 110.455 599.259 110.879 597.967 110.879C597.046 110.879 596.198 110.662 595.464 110.238C593.902 109.328 592.868 107.508 592.682 104.902L589.062 54.9313V48.7884C589.062 40.3496 595.009 30.07 602.31 25.8403C605.909 23.7719 609.167 23.5237 611.556 24.8268",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M593.884 151.884C591.64 150.529 590.502 147.934 590.502 144.097C590.502 140.26 591.671 136.237 593.997 132.214C596.314 128.171 599.168 125.192 602.55 123.248C605.901 121.314 608.745 120.983 611.061 122.328",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M611.083 122.328C611.083 122.328 611.083 122.328 611.093 122.328C613.41 123.662 614.579 126.289 614.579 130.187C614.579 134.086 613.42 138.037 611.093 142.07C608.777 146.093 605.923 149.092 602.551 151.047C599.169 152.991 596.305 153.291 593.999 151.946C593.999 151.946 593.999 151.946 593.988 151.936",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M611.691 24.8994L594.255 14.8267C591.856 13.4409 588.536 13.6374 584.865 15.7574C577.564 19.9872 571.617 30.2668 571.617 38.7055V44.8484L575.237 94.8192C575.423 97.4253 576.457 99.2558 578.008 100.155L595.455 110.228",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M576.541 141.874C574.225 140.529 573.066 137.913 573.066 134.024C573.066 130.136 574.225 126.165 576.562 122.142C578.868 118.098 581.733 115.12 585.104 113.176C588.465 111.242 591.309 110.911 593.626 112.255L611.072 122.328",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M576.541 141.873L593.987 151.936",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M1080.32 187.749V225.63L936.479 308.663V270.803L1080.32 187.749Z",
    fill: "black"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M1080.32 187.749L936.477 270.803L792.625 187.749L936.477 104.695L1080.32 187.749ZM935.37 251.66L1046.06 187.749L935.37 123.858L850.91 172.619V202.899L935.37 251.671V251.66Z",
    fill: "black"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M1046.06 187.749L935.37 251.66L850.92 202.889V172.609L935.37 123.848L1046.06 187.749Z",
    fill: "#FBB93E"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M936.477 270.803V308.663L792.625 225.63V187.749L936.477 270.803Z",
    fill: "black"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M792.625 187.748L936.477 104.705L1080.32 187.748L936.477 270.802L792.625 187.748Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M792.625 187.748V225.63L936.477 308.663L1080.32 225.63V187.748",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M850.92 172.608L935.37 123.847L1046.06 187.748L935.37 251.66L850.92 202.888V172.608Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M936.479 270.802V308.663",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M1092.02 274.877V319.76C1092.02 327.971 1089.04 334.217 1083.62 337.341C1081.29 338.675 1078.7 339.347 1075.93 339.347C1073.16 339.347 1070.47 338.737 1067.59 337.516C1067.75 336.306 1067.82 335.045 1067.82 333.742V329.067C1067.94 328.891 1068.07 328.705 1068.19 328.53L1068.37 328.633C1072.73 331.146 1076.76 331.694 1079.46 330.143C1082.16 328.581 1083.7 324.807 1083.7 319.77V274.887C1083.7 262.684 1074.78 247.203 1064.2 241.101L1045.08 230.056C1043.09 228.909 1042.41 226.365 1043.56 224.379C1044.71 222.393 1047.25 221.7 1049.23 222.859L1068.36 233.904C1081.62 241.567 1092.02 259.572 1092.02 274.887V274.877Z",
    fill: "black"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M1067.81 297.029C1071.77 298.115 1074.41 302.51 1074.41 309.243C1074.41 315.975 1071.94 322.945 1068.17 328.53L1067.8 328.313V297.029H1067.81Z",
    fill: "black"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M1068.18 328.53C1068.07 328.706 1067.94 328.892 1067.81 329.068V328.313L1068.18 328.53Z",
    fill: "black"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M1067.81 329.068V333.742C1067.81 335.055 1067.74 336.317 1067.58 337.517C1066.8 343.856 1063.96 348.686 1059.4 351.312C1057.08 352.657 1054.48 353.319 1051.71 353.319C1048.94 353.319 1046.25 352.708 1043.37 351.488C1043.53 350.278 1043.6 349.017 1043.6 347.713V342.274L1044.15 342.594C1045.14 343.163 1046.11 343.639 1047.05 344.001C1050.27 345.252 1053.16 345.304 1055.24 344.104C1057.33 342.894 1058.73 340.371 1059.25 336.958C1059.4 335.955 1059.48 334.88 1059.48 333.732V288.839C1059.48 276.635 1050.56 261.164 1039.98 255.052L1020.86 244.018C1018.87 242.87 1018.19 240.326 1019.34 238.33C1020.49 236.344 1023.03 235.652 1025.02 236.81L1044.14 247.855C1057.41 255.518 1067.8 273.523 1067.8 288.839V329.057L1067.81 329.068Z",
    fill: "black"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M1059.5 333.111V333.742C1059.5 334.89 1059.4 335.965 1059.26 336.968L1047.07 344.011C1046.12 343.639 1045.15 343.173 1044.16 342.604L1043.61 342.284V308.043L1059.5 298.87V323.503L1054.31 320.504C1052.33 319.357 1049.79 320.039 1048.63 322.025C1047.48 324.01 1048.16 326.554 1050.15 327.713L1059.5 333.111Z",
    fill: "black"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M1059.49 323.503V333.111L1050.15 327.712C1048.16 326.564 1047.48 324.02 1048.63 322.025C1049.77 320.039 1052.32 319.356 1054.31 320.504L1059.49 323.503Z",
    fill: "black"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.6 342.284V347.724C1043.6 349.037 1043.53 350.299 1043.37 351.498C1042.58 357.838 1039.75 362.667 1035.2 365.294C1032.87 366.638 1030.28 367.3 1027.51 367.3C1024.74 367.3 1022.05 366.69 1019.17 365.48C1019.33 364.27 1019.4 363.008 1019.4 361.695V356.266L1019.94 356.576C1020.93 357.145 1021.9 357.62 1022.85 357.982C1026.07 359.234 1028.96 359.285 1031.04 358.086C1033.13 356.876 1034.53 354.352 1035.05 350.94C1035.2 349.937 1035.28 348.861 1035.28 347.713V302.831C1035.28 290.617 1026.36 275.146 1015.78 269.044L996.658 258.01C994.672 256.862 993.99 254.318 995.137 252.322C996.285 250.336 998.829 249.654 1000.82 250.802L1019.94 261.847C1033.22 269.51 1043.61 287.515 1043.61 302.841V342.294L1043.6 342.284Z",
    fill: "black"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M1035.29 347.093V347.724C1035.29 348.872 1035.19 349.947 1035.05 350.95L1022.85 357.993C1021.9 357.621 1020.93 357.155 1019.94 356.586L1019.4 356.276V322.025L1035.29 312.852V337.496L1030.1 334.497C1028.12 333.349 1025.57 334.021 1024.42 336.017C1023.27 338.003 1023.95 340.547 1025.94 341.705L1035.29 347.103V347.093Z",
    fill: "black"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M1035.28 337.486V347.083L1025.94 341.684C1023.95 340.536 1023.27 337.992 1024.41 335.996C1025.56 334.011 1028.11 333.328 1030.1 334.476L1035.28 337.475V337.486Z",
    fill: "black"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.4 356.266V361.695C1019.4 363.009 1019.33 364.27 1019.17 365.48C1018.39 371.82 1015.55 376.639 1011 379.266C1008.67 380.61 1006.08 381.272 1003.31 381.272C999.625 381.272 995.644 380.093 991.58 377.746L977.536 369.638C975.55 368.49 974.857 365.946 976.015 363.96C977.163 361.975 979.707 361.282 981.703 362.44L995.747 370.548C996.74 371.117 997.712 371.592 998.664 371.954C1001.88 373.206 1004.78 373.268 1006.85 372.058C1008.94 370.858 1010.34 368.324 1010.86 364.912C1011.01 363.908 1011.09 362.833 1011.09 361.685V316.802C1011.09 304.599 1002.17 289.118 991.59 283.016L972.468 271.982C970.483 270.834 969.8 268.29 970.948 266.294C972.096 264.308 974.64 263.626 976.626 264.774L995.747 275.808C1009.03 283.471 1019.41 301.476 1019.41 316.802V356.266H1019.4Z",
    fill: "black"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.07 361.064V361.695C1011.07 362.843 1010.98 363.919 1010.84 364.922L998.643 371.964C997.692 371.592 996.72 371.127 995.727 370.558L981.683 362.45C979.697 361.302 977.153 361.985 975.995 363.97C974.847 365.956 975.53 368.5 977.515 369.648L990.08 376.908L976.005 385.036C968.146 389.576 961.775 384.757 961.775 374.271C961.775 363.784 968.146 351.612 976.005 347.072L1011.07 326.834V351.478L1005.89 348.479C1003.91 347.331 1001.36 348.003 1000.2 349.999C999.057 351.984 999.74 354.528 1001.73 355.687L1011.07 361.085V361.064Z",
    fill: "black"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.08 351.467V361.064L1001.73 355.666C999.741 354.518 999.048 351.974 1000.21 349.978C1001.35 347.993 1003.9 347.31 1005.89 348.458L1011.08 351.457V351.467Z",
    fill: "black"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M990.08 376.908L976.005 385.036C968.146 389.576 961.775 384.757 961.775 374.271C961.775 363.784 968.146 351.612 976.005 347.072L1011.07 326.834",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.4 322.014L1035.29 312.841",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.6 308.043L1059.49 298.87",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M1067.81 297.029C1071.77 298.115 1074.41 302.51 1074.41 309.243C1074.41 315.975 1071.9 322.914 1068.17 328.53C1068.05 328.706 1067.93 328.892 1067.8 329.068",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M1059.25 336.968L1047.05 344.011",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M1035.05 350.95L1022.85 357.993",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M1010.84 364.922L998.645 371.965",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.16 365.48C1018.36 371.82 1015.54 376.639 1010.99 379.266C1008.66 380.61 1006.07 381.272 1003.3 381.272C999.616 381.272 995.634 380.093 991.57 377.746L977.526 369.638C975.54 368.49 974.847 365.946 976.006 363.96C977.154 361.975 979.698 361.282 981.694 362.44L995.737 370.548C996.73 371.117 997.702 371.582 998.654 371.954C1001.87 373.206 1004.77 373.268 1006.84 372.058C1008.93 370.858 1010.33 368.324 1010.85 364.912C1011 363.908 1011.08 362.833 1011.08 361.685V316.802C1011.08 304.599 1002.16 289.118 991.58 283.016L972.458 271.982C970.473 270.834 969.79 268.29 970.938 266.294C972.086 264.308 974.63 263.626 976.616 264.774L995.737 275.808C1009.02 283.471 1019.4 301.476 1019.4 316.802V361.685C1019.4 362.998 1019.33 364.26 1019.17 365.47L1019.16 365.48Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.4 356.266L1019.94 356.576C1020.93 357.145 1021.9 357.62 1022.85 357.982C1026.07 359.234 1028.96 359.285 1031.04 358.086C1033.13 356.876 1034.53 354.352 1035.05 350.94C1035.2 349.937 1035.28 348.861 1035.28 347.713V302.831C1035.28 290.617 1026.36 275.146 1015.78 269.044L996.658 258.01C994.672 256.862 993.99 254.318 995.137 252.322C996.285 250.336 998.829 249.654 1000.82 250.802L1019.94 261.847C1033.22 269.51 1043.61 287.515 1043.61 302.841V347.724C1043.61 349.037 1043.53 350.299 1043.38 351.498C1042.58 357.838 1039.76 362.667 1035.21 365.294C1032.88 366.638 1030.29 367.3 1027.52 367.3C1024.75 367.3 1022.06 366.69 1019.18 365.48",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.08 361.064L1001.73 355.666C999.741 354.518 999.048 351.974 1000.21 349.978C1001.35 347.993 1003.9 347.31 1005.89 348.458L1011.08 351.457",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M1043.6 342.284L1044.15 342.604C1045.14 343.173 1046.11 343.649 1047.05 344.011C1050.27 345.262 1053.16 345.314 1055.24 344.114C1057.33 342.904 1058.73 340.381 1059.25 336.968C1059.4 335.965 1059.48 334.89 1059.48 333.742V288.849C1059.48 276.646 1050.56 261.174 1039.98 255.063L1020.86 244.028C1018.87 242.88 1018.19 240.336 1019.34 238.34C1020.49 236.355 1023.03 235.662 1025.02 236.82L1044.14 247.865C1057.41 255.528 1067.8 273.533 1067.8 288.849V333.742C1067.8 335.055 1067.73 336.317 1067.57 337.516C1066.78 343.856 1063.95 348.685 1059.39 351.312C1057.06 352.657 1054.47 353.318 1051.7 353.318C1048.93 353.318 1046.24 352.708 1043.36 351.488",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M1035.28 347.093L1025.94 341.694C1023.95 340.546 1023.27 338.002 1024.41 336.006C1025.56 334.021 1028.11 333.338 1030.1 334.486L1035.28 337.485",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M1067.81 328.312L1068.36 328.633C1072.72 331.146 1076.75 331.694 1079.45 330.143C1082.15 328.581 1083.69 324.807 1083.69 319.77V274.887C1083.69 262.684 1074.77 247.203 1064.19 241.101L1045.07 230.056C1043.08 228.909 1042.4 226.365 1043.55 224.379C1044.7 222.393 1047.24 221.7 1049.23 222.859L1068.35 233.904C1081.62 241.567 1092.01 259.572 1092.01 274.887V319.77C1092.01 327.981 1089.03 334.228 1083.61 337.351C1081.28 338.685 1078.69 339.357 1075.92 339.357C1073.15 339.357 1070.46 338.747 1067.58 337.527",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M1059.49 333.111L1050.15 327.712C1048.16 326.564 1047.48 324.02 1048.63 322.025C1049.77 320.039 1052.32 319.356 1054.31 320.504L1059.49 323.503",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M898.185 347.061C906.045 351.601 912.426 363.784 912.426 374.26C912.426 384.736 906.045 389.566 898.185 385.026L884.11 376.897L896.685 369.637C898.671 368.479 899.354 365.945 898.195 363.96C897.058 361.964 894.514 361.281 892.518 362.429L878.464 370.547C877.481 371.106 876.509 371.581 875.558 371.954L863.365 364.921C863.21 363.918 863.127 362.832 863.127 361.695V361.064L872.486 355.676C874.472 354.518 875.154 351.974 873.996 349.988C872.858 347.992 870.314 347.32 868.318 348.468L863.127 351.457V326.813L898.195 347.051L898.185 347.061Z",
    fill: "black"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M903.274 266.304C904.412 268.289 903.74 270.844 901.744 271.992L882.622 283.026C872.053 289.138 863.108 304.599 863.108 316.812V361.695C863.108 362.833 863.19 363.919 863.346 364.922C863.863 368.334 865.259 370.868 867.348 372.068C869.437 373.267 872.322 373.226 875.538 371.964C876.49 371.602 877.462 371.127 878.444 370.558L892.499 362.44C894.495 361.292 897.039 361.974 898.176 363.97C899.334 365.956 898.652 368.49 896.666 369.648L882.612 377.756C878.558 380.103 874.566 381.282 870.885 381.282C868.113 381.282 865.517 380.62 863.19 379.276C858.65 376.649 855.806 371.82 855.021 365.48C854.865 364.28 854.793 363.008 854.793 361.695V316.812C854.793 301.486 865.197 283.481 878.465 275.818L897.587 264.784C899.572 263.636 902.116 264.308 903.274 266.304Z",
    fill: "black"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M863.365 364.922L875.558 371.954C872.342 373.216 869.446 373.267 867.367 372.058C865.278 370.858 863.893 368.324 863.365 364.911V364.922Z",
    fill: "black"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M873.986 349.988C875.145 351.974 874.462 354.518 872.476 355.676L863.117 361.064V351.467L868.309 348.479C870.305 347.331 872.849 348.003 873.986 349.999V349.988Z",
    fill: "black"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M855.03 365.48C852.145 366.7 849.343 367.3 846.695 367.3C844.048 367.3 841.328 366.638 839.001 365.294C834.461 362.667 831.617 357.837 830.831 351.498C830.676 350.298 830.604 349.037 830.604 347.723V302.83C830.604 287.504 840.997 269.51 854.276 261.846L873.397 250.802C875.383 249.664 877.937 250.336 879.085 252.332C880.223 254.318 879.55 256.872 877.555 258.02L858.433 269.055C847.864 275.166 838.929 290.627 838.929 302.841V347.734C838.929 348.871 839.001 349.957 839.156 350.95C839.673 354.363 841.069 356.896 843.158 358.096C845.237 359.296 848.133 359.234 851.349 357.993C852.3 357.62 853.272 357.155 854.265 356.586L854.803 356.266V361.695C854.803 363.008 854.875 364.27 855.03 365.48Z",
    fill: "black"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M854.855 238.35C856.003 240.336 855.32 242.88 853.334 244.038L834.213 255.073C823.644 261.185 814.708 276.645 814.708 288.848V333.741C814.708 334.879 814.791 335.965 814.946 336.958C815.463 340.37 816.859 342.904 818.949 344.104C821.038 345.303 823.923 345.241 827.139 344C828.08 343.638 829.052 343.163 830.045 342.594L830.583 342.273V347.713C830.583 349.026 830.655 350.288 830.81 351.488C827.935 352.708 825.122 353.318 822.475 353.318C819.828 353.318 817.097 352.656 814.781 351.312C810.22 348.685 807.397 343.856 806.601 337.516C806.456 336.317 806.373 335.055 806.373 333.741V288.848C806.373 273.533 816.766 255.528 830.045 247.865L849.167 236.82C851.163 235.672 853.707 236.354 854.855 238.35Z",
    fill: "black"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M854.804 322.025V356.276L854.266 356.597C853.274 357.155 852.301 357.631 851.35 358.003L839.157 350.96C839.002 349.957 838.93 348.882 838.93 347.744V347.113L848.279 341.725C850.274 340.567 850.947 338.023 849.799 336.038C848.64 334.042 846.107 333.369 844.121 334.517L838.93 337.506V312.862L854.814 322.035L854.804 322.025Z",
    fill: "black"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M839.154 350.94L851.347 357.982C848.131 359.234 845.235 359.285 843.157 358.086C841.067 356.886 839.682 354.352 839.154 350.94Z",
    fill: "black"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M849.785 336.017C850.933 338.002 850.261 340.546 848.265 341.705L838.916 347.093V337.496L844.107 334.507C846.093 333.359 848.627 334.031 849.785 336.027V336.017Z",
    fill: "black"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M830.593 308.043V342.284L830.055 342.604C829.063 343.163 828.09 343.639 827.149 344.011L814.957 336.968C814.812 335.965 814.719 334.89 814.719 333.752V333.121L824.068 327.733C826.053 326.575 826.746 324.031 825.588 322.045C824.44 320.049 821.906 319.377 819.9 320.515L814.719 323.503V298.859L830.614 308.032L830.593 308.043Z",
    fill: "black"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M814.945 336.968L827.138 344.011C823.922 345.262 821.026 345.314 818.948 344.114C816.859 342.915 815.462 340.381 814.945 336.968Z",
    fill: "black"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M825.578 322.045C826.736 324.031 826.043 326.575 824.058 327.733L814.709 333.121V323.514L819.89 320.525C821.886 319.388 824.43 320.06 825.578 322.056V322.045Z",
    fill: "black"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M806.383 328.312V329.067C806.259 328.891 806.135 328.705 806.021 328.529L806.383 328.312Z",
    fill: "black"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M806.383 297.029V328.312L806.021 328.529C802.257 322.945 799.785 315.758 799.785 309.242C799.785 302.727 802.422 298.104 806.383 297.029Z",
    fill: "black"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M806.384 329.067V333.752C806.384 335.065 806.456 336.327 806.611 337.527C803.736 338.747 800.923 339.357 798.276 339.357C795.504 339.357 792.898 338.685 790.582 337.351C785.163 334.228 782.174 327.971 782.174 319.77V274.877C782.174 259.561 792.567 241.556 805.846 233.893L824.967 222.848C826.953 221.7 829.497 222.383 830.655 224.379C831.793 226.365 831.11 228.909 829.125 230.057L810.003 241.101C799.424 247.203 790.488 262.674 790.488 274.877V319.77C790.488 324.807 792.04 328.592 794.739 330.143C797.428 331.694 801.482 331.146 805.835 328.633L806.011 328.53C806.135 328.705 806.249 328.891 806.373 329.067H806.384Z",
    fill: "black"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M884.111 376.907L898.186 385.036C906.045 389.576 912.426 384.757 912.426 374.27C912.426 363.784 906.045 351.612 898.186 347.072L863.117 326.833",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M854.801 322.024L838.916 312.851",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M830.592 308.043L814.707 298.87",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M806.383 297.029C802.422 298.104 799.785 302.5 799.785 309.242C799.785 315.985 802.236 322.945 806.021 328.529C806.145 328.705 806.259 328.891 806.383 329.067",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M814.945 336.968L827.138 344.011",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M839.154 350.94L851.347 357.982",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M863.365 364.922L875.558 371.964",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M855.03 365.48C855.837 371.82 858.66 376.649 863.2 379.276C865.527 380.62 868.133 381.282 870.894 381.282C874.576 381.282 878.568 380.103 882.622 377.756L896.676 369.648C898.662 368.49 899.344 365.956 898.186 363.97C897.048 361.974 894.504 361.292 892.508 362.44L878.454 370.558C877.472 371.116 876.499 371.592 875.548 371.964C872.321 373.216 869.436 373.278 867.357 372.068C865.268 370.868 863.883 368.334 863.355 364.922C863.2 363.919 863.117 362.833 863.117 361.695V316.812C863.117 304.599 872.053 289.128 882.632 283.026L901.754 271.992C903.75 270.844 904.422 268.289 903.284 266.304C902.126 264.308 899.582 263.636 897.596 264.784L878.475 275.818C865.206 283.481 854.803 301.486 854.803 316.812V361.695C854.803 363.008 854.885 364.27 855.03 365.48Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M854.803 356.266L854.265 356.586C853.272 357.145 852.29 357.62 851.349 357.993C848.133 359.244 845.237 359.296 843.158 358.096C841.069 356.896 839.683 354.363 839.156 350.95C839.001 349.947 838.929 348.871 838.929 347.734V302.841C838.929 290.627 847.864 275.166 858.433 269.055L877.555 258.02C879.55 256.872 880.223 254.318 879.085 252.332C877.937 250.336 875.383 249.664 873.397 250.802L854.276 261.846C841.007 269.51 830.604 287.504 830.604 302.83V347.723C830.604 349.037 830.676 350.298 830.831 351.498C831.638 357.848 834.461 362.667 839.001 365.294C841.328 366.638 843.924 367.3 846.695 367.3C849.467 367.3 852.155 366.69 855.03 365.48",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M863.117 361.064L872.476 355.676C874.462 354.518 875.145 351.974 873.986 349.988C872.849 347.992 870.305 347.32 868.309 348.468L863.117 351.457",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M830.593 342.284L830.055 342.605C829.062 343.163 828.09 343.639 827.149 344.011C823.933 345.262 821.037 345.314 818.958 344.114C816.869 342.915 815.473 340.381 814.956 336.968C814.801 335.965 814.718 334.89 814.718 333.752V288.859C814.718 276.656 823.653 261.195 834.222 255.083L853.344 244.049C855.33 242.891 856.012 240.346 854.864 238.361C853.716 236.365 851.172 235.682 849.176 236.83L830.055 247.875C816.787 255.538 806.383 273.533 806.383 288.859V333.752C806.383 335.065 806.455 336.327 806.61 337.527C807.396 343.877 810.23 348.696 814.791 351.323C817.107 352.667 819.713 353.329 822.485 353.329C825.256 353.329 827.955 352.719 830.82 351.498",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M838.916 347.093L848.265 341.705C850.261 340.547 850.933 338.003 849.785 336.017C848.627 334.021 846.093 333.349 844.107 334.497L838.916 337.485",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M806.383 328.312L806.021 328.53L805.845 328.633C801.481 331.156 797.438 331.694 794.749 330.143C792.05 328.581 790.498 324.807 790.498 319.77V274.877C790.498 262.674 799.433 247.203 810.013 241.101L829.135 230.057C831.12 228.909 831.803 226.365 830.665 224.379C829.507 222.383 826.963 221.7 824.977 222.848L805.856 233.893C792.587 241.546 782.184 259.551 782.184 274.877V319.77C782.184 327.981 785.172 334.228 790.591 337.351C792.918 338.685 795.514 339.357 798.286 339.357C801.057 339.357 803.746 338.747 806.621 337.527",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M814.707 333.111L824.056 327.723C826.041 326.565 826.734 324.021 825.576 322.035C824.428 320.039 821.894 319.367 819.888 320.505L814.707 323.493",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M1101.86 44.3626V19.1704L1088 8.15656V33.3384L1101.86 44.3626Z",
    fill: "black"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.46 31.9111V6.71887L1101.87 19.1702V44.3624L1111.46 31.9111Z",
    fill: "black"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M1088 8.15636L1101.86 19.1702L1111.46 6.71887L1088 8.15636Z",
    fill: "black"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M1101.86 19.1702L1111.46 6.71887L1088 8.15636L1101.86 19.1702Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M1088 8.15636V33.3382L1101.86 44.3624L1111.46 31.9111V6.71887",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M1101.87 19.1703V44.3625",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5369 -48.9919L-44.6406 12.3133C-44.1442 -10.2108 -39.5629 -34.5447 -30.6174 -31.7628C-28.9834 -31.256 -27.5356 -29.7255 -26.0671 -29.2704C-16.3356 -26.2507 -20.162 -81.5681 -4.73228 -76.7799C0.572979 -75.1356 3.18941 -57.3893 8.68082 -55.683C19.4051 -52.3529 21.0908 -92.5198 28.6298 -90.1826C31.3704 -89.3346 33.3456 -82.0851 36.293 -81.1647C41.1535 -79.6549 44.1216 -100.917 49.1786 -99.3453C54.4012 -97.7217 59.0756 -69.5097 61.5266 -48.9816L61.5369 -48.9919Z",
    fill: "#FBB93E"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5363 -48.9917C59.075 -69.5095 54.4006 -97.7214 49.1884 -99.3554C44.1314 -100.927 41.1633 -79.665 36.3027 -81.1748C33.3554 -82.0849 31.3801 -89.3344 28.6396 -90.1927C21.1005 -92.5403 19.4149 -52.363 8.69059 -55.6931C3.19918 -57.3994 0.582751 -75.1457 -4.72251 -76.79C-20.1522 -81.5782 -16.3258 -26.2608 -26.0573 -29.2805C-27.5155 -29.7356 -28.9736 -31.2558 -30.6076 -31.7729C-39.5635 -34.5548 -44.1345 -10.2209 -44.6309 12.3032L61.5467 -49.002L61.5363 -48.9917Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3456 88.3665L99.2422 88.4285C99.2422 88.4285 99.3146 88.3871 99.3456 88.3665Z",
    fill: "black"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1588 88.47L98.9727 88.5837C99.045 88.5424 99.1071 88.5113 99.1588 88.47Z",
    fill: "black"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9321 88.6042L98.8184 88.6663L98.8804 88.6249C98.8804 88.6249 98.9218 88.6042 98.9425 88.6042H98.9321Z",
    fill: "black"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8688 88.6351L98.8068 88.6764L98.7344 88.7178C98.7344 88.7178 98.8275 88.6661 98.8585 88.6454L98.8688 88.6351Z",
    fill: "black"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7247 88.7179C98.7247 88.7179 98.6939 88.7384 98.6836 88.7384C98.7041 88.7282 98.7144 88.7179 98.7247 88.7179Z",
    fill: "black"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M91.766 22.2211V89.4106C91.766 91.572 91.0317 93.1129 89.8321 93.8679C89.8321 93.8679 89.8321 93.8679 89.8217 93.8679C89.7907 93.8885 89.7494 93.9092 89.7183 93.9299C88.4566 94.6642 86.7089 94.5504 84.7854 93.4439L53.3261 75.2736L43.6464 94.6642L33.9769 64.1047L2.51771 45.9448C-1.33972 43.7317 -4.46289 38.323 -4.46289 33.8761V-33.3135C-4.46289 -35.5266 -3.68727 -37.0882 -2.42559 -37.8224C-1.16391 -38.5567 0.583815 -38.4533 2.50736 -37.3364L84.775 10.1524C88.6221 12.3862 91.7556 17.7845 91.7556 22.2314L91.766 22.2211Z",
    fill: "black"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M2.51695 -37.3465C0.593403 -38.4634 -1.15434 -38.5669 -2.41602 -37.8326L6.68462 -43.0862C7.9463 -43.8204 9.69404 -43.717 11.6176 -42.6001L93.8852 4.89902C97.7427 7.12247 100.866 12.5208 100.866 16.9677V84.1573C100.866 86.3497 100.09 87.8699 98.8802 88.6352C98.8389 88.6559 98.8079 88.6869 98.7561 88.7076H98.7355C98.7355 88.7076 98.7148 88.7283 98.6941 88.7489C98.6838 88.7593 98.6734 88.7593 98.6734 88.7593L89.8417 93.8577C91.0413 93.1028 91.7756 91.5619 91.7756 89.4005V22.2109C91.7756 17.764 88.642 12.3657 84.795 10.1319L2.52728 -37.3569L2.51695 -37.3465Z",
    fill: "black"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7086 93.92C88.4366 94.6439 86.6992 94.5405 84.7756 93.434L53.3164 75.2637L43.6366 94.6543L33.9672 64.0947L2.50794 45.9348C-1.34948 43.7217 -4.47266 38.3131 -4.47266 33.8662V-33.3234C-4.47266 -35.5365 -3.69703 -37.0981 -2.43535 -37.8324C-1.17367 -38.5666 0.574065 -38.4632 2.49761 -37.3463L84.7653 10.1425C88.6124 12.3763 91.7459 17.7746 91.7459 22.2215V89.4111C91.7459 91.5725 91.0116 93.1134 89.812 93.8683",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8182 88.6666C98.8182 88.6666 98.8596 88.6356 98.8802 88.6252C100.09 87.86 100.866 86.3397 100.866 84.1473V16.9577C100.866 12.5108 97.7427 7.11252 93.8852 4.88907L11.6176 -42.61C9.6837 -43.7269 7.9463 -43.8304 6.68462 -43.0961L-2.41602 -37.8426",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7247 88.7185C98.7247 88.7185 98.6939 88.739 98.6836 88.739L98.7247 88.7185Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9322 88.6044L98.7461 88.7078",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1588 88.4701L98.9727 88.5839",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M99.449 88.3044C99.449 88.3044 99.4387 88.3044 99.4077 88.3251C99.4387 88.3044 99.3973 88.3251 99.3973 88.3251C99.387 88.3251 99.3663 88.3458 99.3456 88.3458L99.2422 88.4079",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2422 88.4185C99.2422 88.4185 99.3146 88.3771 99.3456 88.3564",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2429 88.4186L99.1602 88.4703",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9727 88.5839C99.045 88.5425 99.1071 88.5115 99.1588 88.4701",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9747 88.5837C98.9747 88.5837 98.9541 88.594 98.9336 88.6043L98.9747 88.5837Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7461 88.7081C98.7461 88.7081 98.8392 88.6564 98.8702 88.6357C98.8909 88.6357 98.9116 88.615 98.9322 88.615",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7446 88.7079L98.7246 88.718",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M89.709 93.9201C89.709 93.9201 89.7814 93.8788 89.8124 93.8581H89.8227L98.6545 88.7597C98.6545 88.7597 98.6545 88.7597 98.6752 88.7493C98.6959 88.739 98.7062 88.7286 98.7166 88.7286",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1217 -7.97665V8.84918L17.7503 6.89461V-6.79771L14.834 -8.48339V-11.6066L21.1217 -7.97665Z",
    fill: "#459AA4"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6872 11.3104C25.7461 10.0797 25.0015 8.65256 24.474 7.03926C23.9363 5.42597 23.6777 3.70926 23.6777 1.89947C23.6777 0.0896869 23.9466 -1.31677 24.474 -2.30957C25.0118 -3.30237 25.7461 -3.8815 26.6872 -4.02629C27.6282 -4.17107 28.7038 -3.89184 29.9137 -3.19895C31.1237 -2.50606 32.1992 -1.53395 33.1403 -0.3033C34.0814 0.927354 34.826 2.3545 35.3534 3.9678C35.8912 5.58109 36.1498 7.2978 36.1498 9.10759C36.1498 10.9174 35.8809 12.3238 35.3534 13.3166C34.8157 14.3094 34.0814 14.8886 33.1403 15.0333C32.1992 15.1781 31.1237 14.8989 29.9137 14.206C28.7038 13.5131 27.6282 12.541 26.6872 11.3104ZM32.0027 10.8036C32.5095 10.2141 32.7577 9.00417 32.7577 7.15301C32.7577 5.30186 32.5095 3.80233 32.0027 2.62338C31.496 1.44444 30.8031 0.606768 29.9137 0.0896869C29.0347 -0.417053 28.3521 -0.375692 27.8454 0.213781C27.3387 0.803254 27.0801 2.02357 27.0801 3.86438C27.0801 5.70519 27.3387 7.21507 27.8454 8.39401C28.3521 9.57296 29.045 10.4106 29.9137 10.9174C30.8031 11.4345 31.496 11.3931 32.0027 10.8036Z",
    fill: "#FBB93E"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8239 19.47C39.8828 18.2394 39.1382 16.8122 38.6107 15.1989C38.073 13.5856 37.8145 11.8689 37.8145 10.0591C37.8145 8.24935 38.0833 6.84289 38.6107 5.8501C39.1485 4.8573 39.8828 4.27817 40.8239 4.13338C41.7649 3.9886 42.8405 4.26783 44.0505 4.96072C45.2604 5.65361 46.3359 6.62571 47.277 7.85637C48.2181 9.08702 48.9627 10.5142 49.4901 12.1275C50.0279 13.7408 50.2865 15.4575 50.2865 17.2673C50.2865 19.077 50.0176 20.4835 49.4901 21.4763C48.9524 22.4691 48.2181 23.0482 47.277 23.193C46.3359 23.3378 45.2604 23.0586 44.0505 22.3657C42.8405 21.6728 41.7649 20.7007 40.8239 19.47ZM46.1395 18.9633C46.6462 18.3738 46.8944 17.1638 46.8944 15.3127C46.8944 13.4615 46.6462 11.962 46.1395 10.7831C45.6327 9.6041 44.9398 8.76644 44.0505 8.24935C43.1714 7.74261 42.4889 7.78398 41.9821 8.37345C41.4754 8.96292 41.2272 10.1832 41.2272 12.0241C41.2272 13.8649 41.4857 15.3747 41.9821 16.5537C42.4889 17.7326 43.1818 18.5703 44.0505 19.077C44.9398 19.5941 45.6327 19.5528 46.1395 18.9633Z",
    fill: "black"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4303 12.9859V29.8117L54.0589 27.8571V14.1545L51.1426 12.4791V9.35596L57.4303 12.9859Z",
    fill: "#459AA4"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9957 32.2729C62.0547 31.0422 61.3101 29.6151 60.7826 28.0018C60.2449 26.3885 59.9863 24.6718 59.9863 22.862C59.9863 21.0522 60.2552 19.6457 60.7826 18.6529C61.3204 17.6601 62.0547 17.081 62.9957 16.9362C63.9368 16.7915 65.0124 17.0707 66.2223 17.7636C67.4323 18.4565 68.5078 19.4286 69.4489 20.6592C70.39 21.8899 71.1346 23.317 71.662 24.9303C72.1998 26.5436 72.4583 28.2603 72.4583 30.0701C72.4583 31.8799 72.1895 33.2864 71.662 34.2792C71.1243 35.272 70.39 35.8511 69.4489 35.9959C68.5078 36.1406 67.4323 35.8614 66.2223 35.1685C65.0124 34.4756 63.9368 33.5035 62.9957 32.2729ZM68.3113 31.7558C68.8181 31.1663 69.0663 29.946 69.0663 28.1052C69.0663 26.2644 68.8181 24.7545 68.3113 23.5756C67.8046 22.3966 67.1117 21.5589 66.2223 21.0419C65.3433 20.5351 64.6607 20.5765 64.154 21.166C63.6473 21.7554 63.3991 22.9757 63.3991 24.8166C63.3991 26.6574 63.6576 28.1672 64.154 29.3462C64.6607 30.5251 65.3536 31.3628 66.2223 31.8696C67.1117 32.3866 67.8046 32.3453 68.3113 31.7558Z",
    fill: "#FBB93E"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M18.527 32.6041C17.5859 31.3735 16.8413 29.9463 16.3139 28.333C15.7761 26.7197 15.5176 25.003 15.5176 23.1932C15.5176 21.3834 15.7865 19.977 16.3139 18.9842C16.8517 17.9914 17.5859 17.4123 18.527 17.2675C19.4681 17.1227 20.5436 17.4019 21.7536 18.0948C22.9635 18.7877 24.0391 19.7598 24.9802 20.9905C25.9213 22.2211 26.6659 23.6483 27.1933 25.2616C27.7311 26.8748 27.9896 28.5916 27.9896 30.4014C27.9896 32.2111 27.7207 33.6176 27.1933 34.6104C26.6555 35.6032 25.9213 36.1823 24.9802 36.3271C24.0391 36.4719 22.9635 36.1927 21.7536 35.4998C20.5436 34.8069 19.4681 33.8348 18.527 32.6041ZM23.8426 32.0974C24.3493 31.5079 24.5975 30.2979 24.5975 28.4468C24.5975 26.5956 24.3493 25.0961 23.8426 23.9171C23.3359 22.7382 22.643 21.9005 21.7536 21.3834C20.8745 20.8767 20.192 20.9181 19.6853 21.5075C19.1785 22.097 18.9303 23.3173 18.9303 25.1581C18.9303 26.9989 19.1785 28.5088 19.6853 29.6878C20.192 30.8667 20.8849 31.7044 21.7536 32.2111C22.643 32.7282 23.3359 32.6869 23.8426 32.0974Z",
    fill: "black"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1354 26.12V42.9458L31.764 40.9912V27.2886L28.8477 25.6132V22.4901L35.1354 26.12Z",
    fill: "#459AA4"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6989 45.4069C39.7578 44.1763 39.0132 42.7491 38.4858 41.1358C37.948 39.5225 37.6895 37.8058 37.6895 35.996C37.6895 34.1862 37.9583 32.7798 38.4858 31.787C39.0235 30.7942 39.7578 30.2151 40.6989 30.0703C41.64 29.9255 42.7155 30.2047 43.9255 30.8976C45.1354 31.5905 46.211 32.5626 47.1521 33.7933C48.0931 35.0239 48.8377 36.4511 49.3652 38.0643C49.9029 39.6776 50.1615 41.3944 50.1615 43.2041C50.1615 45.0139 49.8926 46.4204 49.3652 47.4132C48.8274 48.406 48.0931 48.9851 47.1521 49.1299C46.211 49.2747 45.1354 48.9955 43.9255 48.3026C42.7155 47.6097 41.64 46.6376 40.6989 45.4069ZM46.0145 44.8898C46.5212 44.3004 46.7694 43.08 46.7694 41.2392C46.7694 39.3984 46.5212 37.8885 46.0145 36.7096C45.5077 35.5307 44.8148 34.693 43.9255 34.1759C43.0464 33.6692 42.3639 33.7105 41.8571 34.3C41.3504 34.8895 41.1022 36.1098 41.1022 37.9506C41.1022 39.7914 41.3607 41.3013 41.8571 42.4802C42.3639 43.6592 43.0568 44.4968 43.9255 44.9932C44.8148 45.5103 45.5077 45.469 46.0145 44.8795V44.8898Z",
    fill: "#FBB93E"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3072 38.9121V55.738L53.9359 53.7938V40.0911L51.0195 38.4054V35.2822L57.3072 38.9121Z",
    fill: "#459AA4"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M62.861 58.2097C61.9199 56.9791 61.1753 55.5519 60.6479 53.9386C60.1101 52.3253 59.8516 50.6086 59.8516 48.7988C59.8516 46.989 60.1204 45.5826 60.6479 44.5898C61.1856 43.597 61.9199 43.0179 62.861 42.8731C63.8021 42.7283 64.8776 43.0075 66.0876 43.7004C67.2975 44.3933 68.3731 45.3654 69.3141 46.596C70.2552 47.8267 70.9998 49.2538 71.5273 50.8671C72.065 52.4804 72.3236 54.1972 72.3236 56.0069C72.3236 57.8167 72.0547 59.2232 71.5273 60.216C70.9895 61.2088 70.2552 61.7879 69.3141 61.9327C68.3731 62.0775 67.2975 61.7982 66.0876 61.1054C64.8776 60.4125 63.8021 59.4404 62.861 58.2097ZM68.1869 57.6926C68.6937 57.1032 68.9418 55.8828 68.9418 54.042C68.9418 52.2012 68.6937 50.6913 68.1869 49.5124C67.6802 48.3334 66.9873 47.4958 66.0979 46.9787C65.2189 46.472 64.5363 46.5133 64.0296 47.1028C63.5228 47.6923 63.2746 48.9126 63.2746 50.7534C63.2746 52.5942 63.5332 54.1041 64.0296 55.283C64.5363 56.462 65.2292 57.2996 66.0979 57.8064C66.9873 58.3235 67.6802 58.2821 68.1869 57.6926Z",
    fill: "#FBB93E"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M231.429 -28.9703V-15.0712L197.209 4.69169V-9.20746L219.392 -22.0207V-22.0311L231.429 -28.9703Z",
    fill: "black"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M197.21 -9.20744V4.69172L167.498 -12.465V-26.3642L197.21 -9.20744Z",
    fill: "black"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M231.431 -28.9703L219.393 -22.0311V-22.0207L197.21 -9.20746L167.499 -26.3642L155.461 -19.4146L197.21 4.69169L231.431 -15.0712L250.976 -3.77811L263.014 -10.738L231.431 -28.9703Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M197.209 -9.20758V4.69157",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0817 153.621L53.7605 155.421C51.3302 162.836 46.5627 169.672 41.0817 172.836C33.129 177.428 26.6758 172.547 26.6758 161.946C26.6758 151.346 33.129 139.009 41.0817 134.417V153.632V153.621Z",
    fill: "black"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1443 109.546V171.058L18 197.698V136.186L64.1443 109.546ZM53.7614 155.431C54.8576 152.081 55.4781 148.616 55.4781 145.317C55.4781 134.707 49.0249 129.826 41.0722 134.417C33.1195 139.009 26.6663 151.336 26.6663 161.947C26.6663 172.557 33.1195 177.428 41.0722 172.836C46.5532 169.672 51.3207 162.846 53.751 155.421L53.7614 155.431Z",
    fill: "#459AA4"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4776 145.307C55.4776 148.606 54.8571 152.07 53.7609 155.421L41.082 153.621V134.407C49.0347 129.815 55.4879 134.696 55.4879 145.307H55.4776Z",
    fill: "black"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7591 155.432C54.8554 152.081 55.4758 148.616 55.4758 145.317C55.4758 134.707 49.0227 129.826 41.07 134.417C33.1172 139.009 26.6641 151.336 26.6641 161.947C26.6641 172.557 33.1172 177.428 41.07 172.836C46.551 169.672 51.3185 162.846 53.7488 155.421L53.7591 155.432Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M41.082 134.417V153.621L53.7609 155.431",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1438 171.068L18.0098 197.698V136.186L64.1438 109.546V171.068Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M473.608 -3.89257C473.102 0.182029 470.589 4.17389 466.069 7.57629C467.683 5.48728 468.758 2.8088 468.758 0.461251C468.758 -3.14798 466.225 -4.61649 463.091 -2.80671C459.968 -1.00726 457.424 3.38793 457.424 6.99716C457.424 9.44813 458.592 10.896 460.309 11.0407C457.951 12.1783 455.407 13.1091 452.739 13.8537C452.346 12.7781 452.129 11.5061 452.129 10.0583C452.129 3.07768 457.031 -5.43348 463.081 -8.91861C468.169 -11.8556 472.45 -10.3251 473.681 -5.61963C473.681 -5.54724 473.681 -5.47485 473.691 -5.39211C473.691 -4.89572 473.66 -4.38897 473.598 -3.89257H473.608Z",
    fill: "black"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M468.749 0.461225C468.749 2.80878 467.673 5.48726 466.06 7.57626C465.077 8.31052 464.002 9.0241 462.833 9.6963C462.016 10.172 461.168 10.6167 460.299 11.0304C458.583 10.8959 457.414 9.43776 457.414 6.98679C457.414 3.37756 459.958 -1.01763 463.081 -2.81708C466.215 -4.62686 468.749 -3.15835 468.749 0.450881V0.461225Z",
    fill: "black"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M426.803 11.8993C426.803 12.9852 426.854 14.1021 426.968 15.2293C423.576 14.7122 420.298 13.8952 417.237 12.8197C416.906 10.5756 416.751 8.41419 416.771 6.33552C416.802 3.53294 419.481 2.84004 422.439 4.82564C422.48 4.84632 422.511 4.87735 422.532 4.89804C425.014 6.56304 426.813 9.55177 426.792 11.9097L426.803 11.8993Z",
    fill: "black"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M426.968 15.2396C435.489 16.5737 444.673 16.0979 452.739 13.8538C455.407 13.1092 457.951 12.1785 460.309 11.0409C461.178 10.6272 462.026 10.1825 462.843 9.70682C464.001 9.03462 465.087 8.32105 466.07 7.58679C470.589 4.1844 473.102 0.18218 473.609 -3.88208C473.743 -3.77866 473.878 -3.67524 474.012 -3.57183C481.437 2.13675 484.716 8.94154 483.599 15.6636C482.585 21.7341 478.056 27.6599 469.989 32.324C451.56 42.9655 421.673 42.9655 403.244 32.324C395.178 27.6599 390.648 21.7445 389.645 15.6636C388.507 8.82778 391.837 1.78513 399.635 -3.88208C399.914 -1.71034 400.752 0.440719 402.169 2.4987C403.978 5.12548 406.709 7.60747 410.411 9.71716C410.649 9.85161 410.887 9.98604 411.125 10.1101C413.038 11.1443 415.085 12.0647 417.257 12.83C420.318 13.9159 423.607 14.7225 426.989 15.2396H426.968Z",
    fill: "black"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M411.611 5.51813C411.342 6.9763 411.177 8.50687 411.104 10.0995C410.866 9.97538 410.629 9.84093 410.391 9.70649C406.688 7.60714 403.958 5.12515 402.148 2.48804C402.262 1.01953 402.459 -0.397278 402.717 -1.76237C403.245 -4.51325 406.037 -4.73043 408.581 -2.22775C408.612 -2.19673 408.633 -2.17604 408.664 -2.14502C410.794 -0.0456655 412.045 3.20161 411.611 5.51813Z",
    fill: "black"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M399.626 -3.89244C399.564 -4.38884 399.533 -4.89558 399.533 -5.39198V-6.50887C399.533 -8.87711 399.854 -11.1109 400.433 -13.1999C405.118 -30.0051 426.794 -38.0508 436.546 -38.0508C437.652 -38.0508 439.297 -37.9888 441.293 -37.7406C451.851 -36.4996 472.204 -30.5842 473.683 -5.60915C472.452 -10.3146 468.171 -11.8452 463.082 -8.90813C457.033 -5.423 452.131 3.07782 452.131 10.0688C452.131 11.5166 452.338 12.7886 452.741 13.8641C444.674 16.1083 435.491 16.5736 426.97 15.2499C426.856 14.1123 426.804 13.0058 426.804 11.9199C426.825 9.57236 425.025 6.57329 422.543 4.90829C422.512 4.8876 422.492 4.85658 422.45 4.8359C419.493 2.8503 416.804 3.54319 416.783 6.34577C416.762 8.42444 416.917 10.5858 417.248 12.83C415.087 12.0647 413.029 11.1546 411.116 10.1101C411.188 8.51751 411.354 6.98695 411.623 5.52878C412.057 3.2226 410.806 -0.0350113 408.675 -2.13436C408.644 -2.16539 408.623 -2.18607 408.592 -2.2171C406.059 -4.71977 403.266 -4.50259 402.729 -1.75172C402.47 -0.386623 402.274 1.03017 402.16 2.49868C400.743 0.451042 399.885 -1.71036 399.626 -3.8821V-3.89244Z",
    fill: "black"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M389.636 15.6534C390.639 21.724 395.179 27.6497 403.235 32.3138C421.664 42.9553 451.551 42.9553 469.98 32.3138C478.046 27.6497 482.576 21.7343 483.589 15.6534L483.807 15.6845C483.807 54.8792 460.207 90.351 436.607 90.351C413.008 90.351 389.408 54.8792 389.408 15.6845L389.636 15.6534Z",
    fill: "black"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M460.31 11.0409C461.179 10.6272 462.027 10.1825 462.844 9.7068C464.002 9.0346 465.088 8.32103 466.071 7.58677C470.59 4.18438 473.103 0.182161 473.61 -3.8821C473.672 -4.3785 473.703 -4.88523 473.703 -5.38163C473.703 -5.45402 473.703 -5.53676 473.692 -5.60915C471.707 -30.5428 451.861 -36.4686 441.302 -37.7406C439.317 -37.9785 437.662 -38.0508 436.556 -38.0508C426.804 -38.0508 405.138 -29.9947 400.443 -13.1999C399.864 -11.1109 399.543 -8.87711 399.543 -6.50887V-5.39198C399.543 -4.89558 399.574 -4.38883 399.636 -3.89244C399.895 -1.72069 400.753 0.430364 402.17 2.48835C403.98 5.11512 406.71 7.59711 410.412 9.7068C410.65 9.84124 410.888 9.97569 411.126 10.0998C413.039 11.134 415.086 12.0544 417.258 12.8196",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M417.236 12.8196C420.297 13.9055 423.586 14.7121 426.968 15.2292C435.489 16.553 444.673 16.0979 452.739 13.8434C455.407 13.0988 457.951 12.1681 460.309 11.0305",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M399.626 -3.8927C391.829 1.77451 388.509 8.80682 389.636 15.653C390.639 21.7235 395.179 27.6493 403.235 32.3133C421.664 42.9549 451.551 42.9549 469.98 32.3133C478.047 27.6493 482.587 21.7339 483.59 15.653C484.707 8.93091 481.428 2.11578 474.003 -3.58246C473.869 -3.68587 473.734 -3.78928 473.6 -3.8927",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M389.418 15.6842C389.418 54.879 413.018 90.3508 436.617 90.3508C460.217 90.3508 483.816 54.879 483.816 15.6842",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M402.158 2.48804C402.272 1.01953 402.468 -0.397278 402.727 -1.76237C403.254 -4.51325 406.047 -4.73043 408.591 -2.22775C408.622 -2.19673 408.642 -2.17604 408.673 -2.14502C410.804 -0.0456655 412.055 3.20161 411.621 5.51813C411.352 6.9763 411.186 8.50687 411.114 10.0995",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M417.237 12.8197C416.906 10.5756 416.751 8.41419 416.771 6.33552C416.802 3.53294 419.481 2.84004 422.439 4.82564C422.48 4.84632 422.511 4.87735 422.532 4.89804C425.014 6.56304 426.813 9.55177 426.792 11.9097C426.792 12.9955 426.844 14.1124 426.958 15.2397",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M452.739 13.8537C452.346 12.7782 452.129 11.5062 452.129 10.0584C452.129 3.07776 457.031 -5.4334 463.081 -8.91853C468.169 -11.8556 472.429 -10.3147 473.681 -5.61956C473.846 -4.99906 473.96 -4.31651 474.012 -3.5926",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M460.311 11.041C458.594 10.9065 457.426 9.44838 457.426 6.99741C457.426 3.38818 459.97 -1.00701 463.093 -2.80646C466.226 -4.61624 468.76 -3.14773 468.76 0.461501C468.76 2.80905 467.685 5.48753 466.071 7.57654",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M434.539 103.299L440.433 99.4413L433.742 96.0389",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M440.433 99.4412H440.413C413.938 99.4412 392.469 87.052 392.469 71.767C392.469 71.6533 392.469 71.5292 392.469 71.4154",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M476.412 53.4933C483.837 58.3642 488.336 64.7553 488.346 71.7566",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M608.63 -50.6983L542.795 -12.6825C540.737 -11.4932 538.793 -9.80752 537.025 -7.75988C535.742 -6.27068 534.543 -4.60568 533.478 -2.80624L533.281 -2.46497C530.199 2.87132 528.255 9.23141 528.255 15.0951C528.255 20.9588 530.117 24.899 533.074 26.7294L521.688 20.1625C518.606 18.3838 516.662 14.2575 516.662 8.40409C516.662 2.55073 518.606 -3.83006 521.688 -9.156L521.885 -9.49727C522.95 -11.2967 524.149 -12.9721 525.432 -14.4509C527.2 -16.4986 529.155 -18.1946 531.202 -19.3735L620.099 -70.699C623.739 -72.7984 627.059 -72.9432 629.613 -71.4643L641.01 -64.8767C638.487 -66.2314 635.239 -66.0453 631.692 -63.9977L608.62 -50.688L608.63 -50.6983Z",
    fill: "black"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M533.281 26.8538L533.085 26.7297C530.117 24.8992 528.266 20.8246 528.266 15.0953C528.266 9.36609 530.21 2.86121 533.292 -2.46473L533.488 -2.80601C534.553 -4.60545 535.753 -6.2808 537.035 -7.75965C538.804 -9.80729 540.758 -11.493 542.806 -12.6823L608.641 -50.6981V-11.9273L542.806 26.0885C539.166 28.1879 535.846 28.3326 533.292 26.8538H533.281Z",
    fill: "black"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M533.085 26.7399C530.117 24.9095 528.266 20.8349 528.266 15.1056C528.266 9.37635 530.21 2.87147 533.292 -2.45447",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M641.207 -64.7835C644.278 -63.0047 646.233 -58.8784 646.233 -53.0251C646.233 -47.1717 644.288 -40.7909 641.207 -35.465C640.1 -33.5414 638.838 -31.7523 637.473 -30.1701C635.705 -28.1224 633.75 -26.4367 631.703 -25.2475L542.796 26.078C539.155 28.1774 535.836 28.3222 533.281 26.8433",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M521.698 -9.15582C518.616 -3.81954 516.672 2.54056 516.672 8.40427C516.672 14.268 518.616 18.3839 521.698 20.1627L533.281 26.8537",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M244.316 77.0205V59.812C246.478 58.871 248.929 58.8193 251.835 60.4946C259.405 64.8691 259.167 74.1869 263.986 76.9688C269.974 80.4229 271.463 65.9136 277.286 69.2747C282.022 72.0152 284.194 84.6113 290.057 88.0033C293.832 90.1854 297.235 78.458 302.85 81.7053C303.377 82.0052 303.864 82.3982 304.339 82.8842V111.686C304.339 114.53 302.612 115.833 300.482 114.602L248.184 84.4044C246.054 83.1738 244.327 79.8748 244.327 77.0309L244.316 77.0205Z",
    fill: "black"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M244.315 59.8018V35.199C244.315 32.3551 246.042 31.052 248.172 32.2827L300.47 62.4802C302.6 63.7109 304.328 67.0099 304.328 69.8538V82.8636C303.862 82.3775 303.366 81.9949 302.838 81.6847C297.223 78.4374 293.82 90.1648 290.046 87.9827C284.182 84.5906 282.01 71.9945 277.274 69.254C271.451 65.893 269.962 80.4023 263.974 76.9482C259.166 74.1663 259.403 64.8485 251.823 60.474C248.917 58.7986 246.466 58.8503 244.305 59.7914L244.315 59.8018Z",
    fill: "#FBB93E"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M304.339 82.8642V111.666C304.339 114.51 302.612 115.813 300.481 114.582L248.184 84.3844C246.053 83.1537 244.326 79.8548 244.326 77.0108V35.1893C244.326 32.3453 246.053 31.0423 248.184 32.2729L300.481 62.4705C302.612 63.7011 304.339 67.0001 304.339 69.8441V82.8538V82.8642Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M244.316 59.8021C246.478 58.861 248.929 58.8093 251.835 60.4847C259.405 64.8592 259.167 74.177 263.986 76.9589C269.974 80.413 271.463 65.9037 277.286 69.2647C282.022 72.0052 284.194 84.6013 290.057 87.9934C293.832 90.1755 297.235 78.4481 302.85 81.6953C303.377 81.9952 303.864 82.3882 304.339 82.8743",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M104.527 213.386L237.273 136.744L330.461 190.541L197.716 267.183L104.527 213.386Z",
    fill: "black"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M324.669 294.702V200.562L243.156 247.627H243.146L203.506 270.523V364.663L197.715 367.993V267.183L330.46 190.541V291.362L324.669 294.702Z",
    fill: "black"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M104.527 314.196V213.386L197.716 267.183V367.993L104.527 314.196Z",
    fill: "#459AA4"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M243.158 247.627L324.671 200.562V294.702L243.158 247.627Z",
    fill: "black"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M243.146 247.627L203.506 270.523V364.663L197.715 367.993V267.183L330.46 190.541V291.362L324.669 294.702V200.562L243.156 247.627H243.146Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M330.461 190.541L237.273 136.744L104.527 213.386V314.196L197.716 367.993",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M197.716 267.183L104.527 213.386",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M324.67 294.702L243.157 247.627H243.146",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M265.301 183.384L269.81 186.011C268.083 186.901 266.459 187.769 264.918 188.628C254.618 194.398 248.258 199.755 239.809 208.69L200.562 186.032C212.311 173.922 219.674 169.361 230.936 163.342L265.301 183.384Z",
    fill: "black"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M239.808 208.691L239.87 208.784L239.695 215.961L224.72 224.844L222.745 222.569L216.519 226.158L218.649 228.453L207.025 235.351L207.098 227.574C218.101 218.184 225.371 214.089 239.798 208.691H239.808Z",
    fill: "black"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M200.56 186.032L239.806 208.69C225.38 214.078 218.109 218.184 207.106 227.574L167.859 204.916C178.915 195.588 187.571 190.706 200.56 186.032Z",
    fill: "black"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M224.718 224.844L233.033 234.41L228.193 233.79L226.642 237.058L216.518 226.157L222.743 222.569L224.718 224.844Z",
    fill: "black"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M207.096 227.574L207.024 235.351L167.85 212.465V204.916L207.096 227.574Z",
    fill: "black"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M167.85 204.916C178.905 195.588 187.561 190.706 200.55 186.032C212.298 173.922 219.661 169.361 230.923 163.342L269.797 186.011C268.07 186.901 266.447 187.769 264.906 188.628C254.606 194.398 248.245 199.755 239.796 208.69C225.37 214.078 218.1 218.184 207.096 227.574L167.85 204.916Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M181.832 204.068C187.872 199.569 193.539 196.291 200.178 193.395",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M186.889 207.098C192.814 202.744 198.42 199.538 204.987 196.705",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M192.465 209.756C198.349 205.536 203.996 202.423 210.666 199.631",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M196.775 213.334C202.743 209.032 208.441 205.888 215.194 203.054",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M201.678 216.488C207.852 212.093 213.757 208.897 220.893 206.002",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M239.869 208.783L239.693 215.961L224.719 224.844",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M218.649 228.453L207.025 235.351L207.098 227.574",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M167.85 204.916V212.465L207.024 235.351",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M239.809 208.69L200.562 186.032",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M224.718 224.844L222.743 222.569L216.518 226.157L226.642 237.058L228.193 233.79L233.033 234.41L224.718 224.844Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M123.865 202.217C124.134 199.28 133.504 164.718 157.3 191.637C160.361 195.102 159.544 200.479 155.593 202.868L153.111 204.368C150.05 206.219 146.245 206.322 143.09 204.657L131.611 197.749L123.865 202.217Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M193.051 162.267C193.32 159.33 202.689 124.768 226.485 151.688C229.546 155.152 228.729 160.53 224.779 162.919L222.297 164.418C219.236 166.269 215.43 166.373 212.276 164.708L200.797 157.799L193.051 162.267Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M250.281 274.649V303.596C250.281 308.735 247.158 314.692 243.311 316.916L235.638 321.342C233.962 322.304 232.432 322.417 231.232 321.797L231.025 321.673C229.577 320.804 228.678 318.849 228.678 316.078V287.132C228.678 279.169 233.518 269.923 239.495 266.479C241.015 265.6 242.463 265.187 243.787 265.187C243.994 265.187 244.19 265.187 244.387 265.218C244.397 265.218 244.418 265.218 244.438 265.218C244.687 265.249 244.924 265.29 245.162 265.342C248.265 266.035 250.302 269.458 250.302 274.649H250.281Z",
    fill: "black"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M220.942 282.364C226.133 267.752 237.054 264.122 244.366 265.208C244.169 265.187 243.973 265.177 243.766 265.177C242.452 265.177 240.994 265.59 239.474 266.469C233.496 269.913 228.657 279.158 228.657 287.122V316.068C228.657 318.839 229.567 320.804 231.004 321.663L221.914 316.419C219.349 314.941 217.798 312.19 217.819 309.232C217.912 299.283 218.636 288.787 220.921 282.354L220.942 282.364Z",
    fill: "black"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M231.016 321.673L231.222 321.797C231.15 321.766 231.078 321.725 231.016 321.673Z",
    fill: "black"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M244.418 265.218C244.666 265.249 244.904 265.29 245.142 265.342C248.234 266.086 250.281 269.458 250.281 274.649V303.596C250.281 308.735 247.158 314.692 243.311 316.916L235.638 321.342C233.962 322.304 232.432 322.407 231.232 321.797C231.16 321.766 231.087 321.724 231.025 321.673C229.577 320.804 228.678 318.849 228.678 316.078V287.132C228.678 279.169 233.518 269.923 239.495 266.479C241.015 265.6 242.463 265.187 243.787 265.187C243.994 265.187 244.19 265.187 244.387 265.218H244.438H244.418Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M231.232 321.797L221.935 316.43C219.371 314.951 217.819 312.2 217.84 309.242C217.933 299.294 218.657 288.797 220.943 282.364C226.134 267.752 237.055 264.122 244.366 265.208C244.377 265.208 244.397 265.208 244.418 265.208C244.666 265.239 244.904 265.28 245.142 265.332",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M288.733 252.457V281.403C288.733 286.543 285.609 292.499 281.762 294.723L274.089 299.149C272.413 300.111 270.883 300.225 269.683 299.604L269.476 299.48C268.029 298.611 267.129 296.657 267.129 293.885V264.939C267.129 256.976 271.969 247.73 277.946 244.287C279.466 243.408 280.914 242.994 282.238 242.994C282.445 242.994 282.641 242.994 282.838 243.025C282.848 243.025 282.869 243.025 282.89 243.025C283.138 243.056 283.376 243.097 283.613 243.149C286.716 243.842 288.753 247.265 288.753 252.457H288.733Z",
    fill: "black"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M282.809 243.015C282.612 242.994 282.416 242.984 282.209 242.984C280.896 242.984 279.438 243.397 277.917 244.276C271.94 247.72 267.1 256.966 267.1 264.929V293.875C267.1 296.646 268.01 298.611 269.448 299.47L260.357 294.226C257.793 292.748 256.241 289.997 256.262 287.039C256.355 277.09 257.079 266.594 259.364 260.161C264.556 245.548 275.477 241.918 282.788 243.004L282.809 243.015Z",
    fill: "black"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M269.467 299.48L269.674 299.604C269.601 299.573 269.529 299.532 269.467 299.48Z",
    fill: "black"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M282.859 243.024C283.107 243.055 283.345 243.097 283.583 243.148C286.675 243.893 288.723 247.264 288.723 252.456V281.402C288.723 286.542 285.6 292.499 281.753 294.722L274.079 299.148C272.404 300.11 270.873 300.214 269.674 299.603C269.601 299.572 269.529 299.531 269.467 299.479C268.019 298.611 267.119 296.656 267.119 293.884V264.938C267.119 256.975 271.959 247.73 277.937 244.286C279.457 243.407 280.905 242.993 282.228 242.993C282.435 242.993 282.632 242.993 282.828 243.024H282.88H282.859Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M269.674 299.604L260.377 294.236C257.812 292.757 256.261 290.007 256.281 287.049C256.375 277.1 257.098 266.603 259.384 260.171C264.575 245.558 275.496 241.928 282.808 243.014C282.818 243.014 282.839 243.014 282.859 243.014C283.108 243.045 283.345 243.087 283.583 243.138",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M854.979 -4.316C854.731 -2.55792 854.617 -0.810188 854.617 0.896179C854.617 9.03504 857.534 14.7023 862.249 17.2153L882.209 27.9395C878.755 26.0263 876.293 22.4068 875.259 17.3497C874.907 15.633 874.721 13.7405 874.721 11.6825C874.721 -4.22292 885.89 -23.5825 899.655 -31.5248C900.565 -32.0523 901.475 -32.5073 902.365 -32.9106C904.298 -51.7427 917.391 -72.9844 933.245 -82.1368C936.482 -83.9983 939.594 -85.2393 942.521 -85.8598C947.061 -86.8629 951.156 -86.4182 954.548 -84.7118L934.754 -95.343C929.16 -98.3524 921.538 -97.794 913.13 -92.9334C897.276 -83.7811 884.194 -62.529 882.26 -43.7073C881.371 -43.304 880.471 -42.8386 879.561 -42.3215C873.118 -38.5985 867.234 -32.3935 862.818 -25.2061C858.785 -18.6702 855.962 -11.338 854.979 -4.32635V-4.316Z",
    fill: "black"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M874.721 11.6827C874.721 13.7407 874.907 15.6228 875.258 17.3499C876.293 22.4069 878.754 26.0265 882.208 27.9397L882.353 28.0018C884.618 29.2324 887.296 29.7185 890.264 29.3979C892.446 29.1704 894.783 28.4982 897.214 27.3709C898.02 26.9883 898.848 26.5643 899.675 26.0886L963.121 -10.5208C974.921 -17.3359 984.476 -33.9136 984.476 -47.5335C984.476 -61.1534 975.541 -66.3036 964.279 -60.5122C964.269 -60.5019 964.259 -60.4916 964.238 -60.4916C964.248 -60.5846 964.259 -60.6674 964.259 -60.7708C964.341 -61.9084 964.393 -63.0563 964.393 -64.1835C964.393 -74.339 960.742 -81.4127 954.879 -84.5565L954.568 -84.7323C951.176 -86.4387 947.081 -86.8834 942.541 -85.8803C939.614 -85.2494 936.502 -84.0188 933.265 -82.1573C917.401 -73.0049 904.318 -51.7529 902.385 -32.9311C901.495 -32.5175 900.595 -32.0624 899.675 -31.5453C885.9 -23.5926 874.741 -4.24344 874.741 11.662L874.721 11.6827Z",
    fill: "black"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M954.547 -84.722L954.857 -84.5461C960.732 -81.4023 964.372 -74.3286 964.372 -64.1731C964.372 -63.0459 964.32 -61.9083 964.237 -60.7604C964.237 -60.6673 964.227 -60.5742 964.217 -60.4812C964.237 -60.4812 964.248 -60.4812 964.258 -60.5019C975.52 -66.3035 984.455 -60.6983 984.455 -47.5231C984.455 -34.3479 974.9 -17.3255 963.1 -10.5104C963.1 -10.5104 898.01 27.009 897.203 27.3917C894.773 28.5292 892.435 29.2014 890.253 29.4186C887.285 29.7392 884.617 29.2428 882.342 28.0225L882.197 27.9604",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M954.548 -84.7222C951.156 -86.4285 947.061 -86.8732 942.521 -85.8701C939.594 -85.2393 936.482 -84.0086 933.245 -82.1471C917.381 -72.9948 904.298 -51.7427 902.365 -32.921C901.475 -32.5073 900.575 -32.0523 899.655 -31.5352C885.88 -23.5825 874.721 -4.23327 874.721 11.6722C874.721 13.7301 874.907 15.6123 875.259 17.3394C876.293 22.3964 878.755 26.016 882.209 27.9292L862.249 17.2049C857.544 14.6919 854.617 9.0247 854.617 0.885837C854.617 -0.820532 854.741 -2.56827 854.979 -4.32635C855.951 -11.338 858.785 -18.6702 862.818 -25.2061C867.234 -32.3935 873.118 -38.5985 879.561 -42.3215C880.471 -42.8489 881.371 -43.3143 882.26 -43.7073C884.194 -62.5394 897.276 -83.7811 913.13 -92.9334C921.538 -97.794 929.16 -98.3524 934.754 -95.343L954.548 -84.7118V-84.7222Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M1573.13 -39.7668C1573.4 -36.6747 1571.03 -33.6756 1566.03 -30.78L1540.9 -16.2706C1537.71 -14.4298 1536.14 -12.8372 1536.19 -11.5032C1536.23 -10.1587 1537.95 -8.51443 1541.31 -6.57021L1529.02 0.524155C1525.65 -1.42007 1522.81 -2.40253 1520.48 -2.43355C1518.17 -2.45424 1515.41 -1.55452 1512.22 0.286293L1487.09 14.7956C1482.08 17.6809 1476.89 19.046 1471.52 18.8909C1466.16 18.7358 1461.23 17.3707 1456.78 14.7956L1449.13 10.3797L1461.42 3.28537L1463.6 4.54705C1466.06 5.97419 1468.59 6.61538 1471.18 6.48093C1473.78 6.34649 1476.89 5.23993 1480.54 3.13024L1501.02 -8.69024C1507.39 -12.3719 1514.17 -13.0854 1521.36 -10.8206L1521.63 -10.9757C1517.71 -15.1331 1518.94 -19.0422 1525.32 -22.7238L1545.8 -34.5443C1549.44 -36.654 1551.37 -38.4431 1551.6 -39.953C1551.83 -41.4525 1550.71 -42.9107 1548.25 -44.3275L1546.07 -45.5892L1558.35 -52.6835L1566 -48.2677C1570.45 -45.6926 1572.82 -42.8486 1573.1 -39.7462L1573.13 -39.7668Z",
    fill: "black"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M1461.43 3.27462L1463.61 4.5363C1466.08 5.96345 1468.6 6.60463 1471.19 6.47019C1473.79 6.33575 1476.9 5.2292 1480.55 3.1195L1501.03 -8.70098C1507.4 -12.3826 1514.18 -13.0962 1521.37 -10.8314L1521.64 -10.9865C1517.72 -15.1438 1518.95 -19.053 1525.33 -22.7346L1545.81 -34.5551C1549.45 -36.6647 1551.38 -38.4539 1551.61 -39.9637C1551.84 -41.4633 1550.72 -42.9214 1548.26 -44.3382L1546.08 -45.5999L1558.36 -52.6943L1566.01 -48.2784C1570.46 -45.7033 1572.83 -42.8594 1573.11 -39.7569C1573.38 -36.6648 1571.01 -33.6657 1566.01 -30.77L1540.88 -16.2607C1537.69 -14.4199 1536.12 -12.8273 1536.17 -11.4932C1536.21 -10.1488 1537.93 -8.50449 1541.29 -6.56026L1529 0.534096C1525.63 -1.41013 1522.79 -2.39259 1520.46 -2.42361C1518.15 -2.44429 1515.39 -1.54458 1512.2 0.296235L1487.07 14.8055C1482.06 17.6909 1476.87 19.0559 1471.5 18.9008C1466.14 18.7457 1461.21 17.3806 1456.76 14.8055L1449.12 10.3897L1461.4 3.29531L1461.43 3.27462Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M1406.36 81.892V124.251L1455.37 95.9566V53.587L1406.36 81.892Z",
    fill: "#FBB93E"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M1406.36 124.251L1455.37 95.9566V53.587L1406.36 81.892V124.251Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M1463.15 83.1848C1451.68 89.8035 1442.38 105.916 1442.38 119.153C1442.38 132.39 1451.68 137.768 1463.15 131.139C1466.86 128.988 1470.36 125.854 1473.38 122.131C1479.66 114.375 1483.92 104.127 1483.92 95.1708C1483.92 88.5521 1481.59 83.8984 1477.83 81.737C1474.08 79.5653 1468.89 79.8755 1463.15 83.1848ZM1494.86 52.2427V125.472L1431.43 162.091V88.852L1494.86 52.2427Z",
    fill: "black"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M1463.15 83.1849C1451.68 89.8035 1442.38 105.916 1442.38 119.153C1442.38 132.39 1451.68 137.768 1463.15 131.139C1466.86 128.988 1470.36 125.854 1473.38 122.131L1468.71 115.296C1467.08 117.323 1465.18 119.019 1463.15 120.187C1456.91 123.786 1451.87 120.87 1451.87 113.672C1451.87 106.474 1456.92 97.7252 1463.15 94.1263C1466.26 92.3269 1469.08 92.151 1471.13 93.3403L1477.83 81.737C1474.08 79.5653 1468.89 79.8755 1463.15 83.1849Z",
    fill: "black"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M1463.15 94.1363C1456.91 97.7352 1451.87 106.484 1451.87 113.682C1451.87 120.88 1456.92 123.796 1463.15 120.197C1465.17 119.029 1467.07 117.322 1468.7 115.295C1472.13 111.086 1474.43 105.512 1474.43 100.641C1474.43 97.0423 1473.17 94.519 1471.13 93.34C1469.09 92.1507 1466.27 92.3265 1463.15 94.126V94.1363Z",
    fill: "black"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M1468.7 115.296L1473.38 122.131C1479.66 114.375 1483.91 104.127 1483.91 95.1708C1483.91 88.5521 1481.59 83.8984 1477.83 81.737L1471.13 93.3403C1473.17 94.5192 1474.43 97.0426 1474.43 100.641C1474.43 105.512 1472.12 111.076 1468.7 115.296Z",
    fill: "black"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M1431.43 162.091L1494.86 125.472V52.2427L1431.43 88.852V162.091Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M1473.38 122.131C1470.36 125.854 1466.86 128.988 1463.15 131.139C1451.68 137.768 1442.38 132.401 1442.38 119.153C1442.38 105.905 1451.68 89.8035 1463.15 83.1849C1468.88 79.8755 1474.07 79.5653 1477.83 81.737C1481.59 83.9088 1483.91 88.5522 1483.91 95.1708C1483.91 104.127 1479.66 114.375 1473.38 122.131Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M1468.7 115.296C1467.06 117.323 1465.17 119.029 1463.15 120.197C1456.91 123.796 1451.87 120.88 1451.87 113.682C1451.87 106.485 1456.92 97.7355 1463.15 94.1366C1466.26 92.3371 1469.09 92.1613 1471.13 93.3506C1473.17 94.5296 1474.43 97.0529 1474.43 100.652C1474.43 105.523 1472.13 111.087 1468.7 115.306V115.296Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M1471.12 93.3506L1477.82 81.737",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M1468.7 115.306L1473.38 122.131",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M1530.51 304.505C1533.46 319.335 1526.63 339.429 1515.26 349.388C1514.41 350.132 1513.55 350.805 1512.71 351.384C1507.88 354.755 1503.13 355.634 1499.15 354.279C1494.45 352.687 1490.82 347.992 1489.36 340.577C1486.41 325.747 1493.24 305.653 1504.61 295.694C1510.18 290.803 1515.83 289.262 1520.47 290.709L1520.73 290.792C1523.96 291.888 1526.69 294.453 1528.55 298.352C1529.4 300.131 1530.07 302.178 1530.52 304.495L1530.51 304.505ZM1512.16 333.772C1516.92 329.604 1519.77 321.197 1518.54 315.002C1517.31 308.807 1512.46 307.153 1507.7 311.32C1502.94 315.488 1500.09 323.896 1501.32 330.09C1502.55 336.295 1507.4 337.94 1512.16 333.772Z",
    fill: "black"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M1522.4 259.881C1529.99 275.528 1528.93 292.168 1528.53 298.363C1526.67 294.464 1523.94 291.899 1520.71 290.803L1514.71 288.766C1514.71 288.766 1514.7 288.766 1514.69 288.755C1470.8 266.138 1458.79 318.27 1465.82 346.989C1467.46 353.69 1464.01 360.681 1457.63 363.329C1435.55 372.471 1420.73 362.698 1412.48 353.763C1412.29 353.556 1412.1 353.349 1411.92 353.142C1411.43 352.615 1410.89 352.139 1410.34 351.674C1396.89 340.556 1387.38 313.844 1387.38 295.095V295.033C1387.4 274.37 1391.1 257.947 1400.51 246.427C1427.24 226.995 1453.97 254.742 1465.14 262.942C1476.28 271.123 1507.24 292.426 1522.4 259.902V259.881Z",
    fill: "black"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M1518.54 314.992C1519.77 321.187 1516.91 329.605 1512.16 333.762C1507.4 337.93 1502.55 336.285 1501.32 330.081C1500.09 323.886 1502.94 315.468 1507.7 311.31C1512.46 307.143 1517.31 308.797 1518.54 314.992Z",
    fill: "black"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M1454.96 226.985C1495.65 226.985 1514.14 242.849 1522.4 259.881C1507.24 292.406 1476.28 271.112 1465.13 262.922C1453.97 254.731 1427.24 226.985 1400.51 246.406C1410.84 233.738 1428.09 226.974 1454.96 226.974V226.985Z",
    fill: "black"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M1514.71 288.765L1520.46 290.72C1515.82 289.272 1510.18 290.803 1504.6 295.704C1493.23 305.663 1486.4 325.757 1489.35 340.587C1490.81 348.002 1494.45 352.697 1499.14 354.29L1487.13 350.205C1482.44 348.612 1478.81 343.917 1477.34 336.513C1474.39 321.683 1481.23 301.589 1492.59 291.62C1498.27 286.635 1504.01 285.156 1508.71 286.728C1508.73 286.728 1514.68 288.755 1514.68 288.755C1514.68 288.755 1514.69 288.755 1514.7 288.765H1514.71Z",
    fill: "black"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M1508.78 286.739C1508.78 286.739 1508.73 286.728 1508.71 286.718C1504.02 285.136 1498.28 286.625 1492.6 291.61C1481.24 301.579 1474.4 321.673 1477.35 336.503C1478.82 343.918 1482.46 348.602 1487.14 350.195L1499.15 354.28C1503.14 355.635 1507.89 354.756 1512.71 351.384C1499.69 370.392 1482.94 371.364 1476.81 371.013C1477.42 377.538 1478.12 380.796 1478.12 380.796C1478.99 386.267 1475.8 391.913 1468.55 396.091C1446.31 408.925 1408.72 398.315 1412.08 380.465L1412.64 378.976C1413.56 377 1414.37 375.367 1415.06 373.908C1418.26 367.186 1417.21 359.234 1412.48 353.752C1420.69 362.719 1435.55 372.46 1457.63 363.318C1464.01 360.681 1467.46 353.69 1465.82 346.979C1458.78 318.25 1470.8 266.118 1514.69 288.745L1508.78 286.739Z",
    fill: "black"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M1412.47 353.762C1417.2 359.244 1418.25 367.196 1415.05 373.918C1414.36 375.366 1413.56 377 1412.63 378.986L1412.07 380.475C1408.71 398.325 1446.3 408.935 1468.54 396.101C1475.8 391.913 1478.98 386.277 1478.11 380.806C1478.11 380.806 1477.41 377.548 1476.8 371.023C1482.93 371.374 1499.68 370.392 1512.7 351.394",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M1528.53 298.363C1528.93 292.168 1529.99 275.539 1522.4 259.881C1514.13 242.849 1495.65 226.985 1454.96 226.985C1428.09 226.985 1410.84 233.748 1400.51 246.417C1391.1 257.947 1387.4 274.36 1387.38 295.022V295.084C1387.38 313.844 1396.89 340.546 1410.34 351.663C1410.89 352.129 1411.42 352.625 1411.92 353.132",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M1520.71 290.803C1523.94 291.899 1526.67 294.453 1528.53 298.363C1529.38 300.141 1530.05 302.189 1530.5 304.506C1533.45 319.335 1526.62 339.429 1515.25 349.388C1514.4 350.133 1513.54 350.805 1512.7 351.384C1507.86 354.735 1503.12 355.635 1499.14 354.28C1494.44 352.687 1490.81 347.992 1489.35 340.577C1486.4 325.747 1493.23 305.653 1504.6 295.694C1510.17 290.803 1515.82 289.262 1520.46 290.71",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M1518.54 314.992C1519.77 321.187 1516.91 329.605 1512.16 333.762C1507.4 337.93 1502.55 336.285 1501.32 330.08C1500.09 323.886 1502.94 315.468 1507.7 311.31C1512.46 307.143 1517.31 308.797 1518.54 314.992Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M1514.71 288.766L1520.71 290.803",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M1508.78 286.738L1514.69 288.755",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M1508.78 286.739C1508.78 286.739 1508.74 286.728 1508.72 286.718C1504.02 285.136 1498.28 286.625 1492.6 291.61C1481.24 301.579 1474.4 321.673 1477.35 336.503C1478.82 343.918 1482.46 348.602 1487.14 350.195L1499.15 354.28",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M1400.51 246.406C1427.24 226.974 1453.97 254.721 1465.13 262.922C1476.28 271.102 1507.24 292.406 1522.4 259.881",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M1411.92 353.142C1412.1 353.349 1412.28 353.556 1412.48 353.763C1420.73 362.698 1435.55 372.471 1457.63 363.329C1464.01 360.692 1467.46 353.701 1465.82 346.989C1458.79 318.26 1470.8 266.128 1514.69 288.755C1514.69 288.755 1514.7 288.755 1514.71 288.766",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M1438.07 383.506V445.814L1379.12 479.445V359.12L1438.07 325.489V383.506ZM1413.22 388.087C1414.26 386.288 1414.91 384.261 1414.91 382.43C1414.91 378.769 1412.33 377.29 1409.18 379.121C1406.02 380.951 1403.45 385.388 1403.45 389.049C1403.45 392.71 1406.02 394.178 1409.18 392.348C1410.76 391.448 1412.17 389.887 1413.22 388.087Z",
    fill: "black"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M1438.07 325.489L1379.13 359.13L1305.73 316.74L1364.67 283.119L1438.07 325.489Z",
    fill: "black"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M1379.13 359.13V479.455L1305.73 437.075V316.75L1379.13 359.13ZM1364.99 435.514V414.582L1319.87 388.532V409.463L1364.99 435.514ZM1364.47 375.481C1364.47 373.216 1362.88 370.465 1360.91 369.327C1358.96 368.19 1357.36 369.11 1357.36 371.375C1357.36 373.64 1358.95 376.391 1360.91 377.528C1362.88 378.655 1364.47 377.735 1364.47 375.481ZM1364.47 394.437C1364.47 392.172 1362.88 389.421 1360.91 388.283C1358.96 387.146 1357.36 388.066 1357.36 390.331C1357.36 392.596 1358.95 395.347 1360.91 396.484C1362.88 397.612 1364.47 396.691 1364.47 394.437ZM1346.57 383.464V365.78C1346.57 362.74 1344.73 359.182 1342.43 357.869C1341.85 357.538 1341.29 357.372 1340.79 357.372C1339.32 357.372 1338.28 358.727 1338.28 361.002V378.686C1338.28 381.737 1340.14 385.284 1342.42 386.598C1344.71 387.911 1346.56 386.525 1346.56 383.464H1346.57ZM1327.49 354.125C1327.49 351.86 1325.91 349.109 1323.94 347.972C1321.99 346.845 1320.39 347.765 1320.39 350.019C1320.39 352.274 1321.99 355.035 1323.94 356.173C1325.89 357.31 1327.49 356.39 1327.49 354.125ZM1327.49 373.092C1327.49 370.827 1325.91 368.076 1323.94 366.938C1321.99 365.811 1320.39 366.732 1320.39 368.986C1320.39 371.24 1321.99 374.012 1323.94 375.139C1325.89 376.267 1327.49 375.346 1327.49 373.092Z",
    fill: "black"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M1360.91 369.338C1362.88 370.475 1364.47 373.216 1364.47 375.491C1364.47 377.766 1362.88 378.666 1360.91 377.539C1358.96 376.401 1357.36 373.65 1357.36 371.385C1357.36 369.121 1358.95 368.2 1360.91 369.338Z",
    fill: "black"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M1346.57 365.78V383.464C1346.57 386.525 1344.72 387.911 1342.43 386.598C1340.15 385.284 1338.29 381.737 1338.29 378.686V361.002C1338.29 358.727 1339.32 357.372 1340.8 357.372C1341.29 357.372 1341.85 357.527 1342.44 357.869C1344.73 359.182 1346.58 362.739 1346.58 365.78H1346.57Z",
    fill: "black"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M1323.94 347.972C1325.89 349.109 1327.49 351.86 1327.49 354.125C1327.49 356.39 1325.9 357.31 1323.94 356.173C1321.99 355.035 1320.39 352.294 1320.39 350.019C1320.39 347.744 1321.99 346.844 1323.94 347.972Z",
    fill: "black"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M1323.94 366.928C1325.89 368.066 1327.49 370.817 1327.49 373.081C1327.49 375.346 1325.9 376.256 1323.94 375.129C1321.99 373.991 1320.39 371.241 1320.39 368.976C1320.39 366.711 1321.99 365.801 1323.94 366.928Z",
    fill: "black"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M1438.07 445.814V325.489L1364.67 283.119",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M1357.37 371.385C1357.37 373.65 1358.96 376.401 1360.92 377.539C1362.89 378.666 1364.48 377.746 1364.48 375.491C1364.48 373.237 1362.89 370.475 1360.92 369.338C1358.97 368.2 1357.37 369.121 1357.37 371.385Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M1320.39 350.03C1320.39 352.295 1321.99 355.045 1323.94 356.183C1325.89 357.321 1327.49 356.4 1327.49 354.135C1327.49 351.871 1325.9 349.12 1323.94 347.982C1321.99 346.855 1320.39 347.775 1320.39 350.03Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M1320.39 368.986C1320.39 371.251 1321.99 374.012 1323.94 375.139C1325.89 376.267 1327.49 375.346 1327.49 373.092C1327.49 370.837 1325.9 368.076 1323.94 366.938C1321.99 365.811 1320.39 366.732 1320.39 368.986Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M1342.43 386.598C1344.72 387.911 1346.57 386.525 1346.57 383.464V365.78C1346.57 362.739 1344.73 359.182 1342.43 357.869C1341.85 357.538 1341.29 357.372 1340.79 357.372C1339.32 357.372 1338.29 358.727 1338.29 361.002V378.686C1338.29 381.737 1340.14 385.284 1342.42 386.598H1342.43Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M1305.73 316.74V437.065L1379.13 479.455V359.13L1305.73 316.74Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M1364.67 283.119L1305.73 316.74",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M1438.07 325.489L1379.13 359.131",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M1643.79 331.528C1643.79 332.541 1643.18 333.513 1641.92 334.227L1619.09 347.413C1616.33 349.016 1611.5 348.819 1608.3 346.968L1587.02 334.682C1586.58 334.424 1586.19 334.165 1585.87 333.875C1585.71 333.731 1585.55 333.586 1585.42 333.451C1584.72 332.727 1584.37 331.931 1584.37 331.166C1584.37 330.142 1584.99 329.18 1586.23 328.456L1595.26 323.244C1606.17 328.415 1621.98 328.415 1632.9 323.244L1641.14 328.001C1642.89 329.015 1643.79 330.297 1643.79 331.528Z",
    fill: "black"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M1635.09 297.845C1646.68 304.536 1646.68 315.405 1635.09 322.107C1634.38 322.52 1633.65 322.893 1632.89 323.255C1621.97 328.415 1606.17 328.415 1595.26 323.255C1594.51 322.903 1593.77 322.52 1593.08 322.117C1581.48 315.416 1581.48 304.557 1593.08 297.856C1596.04 296.149 1599.45 294.887 1603.1 294.05C1602.89 294.887 1602.79 295.756 1602.79 296.656C1602.79 298.197 1603.1 299.665 1603.65 300.999C1602.66 301.382 1601.73 301.858 1600.84 302.333C1592.68 306.677 1592.69 313.523 1600.84 317.629C1601.57 318.001 1602.29 318.404 1603.09 318.735C1609.63 321.476 1618.54 321.476 1625.08 318.735C1625.86 318.404 1626.61 318.011 1627.33 317.629C1635.36 313.399 1635.45 306.553 1627.33 302.333C1626.43 301.868 1625.51 301.382 1624.52 300.999C1625.08 299.665 1625.38 298.197 1625.38 296.656C1625.38 295.756 1625.27 294.887 1625.08 294.05C1628.73 294.887 1632.14 296.149 1635.1 297.856L1635.09 297.845Z",
    fill: "black"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M1614.08 285.342C1619.42 285.342 1623.9 289.045 1625.08 294.029C1625.28 294.867 1625.38 295.736 1625.38 296.635C1625.38 298.176 1625.08 299.645 1624.52 300.979C1622.81 305.064 1618.79 307.928 1614.08 307.928C1609.38 307.928 1605.36 305.064 1603.66 300.979C1603.11 299.645 1602.8 298.176 1602.8 296.635C1602.8 295.736 1602.9 294.867 1603.11 294.029C1604.28 289.055 1608.76 285.342 1614.09 285.342H1614.08Z",
    fill: "#459AA4"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M1619.86 315.715L1625.08 318.725C1618.54 321.465 1609.63 321.465 1603.09 318.725L1609.08 315.271C1611.84 313.678 1616.67 313.875 1619.86 315.726V315.715Z",
    fill: "black"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M1587.02 334.672C1586.57 334.423 1586.2 334.155 1585.87 333.865C1586.2 334.144 1586.58 334.413 1587.02 334.672Z",
    fill: "black"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M1643.79 331.528V358.292C1643.79 359.305 1643.18 360.277 1641.92 360.991L1619.09 374.177C1616.32 375.78 1611.5 375.573 1608.3 373.732L1587.02 361.446C1585.27 360.433 1584.37 359.15 1584.37 357.92V331.155C1584.37 331.921 1584.72 332.717 1585.42 333.441C1585.55 333.586 1585.71 333.731 1585.87 333.865C1586.2 334.155 1586.59 334.423 1587.02 334.672L1608.3 346.957C1611.5 348.809 1616.33 349.005 1619.09 347.402L1641.92 334.217C1643.18 333.493 1643.79 332.531 1643.79 331.517V331.528Z",
    fill: "#FBB93E"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M1585.87 333.876C1586.2 334.165 1586.58 334.434 1587.02 334.682L1604.42 344.734",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M1643.79 331.528V358.292C1643.79 359.305 1643.18 360.277 1641.92 360.991L1619.09 374.177C1616.32 375.78 1611.5 375.573 1608.3 373.732L1587.02 361.446C1585.27 360.433 1584.37 359.15 1584.37 357.92V331.155",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M1603.09 318.725L1609.08 315.271C1611.84 313.678 1616.67 313.875 1619.86 315.726L1625.08 318.735",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M1632.9 323.244L1641.14 328.001C1642.89 329.015 1643.79 330.297 1643.79 331.528C1643.79 332.541 1643.18 333.513 1641.92 334.227L1619.09 347.413C1616.33 349.016 1611.5 348.819 1608.3 346.968L1587.02 334.682C1586.58 334.423 1586.19 334.165 1585.87 333.875C1585.71 333.731 1585.55 333.586 1585.42 333.451C1584.72 332.727 1584.37 331.931 1584.37 331.166C1584.37 330.142 1584.99 329.18 1586.23 328.456L1595.26 323.244",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M1603.1 294.029C1604.27 289.055 1608.75 285.342 1614.08 285.342C1619.42 285.342 1623.9 289.045 1625.08 294.029",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M1624.52 300.979C1622.81 305.064 1618.79 307.928 1614.08 307.928C1609.38 307.928 1605.36 305.064 1603.66 300.979",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M1625.08 294.029C1628.73 294.867 1632.14 296.128 1635.1 297.835C1646.69 304.526 1646.69 315.395 1635.1 322.096C1634.4 322.51 1633.66 322.882 1632.91 323.244C1622.01 328.436 1606.19 328.405 1595.27 323.244C1594.52 322.882 1593.78 322.51 1593.09 322.107C1581.49 315.405 1581.49 304.546 1593.09 297.845C1596.05 296.139 1599.46 294.877 1603.11 294.039C1602.91 294.877 1602.8 295.746 1602.8 296.645C1602.8 298.186 1603.11 299.655 1603.66 300.989C1602.67 301.372 1601.74 301.847 1600.85 302.323C1592.69 306.667 1592.7 313.513 1600.85 317.618C1601.58 317.991 1602.31 318.394 1603.1 318.725C1609.65 321.455 1618.54 321.455 1625.09 318.725C1625.87 318.394 1626.62 318.001 1627.34 317.618C1635.37 313.389 1635.46 306.542 1627.34 302.323C1626.44 301.858 1625.52 301.372 1624.53 300.989C1625.09 299.655 1625.39 298.186 1625.39 296.645C1625.39 295.746 1625.28 294.877 1625.09 294.039L1625.08 294.029Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M1513.76 236.758C1511.09 231.452 1509.05 225.909 1507.79 220.418",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M1506.4 207.667C1506.53 201.648 1507.91 196.705 1510.26 193.013",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M1526.42 185.349C1530.32 185.701 1534.61 187.128 1539.11 189.724C1544.84 193.033 1550.22 197.842 1554.9 203.53",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M1562.86 215.236C1564.8 218.711 1566.47 222.331 1567.84 225.992",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M1571.38 239.911C1571.66 242.104 1571.82 244.265 1571.82 246.375C1571.82 260.626 1564.98 269.085 1554.89 269.695",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M1539.56 265.528C1539.41 265.445 1539.25 265.352 1539.11 265.269C1533.01 261.753 1527.3 256.531 1522.42 250.357",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M1800.09 -19.3839V1.04081L1746.25 32.1174V11.6927L1800.09 -19.3839Z",
    fill: "black"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M1800.09 -19.3841L1746.25 11.6925L1675.42 -29.2086L1695.45 -40.7706L1750.4 -9.04245L1784.2 -28.5674L1800.09 -19.3841Z",
    fill: "black"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M1746.25 11.6927V32.1174L1731.09 23.358V20.4417L1675.42 -11.5139V-29.2085L1746.25 11.6927Z",
    fill: "black"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M1731.09 23.358V40.8767L1712.67 51.5079V31.0728L1728.57 21.8998L1731.09 23.358Z",
    fill: "black"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M1731.09 20.4415V23.3578L1728.57 21.8996L1731.09 20.4415Z",
    fill: "black"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M1731.09 20.4413L1712.67 31.0725L1674.93 9.52052L1687.27 37.6808L1678.37 42.8206L1630.71 36.2226L1667.24 57.3092L1648.79 68.0024L1577.89 27.1116L1594.38 17.587L1660.16 26.8117L1643.56 -10.8111L1660.05 -20.3358L1731.09 20.4413Z",
    fill: "black"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M1712.67 31.0726V51.5076L1686.87 36.7708L1674.93 9.52063L1712.67 31.0726Z",
    fill: "black"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M1687.27 37.6813V58.106L1678.37 63.2561L1667.24 61.7049V57.3097L1630.71 36.2231L1678.37 42.821L1687.27 37.6813Z",
    fill: "black"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M1667.24 61.7045V77.7443L1648.79 88.4376V68.0025L1667.24 57.3093V61.7045Z",
    fill: "black"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M1643.56 -10.8107L1660.16 26.8122L1650.55 25.4678L1643.56 9.61405V-10.8107Z",
    fill: "black"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M1648.79 68.0028V88.4379L1577.89 47.5367V27.112L1648.79 68.0028Z",
    fill: "black"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M1712.67 31.0725L1674.93 9.52052L1687.27 37.6808L1678.37 42.8206L1630.71 36.2226L1667.24 57.3092L1648.79 68.0024L1577.89 27.1116L1594.38 17.587L1660.16 26.8117L1643.56 -10.8111L1660.05 -20.3358L1731.09 20.4413L1712.67 31.0725Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M1675.42 -29.2086L1695.45 -40.7706L1750.4 -9.04245L1784.2 -28.5674L1800.09 -19.3841L1746.25 11.6925L1675.42 -29.2086Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M1800.09 -19.3839V1.04081L1746.25 32.1174L1728.57 21.8999",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M1746.25 32.1172V11.6925",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M1731.09 20.4415V40.8765L1712.67 51.5077L1686.87 36.7709",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M1712.67 31.0729V51.508",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M1650.55 25.4678L1643.56 9.61405V-10.8107",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M1667.24 57.3096V77.7446L1648.79 88.4379L1577.89 47.5367V27.112",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M1687.27 37.6809V58.1056L1678.37 63.2558L1667.24 61.7045",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M1807.96 280.13V361.54L1788.59 372.719V291.31L1807.96 280.13Z",
    fill: "black"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M1807.96 280.131L1788.59 291.31L1769.22 280.131L1788.59 268.941L1807.96 280.131Z",
    fill: "black"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M1788.59 291.31V372.719L1769.22 361.54V280.13L1788.59 291.31Z",
    fill: "#459AA4"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M1769.22 287.401V344.001L1754.03 352.76V296.16L1769.22 287.401Z",
    fill: "black"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M1769.22 282.571V287.401L1754.03 296.16L1734.66 284.981L1754.03 273.802L1769.22 282.571Z",
    fill: "black"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M1754.03 296.16V352.76L1734.66 341.58V284.981L1754.03 296.16Z",
    fill: "#459AA4"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M1734.66 295.023V324.041L1719.48 332.811V303.792L1734.66 295.023Z",
    fill: "black"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M1734.66 290.193V295.023L1719.48 303.792L1700.1 292.613L1719.48 281.434L1734.66 290.193Z",
    fill: "black"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M1719.48 303.792V332.811L1700.1 321.621V292.613L1719.48 303.792Z",
    fill: "#459AA4"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M1734.66 295.023L1719.48 303.792L1700.1 292.613L1719.48 281.434L1734.66 290.193",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M1719.48 303.792V332.811",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M1700.1 292.613V321.621L1719.48 332.811L1734.66 324.041",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M1769.22 287.401L1754.03 296.16L1734.66 284.981L1754.03 273.802L1769.22 282.571",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M1754.03 296.16V352.76",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M1734.66 284.981V341.58L1754.03 352.76L1769.22 344",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M1769.22 280.131L1788.59 268.941L1807.96 280.131L1788.59 291.31L1769.22 280.131Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M1788.59 291.31V372.719",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M1769.22 280.13V361.54L1788.59 372.719L1807.96 361.54V280.13",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M1781.5 258.816L1763.72 269.086C1763.23 267.586 1762.71 266.118 1762.16 264.649C1754.25 243.666 1740.92 225.196 1725.78 216.457C1718.43 212.227 1711.54 210.759 1705.44 211.721C1702.91 212.124 1700.51 212.962 1698.3 214.192L1715.75 204.119C1718.06 202.785 1720.56 201.886 1723.23 201.462C1729.31 200.49 1736.22 201.968 1743.55 206.198C1758.69 214.937 1772.03 233.407 1779.95 254.39C1780.49 255.859 1781.02 257.338 1781.51 258.827L1781.5 258.816Z",
    fill: "black"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M1763.72 269.086L1781.5 258.816C1780.35 260.916 1779.05 262.819 1777.62 264.452L1777.37 264.752C1775.57 266.759 1773.56 268.413 1771.38 269.665L1753.91 279.748C1755.97 278.517 1757.86 276.935 1759.58 275.022L1759.84 274.722C1761.28 273.088 1762.57 271.185 1763.72 269.086Z",
    fill: "black"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M1762.16 264.649C1762.71 266.118 1763.23 267.596 1763.72 269.086C1762.57 271.185 1761.28 273.088 1759.84 274.722L1759.58 275.022C1757.87 276.935 1755.97 278.517 1753.91 279.748L1753.6 279.934C1746.02 284.319 1736.32 283.967 1725.76 277.855C1709.58 268.507 1695.43 248.02 1687.82 225.258C1689.03 223.014 1690.43 221.018 1691.97 219.301L1692.19 219.053C1693.93 217.14 1695.86 215.588 1697.96 214.378L1698.29 214.192C1700.5 212.962 1702.9 212.124 1705.43 211.721C1711.52 210.759 1718.42 212.227 1725.76 216.457C1740.9 225.196 1754.24 243.666 1762.15 264.649H1762.16ZM1742.83 257.007C1742.83 246.117 1735.2 232.89 1725.76 227.461C1716.34 222.021 1708.72 226.437 1708.72 237.306C1708.72 248.175 1716.34 261.402 1725.76 266.842C1735.2 272.281 1742.83 267.886 1742.83 257.007Z",
    fill: "black"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M1725.77 227.461C1735.2 232.9 1742.83 246.117 1742.83 257.007C1742.83 267.896 1735.2 272.281 1725.77 266.841C1716.34 261.402 1708.72 248.185 1708.72 237.306C1708.72 226.426 1716.34 222.011 1725.77 227.461ZM1732.37 250.957C1732.37 246.748 1729.41 241.639 1725.77 239.529C1722.12 237.42 1719.15 239.136 1719.15 243.345C1719.15 247.554 1722.12 252.673 1725.77 254.793C1729.41 256.893 1732.37 255.176 1732.37 250.957Z",
    fill: "black"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M1725.76 239.529C1729.4 241.639 1732.37 246.758 1732.37 250.957C1732.37 255.156 1729.4 256.893 1725.76 254.794C1722.11 252.684 1719.14 247.555 1719.14 243.346C1719.14 239.136 1722.11 237.42 1725.76 239.529Z",
    fill: "black"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M1698.29 214.181C1700.5 212.951 1702.9 212.113 1705.43 211.71C1711.52 210.748 1718.42 212.216 1725.76 216.446C1740.9 225.185 1754.24 243.655 1762.14 264.638C1762.7 266.107 1763.22 267.585 1763.71 269.075C1762.56 271.174 1761.27 273.077 1759.83 274.711L1759.57 275.011C1757.86 276.924 1755.96 278.506 1753.9 279.737",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M1753.6 279.933C1746.02 284.318 1736.32 283.967 1725.76 277.855C1709.58 268.506 1695.43 248.019 1687.82 225.257C1689.03 223.013 1690.43 221.017 1691.97 219.3L1692.19 219.052C1693.93 217.139 1695.86 215.588 1697.96 214.378",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M1742.83 257.006C1742.83 246.116 1735.2 232.889 1725.77 227.46C1716.34 222.02 1708.72 226.436 1708.72 237.305C1708.72 248.174 1716.34 261.401 1725.77 266.841C1735.2 272.281 1742.83 267.885 1742.83 257.006Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M1732.37 250.956C1732.37 246.747 1729.4 241.638 1725.76 239.529C1722.11 237.419 1719.14 239.136 1719.14 243.345C1719.14 247.554 1722.11 252.673 1725.76 254.793C1729.4 256.892 1732.37 255.175 1732.37 250.956Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M1697.96 214.378L1715.73 204.109C1718.05 202.775 1720.55 201.875 1723.22 201.451C1729.3 200.479 1736.21 201.958 1743.54 206.187C1758.68 214.926 1772.02 233.396 1779.94 254.379C1780.48 255.848 1781.01 257.327 1781.5 258.816C1780.35 260.915 1779.06 262.818 1777.62 264.452L1777.37 264.752C1775.57 266.758 1773.56 268.413 1771.38 269.664L1753.61 279.933",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M1763.72 269.085L1781.5 258.816",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M1880.95 147.396L1928.62 120.249V116.474L1935.36 120.363L1883.06 150.56C1882.36 149.454 1881.66 148.399 1880.96 147.396H1880.95Z",
    fill: "black"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M1868.03 154.759C1865.95 151.801 1863.93 149.412 1861.74 148.14L1874.49 140.777C1876.91 142.173 1878.96 144.541 1880.95 147.396C1881.65 148.399 1882.35 149.464 1883.05 150.56C1887.37 157.355 1891.96 165.587 1900.01 170.23L1891.02 171.698L1887.25 177.593C1879.59 172.66 1874.59 164.573 1870.23 157.965C1869.48 156.838 1868.76 155.762 1868.04 154.749L1868.03 154.759Z",
    fill: "#FBB93E"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M1842.36 151.687V169.392L1868.03 154.759C1865.94 151.801 1863.93 149.412 1861.74 148.14L1874.49 140.777C1876.91 142.173 1878.95 144.541 1880.95 147.396L1928.62 120.249V100.662L1842.37 151.687H1842.36Z",
    fill: "black"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M1775.2 133.238V115.481C1775.2 114.944 1775.48 114.488 1775.88 114.24L1776.01 114.158C1776.44 113.94 1776.96 113.93 1777.42 114.199L1779.81 115.585C1780.59 121.697 1780.49 126.381 1779.63 133.331L1842.36 169.403L1868.03 154.769C1868.75 155.783 1869.48 156.858 1870.22 157.985L1842.36 174.067L1777.38 137.013C1776.03 136.237 1775.19 134.799 1775.19 133.248L1775.2 133.238Z",
    fill: "black"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M1779.81 115.574C1779.87 116.081 1780.01 117.281 1780.02 117.394C1780.12 118.377 1780.19 119.339 1780.24 120.28C1780.24 120.352 1780.32 121.924 1780.32 121.924C1780.41 125.44 1780.17 128.925 1779.63 133.321L1842.36 169.392V151.687L1779.81 115.574Z",
    fill: "black"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M1842.36 151.687L1777.41 114.199C1776.94 113.93 1776.42 113.951 1776 114.158L1867.43 61.2188C1869.1 60.257 1871.15 60.2467 1872.81 61.1981L1935.34 96.6906L1842.35 151.698L1842.36 151.687Z",
    fill: "#459AA4"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M1775.87 114.23C1775.48 114.488 1775.19 114.933 1775.19 115.471V133.227C1775.19 134.789 1776.03 136.226 1777.38 136.992L1842.36 174.046L1870.22 157.965",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M1776.01 114.147L1867.44 61.2084C1869.11 60.2467 1871.16 60.2363 1872.82 61.1877L1935.35 96.6802L1842.36 151.687L1777.41 114.199C1776.94 113.93 1776.42 113.951 1776 114.158L1776.01 114.147Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M1776.02 114.147L1775.87 114.23",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M1883.05 150.571L1935.35 120.363L1928.61 116.474",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M1842.36 151.687V169.392L1779.63 133.321C1780.49 126.371 1780.6 121.686 1779.81 115.574",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M1842.36 169.392L1868.03 154.759",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M1880.95 147.396L1928.61 120.249V100.662",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M1861.74 148.14C1863.94 149.412 1865.95 151.801 1868.03 154.759C1868.75 155.772 1869.47 156.848 1870.22 157.975C1874.58 164.583 1879.59 172.67 1887.24 177.603",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M1887.25 177.593L1891.02 171.699L1900.01 170.23C1891.98 165.587 1887.37 157.355 1883.05 150.56C1882.35 149.454 1881.66 148.399 1880.95 147.396C1878.96 144.542 1876.91 142.173 1874.49 140.777",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.18 151.925L1888.62 132.617",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M1905.8 72.4911C1909.75 76.969 1911.17 84.2288 1907.65 86.2351L1856.59 115.481L1856.55 115.419C1857.32 114.581 1857.76 113.278 1857.76 111.603C1857.76 108.521 1856.25 104.974 1854.04 102.368L1905.81 72.4807L1905.8 72.4911Z",
    fill: "black"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M1905.8 72.491L1825.45 118.884C1824.51 117.767 1823.42 116.815 1822.28 116.164L1763.62 82.6671L1844.18 36.1608L1902.83 70.0297C1903.93 70.6605 1904.92 71.5085 1905.79 72.5013L1905.8 72.491Z",
    fill: "#FBB93E"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M1857.77 111.613C1857.77 113.288 1857.32 114.592 1856.56 115.429L1856.59 115.491L1851.01 118.687L1850.99 118.645C1851.76 117.808 1852.2 116.505 1852.2 114.829C1852.2 111.748 1850.69 108.2 1848.48 105.594L1854.04 102.378C1856.26 104.984 1857.77 108.531 1857.77 111.613Z",
    fill: "black"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M1852.2 114.819C1852.2 116.494 1851.76 117.787 1850.99 118.635L1851.01 118.677L1844.39 122.472V122.451C1845.15 121.614 1845.59 120.311 1845.59 118.635C1845.59 115.553 1844.08 112.006 1841.87 109.4L1848.48 105.584C1850.69 108.19 1852.2 111.737 1852.2 114.819Z",
    fill: "black"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M1845.59 118.635C1845.59 120.311 1845.15 121.614 1844.38 122.451V122.472L1838.82 125.668C1839.57 124.83 1840.03 123.527 1840.03 121.852C1840.03 118.77 1838.52 115.223 1836.3 112.617L1841.87 109.411C1844.08 112.017 1845.59 115.564 1845.59 118.646V118.635Z",
    fill: "black"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M1840.03 121.852C1840.03 123.527 1839.58 124.82 1838.82 125.668L1827.1 132.379C1827.85 131.955 1828.42 131.242 1828.76 130.27C1828.98 129.608 1829.12 128.843 1829.12 127.964C1829.12 124.934 1827.64 121.459 1825.47 118.884L1836.32 112.617C1838.53 115.223 1840.04 118.77 1840.04 121.852H1840.03Z",
    fill: "black"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M1828.93 129.587C1828.98 129.36 1829.02 129.122 1829.04 128.874C1829.04 128.832 1829.04 128.791 1829.05 128.75C1829.08 128.491 1829.1 128.222 1829.1 127.943C1829.1 124.913 1827.62 121.438 1825.45 118.863C1824.74 118.025 1823.96 117.281 1823.13 116.681C1822.85 116.484 1822.57 116.298 1822.29 116.133L1771.35 87.0418C1771.4 87.6106 1771.43 88.1794 1771.46 88.7585C1771.46 88.8619 1771.46 88.9757 1771.47 89.0791C1771.49 89.5548 1771.51 90.0202 1771.52 90.5063C1771.54 91.5094 1771.52 92.5332 1771.46 93.6088C1771.39 94.9015 1771.23 96.2459 1770.99 97.704L1828.75 130.239C1828.83 130.032 1828.89 129.804 1828.94 129.567L1828.93 129.587Z",
    fill: "black"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M1820.63 130.932L1763.62 98.1589L1771.46 93.6396C1771.39 94.9324 1771.24 96.2768 1770.99 97.7349L1828.76 130.27C1828.42 131.242 1827.85 131.955 1827.1 132.379C1825.87 133.083 1824.18 132.979 1822.29 131.893C1822.29 131.893 1820.83 131.045 1820.82 131.045C1820.66 130.942 1820.63 130.932 1820.64 130.942L1820.63 130.932Z",
    fill: "black"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M1821.51 131.438L1820.82 131.045C1820.82 131.045 1821.2 131.262 1821.51 131.438Z",
    fill: "black"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M1820.81 131.035L1820.63 130.932C1820.63 130.932 1820.65 130.932 1820.81 131.035Z",
    fill: "black"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M1838.82 125.657L1827.1 132.369",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M1827.1 132.369C1827.85 131.945 1828.41 131.231 1828.76 130.259C1828.98 129.597 1829.12 128.832 1829.12 127.953C1829.12 124.923 1827.64 121.448 1825.47 118.873C1824.53 117.756 1823.44 116.805 1822.3 116.153L1763.64 82.6566L1844.2 36.1503L1902.85 70.0192C1903.95 70.65 1904.94 71.498 1905.81 72.4908C1909.76 76.9584 1911.18 84.2286 1907.66 86.2348L1838.83 125.657",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1820.62,
    cy: 130.931,
    r: 1.55124,
    fill: "white"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M1820.63 130.931C1820.63 130.931 1820.65 130.931 1820.81 131.035",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M1820.81 131.035C1820.81 131.035 1821.18 131.252 1821.49 131.428",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M1820.63 130.931L1822.29 131.893C1824.17 132.979 1825.87 133.082 1827.1 132.379",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M1820.63 130.931H1820.62",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M1771.46 93.6292L1763.63 98.1588L1820.62 130.931",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M1771.35 87.0621C1771.52 89.1718 1771.61 91.3022 1771.46 93.6291C1771.38 94.9218 1771.23 96.2662 1770.99 97.7244L1828.75 130.259",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M1825.46 118.873L1905.8 72.491",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M1838.82 125.657C1839.57 124.82 1840.03 123.517 1840.03 121.841C1840.03 118.759 1838.52 115.212 1836.3 112.606",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M1844.38 122.451C1845.15 121.614 1845.59 120.311 1845.59 118.635C1845.59 115.553 1844.08 112.006 1841.87 109.4",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M1850.99 118.635C1851.75 117.798 1852.2 116.495 1852.2 114.819C1852.2 111.737 1850.69 108.19 1848.48 105.584",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M1856.55 115.429C1857.32 114.592 1857.76 113.289 1857.76 111.613C1857.76 108.531 1856.25 104.984 1854.04 102.378",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M1895.42 64.1458C1895.42 66.2038 1894.7 67.6516 1893.53 68.3341L1835.41 101.893C1835.91 101.582 1836.34 101.117 1836.64 100.517C1837.01 99.7934 1837.22 98.8626 1837.22 97.7561C1837.22 94.4157 1835.31 90.4963 1832.7 88.0246L1890.91 54.4143C1893.53 56.886 1895.42 60.8054 1895.42 64.1458Z",
    fill: "black"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M1890.9 54.4142L1832.69 88.0245C1832.07 87.4453 1831.41 86.9386 1830.73 86.5456L1784.64 59.9366L1842.85 26.3263L1888.94 52.9456C1889.63 53.3386 1890.28 53.835 1890.9 54.4245V54.4142Z",
    fill: "#FBB93E"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M1837.1 98.9868C1837.12 98.842 1837.15 98.7075 1837.16 98.5524C1837.19 98.3042 1837.21 98.0353 1837.21 97.7561C1837.21 94.4158 1835.3 90.4963 1832.69 88.0246C1832.07 87.4455 1831.41 86.9388 1830.73 86.5458L1791.64 63.9803C1791.72 64.4871 1791.79 65.0042 1791.84 65.5523C1791.84 65.5833 1791.84 65.6143 1791.84 65.6453C1791.89 66.1935 1791.92 66.7623 1791.93 67.331C1791.93 67.5275 1791.94 67.7344 1791.94 67.9309C1791.94 68.9754 1791.87 69.9268 1791.75 70.7541C1791.39 73.2154 1790.57 74.6012 1789.6 74.0428L1833.93 99.6279C1834.89 100.176 1835.79 100.466 1836.61 100.507C1836.79 100.145 1836.94 99.721 1837.04 99.266C1837.06 99.1729 1837.07 99.0695 1837.08 98.9764L1837.1 98.9868Z",
    fill: "black"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M1836.63 100.517C1836.33 101.117 1835.9 101.582 1835.39 101.893L1835.31 101.944C1834.14 102.627 1832.52 102.523 1830.74 101.489L1784.65 74.8699L1791.78 70.7539C1791.42 73.2152 1790.59 74.601 1789.63 74.0426L1833.96 99.6277C1834.92 100.176 1835.82 100.465 1836.64 100.507L1836.63 100.517Z",
    fill: "black"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M1835.31 101.945C1834.14 102.627 1832.52 102.524 1830.74 101.49L1784.65 74.8705L1791.78 70.7545",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M1893.53 68.3343C1894.69 67.6518 1895.42 66.2039 1895.42 64.146C1895.42 60.8056 1893.51 56.8861 1890.91 54.4145C1890.29 53.8353 1889.64 53.3286 1888.95 52.9356L1842.86 26.3163L1784.65 59.9266L1830.74 86.5356C1831.42 86.9286 1832.08 87.425 1832.7 88.0144C1835.31 90.4861 1837.22 94.4056 1837.22 97.7459C1837.22 98.8525 1837.01 99.7729 1836.64 100.507C1836.33 101.107 1835.91 101.572 1835.41 101.883",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M1836.63 100.518C1835.81 100.476 1834.9 100.187 1833.95 99.6386L1789.62 74.0534C1790.6 74.6119 1791.42 73.2158 1791.77 70.7648C1791.9 69.9271 1791.96 68.9757 1791.96 67.9415C1791.96 66.5661 1791.85 65.2217 1791.64 63.991",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M1835.31 101.945L1893.53 68.3342",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M1832.7 88.0247L1890.9 54.4144",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M1846.08 11.7451C1841.51 7.0397 1841.03 1.93094 1842.2 -2.58835C1844.08 -9.8792 1850.24 -15.6292 1850.24 -15.6292C1853.06 -9.7551 1854.32 -5.14273 1853.97 -1.09916C1853.56 3.59594 1850.96 7.51542 1846.08 11.7451Z",
    fill: "black"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M1842.2 -2.58849C1841.03 1.93081 1841.51 7.02923 1846.08 11.745C1850.96 7.51529 1853.56 3.59581 1853.97 -1.09929C1854.86 -0.954506 1855.78 -0.799379 1856.74 -0.644255C1874.61 2.30311 1877.71 19.1806 1876.73 35.1378C1875.75 51.0949 1856.24 60.6402 1849.7 60.4748C1843.15 60.3093 1837.89 62.9361 1823.47 47.5374C1809.06 32.1284 1816.59 13.4514 1825.6 4.59895C1831.46 -1.15099 1835.31 -2.88839 1842.19 -2.58849H1842.2Z",
    fill: "black"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M1842.2 -2.58849C1835.32 -2.88839 1831.46 -1.15099 1825.61 4.59895C1816.59 13.4514 1809.05 32.1284 1823.48 47.5374C1837.9 62.9464 1843.16 60.3196 1849.71 60.4748C1856.25 60.6402 1875.76 51.0949 1876.74 35.1378C1877.72 19.1806 1874.61 2.30311 1856.75 -0.644255C1855.79 -0.799379 1854.86 -0.954506 1853.98 -1.09929",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M1833.98 3.26501C1838.48 5.31266 1842.73 8.44617 1844.6 11.7451",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M1836.11 16.7401C1838.84 13.5859 1842.24 10.4731 1847.85 12.9654C1848.44 13.2239 1849.06 13.5549 1849.71 13.9479",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M1847.86 12.9654C1849.61 10.1938 1852.86 8.65295 1855.8 8.13586",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M1846.08 11.7451C1841.51 7.0397 1841.03 1.93094 1842.2 -2.58835C1844.08 -9.8792 1850.23 -15.6292 1850.23 -15.6292C1853.06 -9.7551 1854.32 -5.13239 1853.97 -1.09916C1853.55 3.59594 1850.96 7.51542 1846.08 11.7451Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M1846.08 11.7453L1848.44 -5.08051",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M2074.99 236.716L1959.99 303.12L1844.99 236.706L1959.99 170.313L2075 236.706H2074.98L2074.99 236.716ZM2010.69 230.356C2011.72 227.647 2011.58 225.744 2007.4 222.207C2006.29 220.408 2003.83 219.001 2000.73 218.36C1998.93 214.43 1992.15 211.948 1985.13 212.734C1983.25 210.242 1978.4 208.939 1973.81 209.777C1972.19 207.708 1968.52 206.581 1964.77 206.85C1962.07 204.327 1956.15 203.934 1952.44 205.867C1948.58 203.044 1941.01 203.447 1938.03 206.602C1934.78 206.405 1931.71 207.046 1929.43 208.205C1926.79 209.539 1926.71 211.897 1929.17 213.324L1995.78 251.774C2005.73 257.524 2010.85 249.561 2009.82 247.906C2021.32 238.092 2010.69 230.356 2010.69 230.356ZM1980.91 264.598C1983.8 265.197 1997.58 262.24 1987.62 256.5L1921.02 218.05C1918.55 216.623 1914.46 216.664 1912.14 218.195C1910.13 219.508 1909.05 221.287 1909.37 223.159C1903.92 224.886 1903.22 229.26 1908.11 231.484C1904.75 233.624 1905.43 237.047 1909.81 238.599C1909.36 240.76 1911.3 242.88 1914.88 243.811C1913.44 246.458 1915.7 249.261 1920.01 250.347C1918.63 254.39 1922.93 258.32 1929.74 259.344C1930.85 261.143 1933.3 262.56 1936.41 263.201C1942.53 265.621 1945.81 265.704 1950.52 265.104C1950.52 265.104 1963.91 271.237 1980.91 264.608V264.598Z",
    fill: "black"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M1987.62 256.5C1997.58 262.25 1983.8 265.197 1980.91 264.598C1963.91 271.227 1950.52 265.094 1950.52 265.094C1945.82 265.694 1942.53 265.611 1936.41 263.191C1933.3 262.55 1930.85 261.133 1929.74 259.334C1922.94 258.3 1918.63 254.38 1920.01 250.336C1915.7 249.251 1913.44 246.448 1914.88 243.801C1911.3 242.87 1909.36 240.75 1909.81 238.588C1905.43 237.027 1904.75 233.614 1908.11 231.473C1903.2 229.25 1903.92 224.875 1909.37 223.148C1909.05 221.276 1910.13 219.498 1912.14 218.184C1914.47 216.654 1918.55 216.612 1921.02 218.04L1987.62 256.49V256.5Z",
    fill: "#FBB93E"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M1959.99 327.981L1960.37 328.643L1959.99 328.86L1952.53 324.558C1953.27 323.297 1953.69 321.818 1953.69 320.246C1953.69 315.478 1949.84 311.611 1945.06 311.611C1941.86 311.611 1939.08 313.348 1937.59 315.923L1927.52 310.111C1928.25 308.839 1928.67 307.37 1928.67 305.799C1928.67 301.031 1924.81 297.163 1920.03 297.163C1916.84 297.163 1914.05 298.901 1912.56 301.486L1902.49 295.674C1903.23 294.402 1903.64 292.934 1903.64 291.351C1903.64 286.594 1899.78 282.716 1895.01 282.716C1891.82 282.716 1889.04 284.453 1887.54 287.039L1877.46 281.227C1878.2 279.955 1878.61 278.486 1878.61 276.904C1878.61 272.147 1874.76 268.279 1869.99 268.279C1866.79 268.279 1864.01 270.016 1862.51 272.592L1852.44 266.78C1853.17 265.508 1853.6 264.039 1853.6 262.457C1853.6 257.7 1849.74 253.832 1844.96 253.832V236.696L1959.96 303.11V327.971L1959.99 327.981Z",
    fill: "black"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M1928.68 305.799C1928.68 307.371 1928.25 308.839 1927.53 310.111C1926.03 312.686 1923.25 314.434 1920.05 314.434C1915.29 314.434 1911.43 310.566 1911.43 305.799C1911.43 304.237 1911.85 302.758 1912.57 301.486C1914.06 298.901 1916.84 297.163 1920.04 297.163C1924.81 297.163 1928.68 301.021 1928.68 305.799Z",
    fill: "black"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M1903.66 291.351C1903.66 292.923 1903.24 294.392 1902.51 295.674C1901.01 298.249 1898.23 299.987 1895.05 299.987C1890.28 299.987 1886.41 296.129 1886.41 291.351C1886.41 289.779 1886.83 288.311 1887.56 287.039C1889.06 284.464 1891.84 282.716 1895.04 282.716C1899.79 282.716 1903.66 286.584 1903.66 291.351Z",
    fill: "black"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M1878.63 276.915C1878.63 278.487 1878.21 279.955 1877.48 281.237C1875.99 283.813 1873.2 285.55 1870.02 285.55C1865.25 285.55 1861.38 281.692 1861.38 276.915C1861.38 275.343 1861.81 273.874 1862.53 272.602C1864.03 270.027 1866.81 268.29 1870.01 268.29C1874.76 268.29 1878.63 272.147 1878.63 276.915Z",
    fill: "black"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M1853.63 262.467C1853.63 264.039 1853.2 265.508 1852.47 266.79C1850.98 269.365 1848.2 271.102 1845 271.102C1840.24 271.102 1836.38 267.245 1836.38 262.467C1836.38 257.689 1840.23 253.842 1845 253.842C1849.77 253.842 1853.64 257.7 1853.64 262.467H1853.63Z",
    fill: "black"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M1912.14 218.195C1910.14 219.508 1909.05 221.287 1909.37 223.159C1903.92 224.886 1903.22 229.26 1908.11 231.484C1904.75 233.624 1905.43 237.047 1909.81 238.599C1909.36 240.76 1911.3 242.88 1914.88 243.811C1913.44 246.458 1915.7 249.261 1920.01 250.347C1918.64 254.39 1922.93 258.32 1929.74 259.344C1930.85 261.143 1933.3 262.56 1936.41 263.201C1942.54 265.621 1945.81 265.704 1950.52 265.104C1950.52 265.104 1963.91 271.237 1980.91 264.608C1983.8 265.208 1997.58 262.25 1987.63 256.51L1921.02 218.06C1918.55 216.633 1914.46 216.674 1912.14 218.205V218.195Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M1844.99 236.706L1959.99 170.313L2075.01 236.706L1959.99 303.12L1844.99 236.706Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M1844.99 236.706V253.842",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M1852.46 266.78L1862.53 272.602",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M1877.48 281.227L1887.56 287.049",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M1902.5 295.674L1912.57 301.486",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M1852.46 266.779C1853.19 265.507 1853.62 264.039 1853.62 262.457C1853.62 257.699 1849.76 253.832 1844.98 253.832C1840.2 253.832 1836.36 257.689 1836.36 262.457C1836.36 267.224 1840.21 271.092 1844.98 271.092C1848.18 271.092 1850.96 269.354 1852.45 266.779H1852.46Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M1877.48 281.227C1878.22 279.955 1878.63 278.486 1878.63 276.904C1878.63 272.147 1874.78 268.279 1870.01 268.279C1866.81 268.279 1864.02 270.006 1862.53 272.592C1861.8 273.853 1861.38 275.332 1861.38 276.904C1861.38 281.672 1865.24 285.539 1870.02 285.539C1873.2 285.539 1876 283.812 1877.48 281.227Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M1902.5 295.674C1903.24 294.402 1903.65 292.934 1903.65 291.351C1903.65 286.594 1899.79 282.716 1895.03 282.716C1891.83 282.716 1889.04 284.453 1887.55 287.039C1886.81 288.301 1886.4 289.779 1886.4 291.351C1886.4 296.119 1890.26 299.987 1895.04 299.987C1898.22 299.987 1901.01 298.259 1902.5 295.674Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M1927.53 310.111C1928.26 308.85 1928.68 307.371 1928.68 305.799C1928.68 301.031 1924.82 297.163 1920.04 297.163C1916.84 297.163 1914.06 298.901 1912.57 301.486C1911.84 302.758 1911.43 304.227 1911.43 305.799C1911.43 310.556 1915.28 314.434 1920.05 314.434C1923.25 314.434 1926.04 312.697 1927.53 310.111Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M1399.65 49.0359L1387.94 55.7994V42.2725L1399.65 49.0359Z",
    fill: "black"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M1387.94 42.2725V55.7994L1370.9 65.6446V52.1178L1387.94 42.2725Z",
    fill: "black"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M1370.9 52.1177V65.6446L1330.11 42.0967V28.5698L1370.9 52.1177Z",
    fill: "black"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M1330.11 28.5697V42.0966L1318.41 35.3331L1330.11 28.5697Z",
    fill: "black"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M1370.9 52.1176L1330.11 28.5697L1318.41 35.3331L1370.9 65.6444L1399.65 49.0358L1387.94 42.2724L1370.9 52.1176Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M1370.9 52.1177V65.6446",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M1387.94 42.2725V55.7994",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M1330.11 28.5698V42.0967",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_950_20574",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 886,
    y: 152,
    width: 100,
    height: 58
  }, _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M886.604 167.552L912.561 152.474L985.738 194.719L959.781 209.808L886.604 167.552Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_950_20574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M895.393 167.769L902.787 163.477L907.865 166.404C908.816 166.952 909.457 167.521 909.788 168.121C910.13 168.721 910.192 169.3 909.954 169.869C909.716 170.437 909.23 170.934 908.485 171.368C907.482 171.947 906.293 172.216 904.917 172.154C903.542 172.092 902.022 171.585 900.346 170.623L895.393 167.769ZM906.076 161.554L913.036 157.51L917.689 160.199C919.044 160.985 919.747 161.75 919.809 162.526C919.871 163.291 919.406 163.953 918.423 164.522C917.679 164.956 916.862 165.215 915.962 165.318C915.052 165.422 914.142 165.37 913.211 165.173C912.281 164.967 911.422 164.646 910.636 164.191L906.076 161.564M921.929 158.276L912.208 152.66L886.975 167.324L897.254 173.261C899.198 174.377 901.112 175.132 902.983 175.525C904.866 175.918 906.634 175.991 908.32 175.753C909.995 175.515 911.484 175.019 912.787 174.253C914.09 173.488 914.897 172.723 915.28 171.885C915.652 171.058 915.673 170.261 915.342 169.486C915.011 168.721 914.411 168.059 913.563 167.511L913.801 167.366C914.825 167.728 915.9 167.966 917.027 168.09C918.144 168.214 919.272 168.172 920.388 167.986C921.516 167.79 922.591 167.397 923.615 166.797C924.866 166.073 925.683 165.246 926.056 164.325C926.428 163.405 926.304 162.423 925.652 161.388C925.001 160.354 923.76 159.299 921.929 158.245",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.797 181.296L956.171 178.049L930.348 184.326L930.048 184.15L940.793 169.175L935.167 165.918L909.934 180.582L914.349 183.137L931.713 173.043L931.951 173.178L921.671 187.273L924.97 189.187L949.252 183.199L949.49 183.344L932.158 193.416L936.563 195.96L961.797 181.296Z",
    fill: "#459AA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.235 189.239C974.456 188.215 972.563 187.47 970.526 187.025C968.499 186.57 966.524 186.436 964.59 186.622C962.656 186.798 960.95 187.325 959.461 188.184C957.651 189.239 956.803 190.417 956.937 191.752C957.061 193.086 957.889 194.513 959.461 196.023L961.612 198.122C962.284 198.773 962.822 199.394 963.215 199.952C963.608 200.521 963.773 201.038 963.721 201.504C963.67 201.969 963.328 202.403 962.677 202.786C961.943 203.21 961.084 203.438 960.123 203.51C959.15 203.572 958.137 203.479 957.092 203.21C956.027 202.952 955.003 202.528 954 201.948C952.997 201.369 952.315 200.811 951.829 200.19C951.342 199.57 951.146 198.96 951.26 198.349C951.363 197.729 951.818 197.15 952.635 196.602L948.106 193.985C946.503 194.999 945.52 196.074 945.168 197.222C944.817 198.37 945.055 199.539 945.903 200.738C946.74 201.928 948.157 203.096 950.132 204.234C952.17 205.413 954.217 206.23 956.275 206.685C958.333 207.15 960.309 207.274 962.191 207.057C964.073 206.84 965.759 206.313 967.227 205.454C968.323 204.813 969.058 204.141 969.471 203.438C969.864 202.724 969.999 202 969.864 201.255C969.74 200.511 969.409 199.777 968.903 199.042C968.396 198.308 967.765 197.605 967.031 196.922L965.242 195.206C964.849 194.833 964.476 194.451 964.156 194.047C963.815 193.644 963.577 193.251 963.421 192.848C963.277 192.455 963.266 192.062 963.401 191.7C963.546 191.338 963.887 190.997 964.404 190.697C965.045 190.335 965.79 190.118 966.648 190.035C967.506 189.962 968.427 190.035 969.399 190.262C970.371 190.49 971.333 190.883 972.295 191.441C973.66 192.227 974.466 193.034 974.725 193.882C974.983 194.72 974.632 195.495 973.67 196.188L978.096 198.742C979.492 197.905 980.361 196.943 980.671 195.857C980.982 194.771 980.775 193.654 980.03 192.506C979.296 191.359 978.024 190.273 976.224 189.228",
    fill: "#459AA4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuture4Dark);
export default __webpack_public_path__ + "static/media/Future4Dark.9260ac7b06278975be94fa77d94c9e61.svg";
export { ForwardRef as ReactComponent };